export default {
  // Common
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    useAssistant: 'Utilisez l\'assistant IA pour commencer',
    confirm: 'Confirmer',
    close: 'Fermer',
    yes: 'Oui',
    no: 'Non',
    actions: 'Actions',
    status: 'Statut',
    date: 'Date',
    name: 'Nom',
    description: 'Description',
    type: 'Type',
    download: 'Télécharger',
    upload: 'Téléverser',
    copy: 'Copier',
    copied: 'Copié !',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Informations',
    all: 'Tout',
    allTypes: 'Tous les types',
    allStatuses: 'Tous les statuts',
    none: 'Aucun',
    active: 'Actif',
    inactive: 'Inactif',
    enabled: 'Activé',
    disabled: 'Désactivé',
    refresh: 'Actualiser',
    back: 'Retour',
    goBack: 'Retour au tableau de bord',
    next: 'Suivant',
    previous: 'Précédent',
    finish: 'Terminer',
    submit: 'Soumettre',
    confirmDeleteItem: 'Voulez-vous supprimer cet élément\u202F?',
    validateForReport: 'Valider pour rapport',
    reset: 'Réinitialiser',
    view: 'Voir',
    details: 'Détails',
    more: 'Plus',
    less: 'Moins',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    optional: 'Optionnel',
    unknown: 'Inconnu',
    notDetected: 'Non détecté',
    notDetectedFeminine: 'Non détectée',
    notAvailable: 'Non disponible',
    required: 'Requis',
    requiredFields: 'Champs obligatoires',
    note: 'Note :',
    and: 'et',
    andThe: 'et les',
    or: 'ou',
    sending: 'Envoi...',
    redirecting: 'Redirection...',
    copyright: '© 2026 SYLink. Tous droits réservés.',
    add: 'Ajouter',
    execute: 'Exécuter',
    launch: 'Lancer',
    pause: 'Pause',
    generating: 'Génération...',
    copiedToClipboard: 'Copié dans le presse-papiers',
    emailRequired: 'E-mail requis',
    regenerate: 'Régénérer',
    deselect: 'Désélectionner',
    severities: {
      critical: 'Critiques',
      high: 'Hautes',
      medium: 'Moyennes',
      low: 'Basses/Info',
    },
    recommendations: 'Recommandations',
    severity: 'Sévérité',
    service: 'Service',
    resource: 'Ressource',
    region: 'Région',
    retry: 'Réessayer',
    vulnerabilities: 'Vulnérabilités',
    pagination: {
      first: 'Première page',
      previous: 'Page précédente',
      next: 'Page suivante',
      last: 'Dernière page',
    },
    creating: 'Création...',
  },

  // APT Modules
  apt: {
    dangerousModule: 'Module dangereux - Utiliser avec précaution',
    addToChain: 'Ajouter à une chaîne',
    createChain: 'Créer une chaîne d\'attaque',
    createChainButton: 'Créer la chaîne',
    chainName: 'Nom de la chaîne',
    selectedModules: 'Modules sélectionnés',
    addModulesFromList: 'Ajoutez des modules depuis la liste à droite',
    availableModules: 'Modules disponibles',
    newChain: 'Nouvelle chaîne',
    executeModule: 'Exécuter {name}',
    loadError: 'Erreur lors du chargement des données APT',
    requiredParams: 'Paramètres requis',
    executions: 'Exécutions',
    successful: 'réussies',
    avgTime: 'Temps moyen',
    modulesApt: 'Modules APT',
    chains: 'Chaînes',
    evidence: 'Preuves',
    mitreMatrix: 'Matrice MITRE ATT&CK',
    category: 'Catégorie',
    criticality: 'Criticité',
    mitreTactic: 'Tactique MITRE',
    allCategories: 'Toutes',
    allCriticalities: 'Toutes',
    allTactics: 'Toutes',
    low: 'Faible',
    medium: 'Moyen',
    high: 'Élevé',
    critical: 'Critique',
    noModulesAvailable: 'Aucune campagne APT disponible pour le moment',
    noModulesFiltered: 'Aucun module ne correspond aux filtres sélectionnés',
    noChains: 'Aucune chaîne d\'attaque créée. Créez-en une pour commencer.',
    noEvidence: 'Aucune preuve collectée. Exécutez des modules pour collecter des preuves.',
    chainStatus: 'Statut',
    chainProgress: 'Progression',
    chainModules: 'Modules',
    chainCreatedAt: 'Créée le',
    executeChain: 'Exécuter {name}',
    moduleLaunched: 'Module {name} lancé',
    moduleLaunchError: 'Erreur lors du lancement du module',
    chainCreated: 'Chaîne créée avec succès',
    chainCreateError: 'Erreur lors de la création de la chaîne',
    chainLaunched: 'Chaîne lancée',
    chainLaunchError: 'Erreur lors du lancement de la chaîne',
    chainPaused: 'Chaîne mise en pause',
    chainCancelled: 'Chaîne annulée',
    dangerWarning: 'Ce module est marqué comme dangereux. Utilisez-le avec précaution.',
    modulesAvailable: 'modules disponibles',
    target: 'Cible',
    duration: 'Durée',
    result: 'Résultat',
    title: 'Titre',
    classification: 'Classification',
    size: 'Taille',
    validated: 'Validé',
    searchPlaceholder: 'Rechercher...',
    tool: 'Outil',
    module: 'Module',
    exitCode: 'Code de sortie',
    status: {
      pending: 'En attente',
      queued: 'En file',
      running: 'En cours',
      paused: 'En pause',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé',
      draft: 'Brouillon',
      ready: 'Prêt'
    },
    categories: {
      reconnaissance: 'Reconnaissance',
      resource_development: 'Développement de ressources',
      initial_access: 'Accès initial',
      execution: 'Exécution',
      persistence: 'Persistance',
      privilege_escalation: 'Élévation de privilèges',
      defense_evasion: 'Évasion de défenses',
      credential_access: 'Accès aux identifiants',
      discovery: 'Découverte',
      lateral_movement: 'Mouvement latéral',
      collection: 'Collecte',
      command_and_control: 'Commande et contrôle',
      exfiltration: 'Exfiltration',
      impact: 'Impact'
    },
    criticalities: {
      low: 'Faible',
      medium: 'Moyen',
      high: 'Élevé',
      critical: 'Critique'
    }
  },

  // Navigation
  nav: {
    dashboard: 'Accueil',
    scans: 'Scans',
    workspaces: 'Espaces de travail',
    vulnerabilities: 'Vulnérabilités',
    reports: 'Rapports',
    settings: 'Paramètres',
    account: 'Mon compte',
    logout: 'Déconnexion',
    help: 'Aide',
    admin: 'Administration',
    tools: 'Outils',
    compliance: 'Conformité',
    notifications: 'Notifications',
    credentials: 'Identifiants',
    ad: 'Active Directory',
    sessions: 'Sessions',
    agents: 'Agents'
  },

  // Auth
  auth: {
    login: 'Connexion',
    logout: 'Déconnexion',
    register: 'S\'inscrire',
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié\u202F?',
    magicLink: 'Lien magique',
    resetPassword: 'Réinitialiser le mot de passe',
    resetPasswordNeedsLink: 'Pour réinitialiser votre mot de passe, utilisez le lien envoyé par e-mail. Vous pouvez demander un nouveau lien depuis la page de connexion.',
    rememberMe: 'Se souvenir de moi',
    loginSuccess: 'Connexion réussie',
    loginError: 'Identifiants incorrects',
    logoutSuccess: 'Déconnexion réussie',
    sessionExpired: 'Session expirée',
    twoFactor: 'Authentification à deux facteurs',
    enterCode: 'Entrez le code',
    verifyCode: 'Vérifier le code',
    invalidCode: 'Code invalide',
    // Register page
    createAccount: 'Créer un compte',
    fillFormBelowEmail: 'Remplissez le formulaire ci-dessous pour créer votre compte entreprise.',
    companyName: 'Nom de l\'entreprise',
    companyPlaceholder: 'Votre entreprise',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Votre prénom',
    lastName: 'Nom',
    lastNamePlaceholder: 'Votre nom',
    professionalEmail: 'E-mail professionnel',
    professionalEmailPlaceholder: 'jean@entreprise.fr',
    professionalPhone: 'Téléphone professionnel',
    phonePlaceholder: '+33 6 12 34 56 78',
    phoneFormatHint: 'Le préfixe +33 est pré-rempli automatiquement. Format\u202F: +33 6 12 34 56 78',
    passwordEmailNote: 'Vous définirez votre mot de passe après validation de votre e-mail.',
    acceptTermsPrefix: 'J\'accepte les',
    createMyAccount: 'Créer mon compte',
    registering: 'Inscription...',
    alreadyHaveAccount: 'Déjà un compte\u202F?',
    loginButton: 'Se connecter',
    byRegistering: 'En créant un compte, vous acceptez nos conditions d\'utilisation et notre politique de confidentialité.',
    registrationSuccess: 'Inscription réussie !',
    demoAccountReady: 'Votre compte démo est prêt !',
    createDemoAccount: 'Créer votre compte démo',
    fillDemoInfo: 'Renseignez vos informations pour accéder à votre espace démo.',
    passwordMinLength: 'Minimum 8 caractères',
    passwordMinLengthError: 'Le mot de passe doit contenir au moins 8 caractères',
    registrationEmailSent: 'Un e-mail de confirmation a été envoyé à',
    clickLinkToSetPassword: 'Cliquez sur le lien pour définir votre mot de passe et activer votre compte.',
    checkSpam: 'Vérifiez vos spams si vous ne voyez pas l\'e-mail.',
    backToLogin: 'Retour à la connexion',
    // Login page
    welcomeBack: 'Bon retour !',
    enterCredentials: 'Entrez vos identifiants pour accéder à votre espace.',
    loggingIn: 'Connexion...',
    noAccount: 'Pas encore de compte\u202F?',
    createAccountLink: 'Créer un compte',
    // Email verification
    verifying: 'Vérification en cours...',
    verifyingDescription: 'Veuillez patienter pendant que nous vérifions votre adresse e-mail.',
    emailVerified: 'E-mail vérifié !',
    accountActive: 'Votre compte est maintenant actif.',
    welcome: 'Bienvenue sur SYLink !',
    choosePlan: 'Choisir mon plan',
    redirectingToPlan: 'Redirection vers les tarifs dans {seconds} secondes...',
    orLoginDirectly: 'Ou {loginLink} directement',
    verificationFailed: 'Échec de la vérification',
    needNewVerificationLink: 'Besoin d\'un nouveau lien de vérification\u202F?',
    yourEmail: 'Votre e-mail',
    emailSent: 'E-mail envoyé !',
    resendLink: 'Renvoyer le lien',
    invalidLink: 'Lien invalide',
    requestNewVerificationLink: 'Demander un nouveau lien de vérification',
    sendLink: 'Envoyer le lien',
    // Password reset / Forgot password modal
    resetPasswordTitle: 'Réinitialiser le mot de passe',
    resetPasswordDesc: 'Entrez votre e-mail pour recevoir un lien de réinitialisation.',
    sendResetLink: 'Envoyer le lien',
    forgotPasswordModalTitle: 'Mot de passe oublié\u202F?',
    emailSentTitle: 'E-mail envoyé',
    checkYourInbox: 'Vérifiez votre boîte mail',
    ifAccountExistsPrefix: 'Si un compte existe avec l\'adresse',
    ifAccountExistsSuffix: ', vous recevrez un lien pour réinitialiser votre mot de passe.',
    linkExpiresCheckSpam: 'Le lien expirera dans 24 heures. Pensez à vérifier vos spams.',
    enterEmailForResetLink: 'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    emailAddressLabel: 'Adresse e-mail',
    sendResetLinkFull: 'Envoyer le lien de réinitialisation',
    sendingInProgress: 'Envoi en cours...',
    connectionError: 'Erreur de connexion. Veuillez réessayer.',
    sending: 'Envoi...',
    resetLinkSent: 'Lien envoyé !',
    resetLinkSentDesc: 'Vérifiez votre boîte mail pour réinitialiser votre mot de passe.',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le mot de passe',
    setNewPassword: 'Définir le mot de passe',
    passwordUpdated: 'Mot de passe mis à jour !',
    passwordUpdatedDesc: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    // Reset password page
    passwordGenerator: 'Générateur de mot de passe',
    regenerate: 'Régénérer',
    classic: 'Classique',
    quantumResistant: 'Quantum-Résistant',
    quantumSecurityDescription: 'Sécurité maximale contre les attaques quantiques futures',
    passwordChanged: 'Mot de passe modifié !',
    passwordResetSuccess: 'Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la page de connexion.',
    chooseSecurePassword: 'Choisissez un mot de passe sécurisé pour votre compte',
    orEnterManually: 'ou entrez manuellement',
    newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    minChars: '8 caractères min',
    uppercase: '1 majuscule',
    lowercase: '1 minuscule',
    number: '1 chiffre',
    specialChar: '1 caractère spécial',
    passwordsMatch: 'Mots de passe identiques',
    resettingPassword: 'Réinitialisation...',
    charactersCount: '{count} caractères',
    // Login page additional
    loginSubtitle: 'Connectez-vous pour accéder à votre espace de sécurité.',
    emailNotVerified: 'E-mail non vérifié',
    emailNotVerifiedMessage: 'Veuillez vérifier votre boîte mail et cliquer sur le lien de confirmation.',
    verificationEmailSent: 'E-mail de vérification envoyé !',
    resendVerificationLink: 'Renvoyer l\'e-mail de vérification',
    accountBlocked: 'Compte bloqué',
    personalEmailBlockedMessage: 'Ce compte utilise une adresse e-mail personnelle qui n\'est plus acceptée.',
    securityPolicy: 'Politique de sécurité :',
    professionalEmailOnly: 'Seules les adresses e-mail professionnelles sont autorisées.',
    personalEmailsNotAccepted: 'Les e-mails personnels (Gmail, Hotmail, Yahoo, etc.) ne sont pas acceptés.',
    createNewAccountMessage: 'Pour continuer, créez un nouveau compte avec votre e-mail professionnel :',
    createAccountWithProfessionalEmail: 'Créer un compte avec e-mail professionnel',
    needHelp: 'Besoin d\'aide\u202F? Contactez-nous',
    emailOrUsername: 'Adresse e-mail',
    emailPlaceholder: 'votre-email@exemple.fr',
    passwordPlaceholder: 'Mot de passe',
    createFreeAccount: 'Créer un compte gratuit',
    // Magic link page
    magicLinkLoginFailed: 'La connexion a échoué. Veuillez réessayer.',
    magicLinkInvalid: 'Ce lien n\'est plus valide.',
    magicLinkNotFound: 'Ce lien n\'existe pas ou a déjà été utilisé.',
    magicLinkExpired: 'Ce lien a expiré. Veuillez en demander un nouveau.',
    unauthorized: 'Accès non autorisé',
    connectionError: 'Erreur de connexion. Vérifiez votre connexion internet et réessayez.',
    genericError: 'Une erreur est survenue. Veuillez réessayer.',
    verificationTimeout: 'La vérification a pris trop de temps. Veuillez réessayer.',
    retrying: 'Nouvelle tentative...',
    verifyingLink: 'Nous vérifions votre lien de connexion',
    loginSuccess: 'Connexion réussie !',
    redirectingToDashboard: 'Vous allez être redirigé vers votre tableau de bord...',
    autoRedirecting: 'Redirection automatique...',
    invalidLink: 'Lien invalide',
    requestNewMagicLink: 'Vous pouvez demander un nouveau lien magique depuis la page de connexion.',
    magicLinkFooter: 'Lien magique - Connexion sécurisée sans mot de passe'
  },

  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    welcome: 'Bienvenue, {name}',
    overview: 'Vue d\'ensemble',
    recentScans: 'Scans récents',
    recentActivity: 'Activité récente',
    statistics: 'Statistiques',
    quickActions: 'Actions Rapides',
    newScan: 'Nouveau scan',
    viewAllScans: 'Voir tous les scans',
    totalScans: 'Total des scans',
    activeScans: 'Scans en cours',
    completedScans: 'Scans terminés',
    failedScans: 'Scans échoués',
    vulnerabilitiesFound: 'Vulnérabilités trouvées',
    criticalVulns: 'Vulnérabilités critiques',
    highVulns: 'Vulnérabilités hautes',
    mediumVulns: 'Vulnérabilités moyennes',
    lowVulns: 'Vulnérabilités basses',
    systemHealth: 'Santé du système',
    toolsStatus: 'État des outils',
    cpuUsage: 'Utilisation CPU',
    memoryUsage: 'Utilisation mémoire',
    diskUsage: 'Utilisation disque',
    monitoring: 'Surveillance et analyse de sécurité en temps réel',
    critical: 'crit',
    serverPerformance: 'Performances serveur',
    realtimeMonitoring: 'Monitoring temps réel des ressources système',
    online: 'En ligne',
    uptime: 'Temps de fonctionnement',
    activeProcesses: 'Processus actifs',
    scansToday: 'Scans aujourd\'hui',
    networkLoad: 'Charge réseau',
    temperature: 'Température',
    started: 'Démarré',
    noActiveScans: 'Aucun scan actif. Démarrez un nouveau scan pour commencer.',
    noRecentActivity: 'Aucune activité récente.',
    startAssessment: 'Démarrer une évaluation de sécurité',
    exportResults: 'Exporter les résultats des scans',
    // Service status
    services: {
      backendApi: 'Serveur Backend',
      frontend: 'Interface',
      postgresql: 'PostgreSQL',
      aiModels: 'Modèles IA'
    },
    serviceStatus: {
      online: 'En ligne',
      offline: 'Hors ligne',
      checking: 'Vérification',
      degraded: 'Dégradé'
    },
    attackTools: {
      reconnaissance: 'Reconnaissance',
      exploitation: 'Exploitation',
      bruteForce: 'Brute Force',
      postExploitation: 'Post-Exploitation',
      privilegeEscalation: 'Élévation de privilèges'
    },
    targets: {
      webApps: 'Applications Web',
      servers: 'Serveurs',
      databases: 'Bases de données',
      network: 'Réseau',
      networkDevices: 'Routeurs, switches',
      target: 'Cible'
    },
    resources: {
      high: 'Élevé',
      medium: 'Moyen',
      normal: 'Normal',
      critical: 'Critique',
      optimal: 'Optimal',
      active: 'Actif',
      inUse: 'Utilisé',
      idle: 'En attente',
      notDetected: 'Non détecté',
      gpuNotAvailable: 'GPU non disponible',
      aiDisabled: 'IA désactivée',
      cores: 'cœurs',
      multiCore: 'Multi-cœurs',
      systemLoad: 'Charge système',
      used: 'utilisés',
      calculating: 'Calcul...',
      total: 'total',
      totalCores: 'Cœurs totaux',
      totalMemory: 'RAM totale',
      computePower: 'Puissance calcul',
      ramCapacity: 'Capacité mémoire',
      aiCapacity: 'Capacité IA',
      availableTotal: 'Disponible / Total',
      cpuCores: 'Cœurs CPU',
      ramInfra: 'RAM Infra.',
      gpuVram: 'VRAM GPU',
      aiReady: 'IA Prête',
      temperatureOk: 'OK',
      servers: 'serveurs',
      onlineCount: 'en ligne',
      offlineCount: 'hors ligne',
      gpuOnline: 'GPU en ligne',
      model: 'modèle'
    },
    infrastructureTotal: 'Infrastructure totale'
  },

  // Equipment
  equipment: {
    title: 'Gestion des équipements',
    subtitle: 'Détectez, catégorisez et attaquez les équipements du réseau',
    totalEquipment: 'Total Équipements',
    totalEquipmentDesc: 'Nombre total d\'équipements enregistrés dans la base de données. Inclut serveurs, postes de travail, équipements réseau, IoT, OT/ICS et autres dispositifs identifiés.',
    equipmentLabel: 'équipements',
    totalAttacks: 'Total Attaques',
    attacksLabel: 'attaques',
    successfulAttacks: 'Attaques réussies',
    successfulAttacksLabel: 'réussies',
    ongoingAttacks: 'Attaques en cours',
    ongoingAttacksLabel: 'en cours',
    typesTab: 'Types d\'équipements',
    detectedTab: 'Équipements détectés',
    attacksTab: 'Attaques',
    autoDetect: 'Auto-Détecter',
    refresh: 'Actualiser',
    searchPlaceholder: 'Rechercher…',
    category: 'Catégorie',
    allCategories: 'Toutes'
  },

  // Scans
  scans: {
    title: 'Scans',
    newScan: 'Nouveau scan',
    scanHistory: 'Historique des scans',
    target: 'Cible',
    targets: 'Cibles',
    scanType: 'Type de scan',
    startScan: 'Démarrer le scan',
    stopScan: 'Arrêter le scan',
    pauseScan: 'Mettre en pause',
    resumeScan: 'Reprendre',
    deleteScan: 'Supprimer le scan',
    scanDetails: 'Détails du scan',
    scanResults: 'Résultats du scan',
    progress: 'Progression',
    duration: 'Durée',
    startedAt: 'Démarré le',
    completedAt: 'Terminé le',
    status: {
      waiting: 'En file d\'attente',
      queued: 'En file d\'attente',
      pending: 'En attente',
      running: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé',
      paused: 'En pause',
      stopped: 'Arrêté',
      scheduled: 'Planifié'
    },
    filters: {
      all: 'Tous',
      failed: 'Échecs'
    },
    types: {
      quick: 'Scan rapide',
      full: 'Scan complet',
      stealth: 'Scan furtif',
      aggressive: 'Scan agressif',
      custom: 'Scan personnalisé',
      ai_scan: 'Scan IA',
      iot_scan: 'Scan IoT',
      ot_scan: 'Scan OT/ICS',
      cloud_scan: 'Scan Cloud',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      expert: 'Scan expert',
      api_pentest: 'Scan API',
      ad_pentest: 'Pentest Active Directory',
      ad_scan: 'Scan Active Directory',
      wifi_pentest: 'Pentest Wi-Fi',
      social_engineering: 'Ingénierie sociale',
      red_team: 'Red Team',
      phishing: 'Campagne de phishing'
    },
    phases: {
      discovery: 'Découverte',
      portScan: 'Scan de ports',
      serviceDetection: 'Détection de services',
      vulnScan: 'Scan de vulnérabilités',
      exploitation: 'Exploitation',
      reporting: 'Rapport'
    },
    stealthMode: {
      title: 'Mode Furtif',
      description: 'Techniques d\'évasion IDS/IPS',
      none: 'Aucun',
      noneDesc: 'Scan rapide, détectable',
      basic: 'Basique',
      basicDesc: 'Paquets fragmentés',
      advanced: 'Avancé',
      advancedDesc: 'Timing lent + spoofing',
      paranoid: 'Paranoïaque',
      paranoidDesc: 'Évasion max (très lent)',
      warning: 'Les modes furtifs utilisent des techniques d\'évasion pour éviter la détection IDS/IPS',
      basicTime: 'Le scan prendra environ 2x plus de temps',
      advancedTime: 'Le scan prendra environ 5x plus de temps',
      paranoidTime: 'Le scan prendra environ 10x plus de temps'
    },
    advancedDiscoveryOptions: 'Options de découverte avancées',
    hosts: 'Hôtes',
    ports: 'Ports',
    services: 'Services',
    openPorts: 'Ports ouverts',
    closedPorts: 'Ports fermés',
    filteredPorts: 'Ports filtrés',
    noResults: 'Aucun résultat trouvé',
    exportResults: 'Exporter les résultats',
    configureScan: 'Configurer les paramètres détaillés du scan',
    steps: {
      targetType: 'Cible & Type',
      networkMode: 'Mode Réseau',
      scanOptions: 'Options',
      advanced: 'Avancée',
      review: 'Vérification'
    },
    allScans: 'Total',
    activeScans: 'Scans actifs',
    withSuccess: 'Terminés avec succès',
    vulnerabilities: 'Vulnérabilités',
    discovered: 'Hôtes détectés',
    toReview: 'À vérifier',
    // Sort options
    sortByDate: 'Trier par date',
    sortByStatus: 'Trier par statut',
    sortByVulns: 'Trier par vuln.',
    // Stat card tooltips
    tooltips: {
      totalScans: 'Total des Scans',
      totalScansDesc: 'Nombre total de scans lancés sur la plateforme. Inclut tous les scans : en cours, terminés, et en échec.',
      runningScans: 'Scans en Cours',
      runningScansDesc: 'Scans actuellement en exécution. Ils analysent les cibles pour détecter les ports ouverts, services et vulnérabilités.',
      completedScans: 'Scans Terminés',
      completedScansDesc: 'Scans qui se sont terminés avec succès. Les résultats sont disponibles pour consultation et export dans les rapports.',
      vulnerabilities: 'Vulnérabilités Détectées',
      vulnerabilitiesDesc: 'Total des failles de sécurité identifiées. Les badges indiquent le nombre de vulnérabilités critiques et élevées nécessitant une attention immédiate.',
      hostsDiscovered: 'Hôtes Découverts',
      hostsDiscoveredDesc: 'Nombre de machines (serveurs, postes, équipements réseau) détectées lors des scans. Chaque hôte peut avoir plusieurs ports et services exposés.',
      failedScans: 'Scans Échoués',
      failedScansDesc: 'Scans échoués (cible inaccessible, timeout, problème réseau). Consultez les détails pour comprendre la cause et relancer si nécessaire.'
    },
    notFound: 'Scan non trouvé',
    notFoundDesc: 'Le scan demandé n\'existe pas ou a été supprimé',
    backToScans: 'Retour aux scans',
    scanFailed: 'Scan échoué',
    genericError: 'Une erreur s\'est produite pendant l\'exécution du scan. Cela peut être dû à des problèmes de connectivité réseau, des cibles inaccessibles ou des ressources insuffisantes.',
    technicalDetails: 'Détails techniques',
    retryScan: 'Relancer ce scan',
    // Console labels
    consoleLive: 'Console en direct',
    consoleCompleted: 'Console (Terminé)',
    consoleFailed: 'Console (Échec)',
    consoleTitle: 'Console',
    scanCompletedMessage: '✓ Terminé !',
    scanFailedMessage: '✗ Échec du scan',
    // Progress steps
    stepCompleted: 'Terminé',
    stepWaiting: 'En attente',
    stepInProgress: 'Scan en cours',
    // Timestamp labels
    timestampStarted: 'Démarré',
    timestampCompleted: 'Terminé',
    // Cleanup mode
    cleanup: 'Nettoyage',
    cleanupTitle: 'Nettoyage post-pentest',
    cleanupDescription: 'Cette action va supprimer toutes les traces laissées par le pentest, incluant\u202F:',
    cleanupSessions: 'Sessions d\'exploitation actives',
    cleanupPersistence: 'Mécanismes de persistence installés',
    cleanupFiles: 'Fichiers temporaires et preuves',
    cleanupLogs: 'Logs d\'exécution APT',
    cleanupPreview: 'Aperçu du nettoyage',
    sessionsCount: 'Sessions',
    withPersistence: 'Avec persistence',
    aptExecutions: 'Exécutions APT',
    evidenceFiles: 'Fichiers évidence',
    evidenceSize: 'Taille évidence',
    cleanNow: 'Nettoyer maintenant',
    archiveAndClean: 'Archiver puis nettoyer',
    cleaning: 'Nettoyage...',
    cleanupSuccess: 'Nettoyage terminé avec succès',
    cleanupPartial: 'Nettoyage partiel (certaines erreurs)',
    cleanupFailed: 'Échec du nettoyage',
    sessionsClosed: 'Sessions fermées',
    persistenceRemoved: 'Persistence supprimée',
    filesCleaned: 'Fichiers nettoyés',
    aptLogsCleaned: 'Logs APT nettoyés',
    evidenceArchived: 'Evidence archivée',
    cleanupWarning: '⚠️ Cette action est irréversible. Assurez-vous d\'avoir sauvegardé les données importantes.',
    // AI Quota
    aiQuotaExceeded: 'Quota de scans IA atteint',
    aiScansUsed: 'Scans IA utilises',
    upgradeOptions: 'Options pour continuer',
    callSylink: 'Appelez le service client SYLink\u202F:',
    upgradePlan: 'Passez à un abonnement supérieur pour des scans IA illimités',
    viewPlans: 'Voir les abonnements',
    // Scan types for NewScan wizard
    networkDiscovery: 'Découverte Réseau',
    networkDiscoveryDesc: 'Découverte rapide des hôtes et ports',
    vulnerabilityScan: 'Scan de Vulnérabilités',
    vulnerabilityScanDesc: 'Analyse approfondie des vulnérabilités',
    fullAutonomous: 'Autonome complet',
    fullAutonomousDesc: 'Évaluation de sécurité complète',
    // Placeholders
    placeholders: {
      target: '192.168.1.0/24 ou exemple.com',
      targetExamples: 'Exemples : 192.168.1.1, 192.168.1.0/24, exemple.com, 10.0.0.0/8',
      customPorts: 'Ex. : 80,443,8080-8090',
      excludeHosts: 'Ex. : 192.168.1.1,192.168.1.5'
    },
    searchPlaceholder: 'Rechercher par Cible ou Type...',
    // Table column headers
    table: {
      name: 'Nom',
      score: 'Score',
      target: 'Cible',
      client: 'Client',
      type: 'Type',
      status: 'Statut',
      vulnerabilities: 'Vuln.',
      date: 'Date',
      actions: 'Actions'
    },
    // Additional strings
    noCaptures: 'Aucune capture',
    noLogsAvailable: 'Aucun log disponible',
    waitingForLogs: 'En attente des logs...',
    discoveringHosts: 'Découverte des hôtes en cours...',
    noHostDiscovered: 'Aucun hôte découvert',
    analyzingVulns: 'Analyse des vulnérabilités en cours...',
    noVulnDetected: 'Aucune vulnérabilité détectée',
    noCriticalVulns: 'Aucune vulnérabilité critique détectée.',
    noAttackScenario: 'Aucun scénario d\'attaque critique identifié.',
    noWeakness: 'Aucune faiblesse critique détectée',
    noContent: 'Aucun contenu disponible',
    noData: 'Aucune donnée disponible',
    noVpnSession: 'Aucune session VPN n\'est actuellement active pour ce workspace.',
    loadingExecutiveReport: 'Chargement du rapport exécutif...',
    saveSchedule: 'Enregistrer la programmation',
    noActiveScan: 'Aucun scan en cours',
    noScanFound: 'Aucun scan trouvé',
    noScanResult: 'Aucun résultat pour "{query}"',
    noScanStatus: 'Aucun scan avec le statut "{status}"',
    noVulnerabilities: 'Aucune vulnérabilité',
    loadingError: 'Erreur de chargement',
    deleteFailedScans: 'Supprimer les échoués',
    deleteFailedScansTitle: 'Supprimer tous les scans échoués',
    confirmDeleteFailed: 'Supprimer les {count} scan(s) échoué(s) ?',
    deleteScansError: 'Erreur lors de la suppression des scans',
    associateScansError: 'Erreur lors de l\'association des scans',
    removeScansError: 'Erreur lors du retrait du scan',
    restartScansError: 'Erreur lors du relancement des scans',
    restartError: 'Erreur lors du relancement',
    loadScansError: 'Erreur lors du chargement des scans',
    networkError: 'Erreur réseau. Vérifiez votre connexion et réessayez.',
    validateScansError: 'Erreur lors de la validation des scans',
    imageLoadError: 'Erreur de chargement de l\'image',
    noWorkspaceForScan: 'Aucun workspace associé à ce scan. Veuillez sélectionner un client depuis la page Clients, puis relancer le scan.',
    pdfGenerationError: 'Erreur génération PDF',
    scheduleSaved: 'Enregistrer la programmation',
    scheduleError: 'Erreur lors de la création de la programmation',
    generatePdfError: 'Erreur lors de la génération du PDF',
    errors: {
      createFailed: 'Échec de la création du scan',
      serverError: 'Erreur serveur lors du scan',
      workspaceRequired: 'Workspace requis pour lancer un scan'
    },
    screenshotLoadError: 'Erreur de chargement de la capture',
    details: {
      queuedTitle: 'Scan en file d\'attente',
      queuedDesc: 'Votre scan est en attente de traitement...',
      queuePosition: 'Position dans la file',
      estimatedWait: 'Attente estimée (minutes)',
      runningScans: 'Scans en cours',
      statusQueued: 'En attente',
      currentStep: 'Étape en cours',
      statusStarting: 'Démarrage',
      soon: 'Bientôt',
      cvssRangeCritical: 'CVSS 9.0-10.0',
      cvssRangeHigh: 'CVSS 7.0-8.9',
      cvssRangeMedium: 'CVSS 4.0-6.9',
      cvssRangeLow: 'CVSS 0.1-3.9',
      riskCritical: 'Action immédiate requise. Risque de compromission élevé.',
      riskHigh: 'Prudence recommandée. Vulnérabilités exploitables détectées.',
      riskMedium: 'Risque maîtrisé. Continuer la surveillance.',
      exitIp: 'IP de sortie',
      location: 'Localisation',
      protocol: 'Protocole',
      upload: 'Upload',
      download: 'Download',
      vulnerabilities: 'Vulnérabilités',
      exposure: 'Exposition',
      configuration: 'Configuration',
      hackProbability: 'Probabilité de hack',
      advancedAnalysis: 'Analyse de sécurité avancée',
      advancedAnalysisDesc: 'CyberScore détaillé basé sur tous les outils',
      severityBreakdown: 'Répartition par sévérité',
      mostImpacted: 'Services les plus impactés',
      aiToolsTitle: 'Outils IA & Threat Intel',
      aiToolsDesc: 'Génération de commandes · Shodan · VirusTotal',
      toolResults: 'Résultats des outils',
      toolResultsDesc: 'Sorties détaillées de chaque outil de scan',
      aiReport: 'Rapport exécutif IA',
      aiAnalyzing: 'L\'IA analyse votre cible...',
      aiIntelAnalysis: 'Analyse Intelligence IA',
      aiRiskAnalysis: 'Analyse de risque IA',
      hosts: 'Hôtes',
      weakPoints: 'Points faibles identifiés',
      analyzingIdentities: 'Analyse des identités et accès en cours...',
      businessImpactPending: 'L\'impact business sera calculé...',
      fixCritical: 'Corriger les vulnérabilités critiques',
      fixHigh: 'Corriger les vulnérabilités hautes',
      continuousImprovements: 'Améliorations continues',
      positivePointsPending: 'Les points positifs seront identifiés...',
      validating: 'Validation en cours...',
      captureConsole: 'Capturer la console',
      aiRecommendations: 'Recommandations IA',
      correctDetection: 'Détection correcte',
      falsePositive: 'Faux positif / Feedback',
      includeInReport: 'Inclure dans le rapport',
      excludeFromReport: 'Exclure du rapport',
      sortBySeverity: 'Trier par sévérité',
      sortByDate: 'Trier par date',
      mostSevereFirst: 'Plus sévère en premier',
      mostRecentFirst: 'Plus récent en premier',
      loadingVulns: 'Chargement des détails de vulnérabilité...',
      check: 'Vérification',
    },
    list: {
      cyberScoreLegend: 'Légende CyberScore',
      scoreExcellent: 'Excellent',
      scoreGood: 'Bon',
      scoreMedium: 'Moyen',
      scoreLow: 'Faible',
      scoreCritical: 'Critique',
      unassigned: 'Non assigné',
    },
    regenerateReports: 'Régénérer les rapports PDF et Word',
    activeScanRealtime: 'Scan actif - Résultats en temps réel',
  },

  // Workspaces
  workspaces: {
    title: 'Espaces clients',
    subtitle: 'Gérez vos espaces clients et leurs configurations',
    newWorkspace: 'Nouvel espace',
    editWorkspace: 'Modifier l\'espace',
    deleteWorkspace: 'Supprimer l\'espace',
    deleteWorkspaceError: 'Erreur lors de la suppression de l\'espace',
    deleteWorkspaceSuccess: 'Espace supprimé avec succès',
    invalidIdentifier: 'Veuillez entrer un identifiant valide',
    workspaceDetails: 'Détails de l\'espace',
    workspaceName: 'Nom de l\'espace',
    clientName: 'Nom du client',
    clientInfo: 'Informations client',
    companyName: 'Nom de l\'entreprise',
    searchCompany: 'Rechercher une entreprise',
    postalCode: 'Code postal',
    nafCode: 'Code NAF',
    capital: 'Capital',
    employees: 'Effectif',
    companyLogo: 'Logo de l\'entreprise',
    noLogo: 'Aucun logo',
    vpnConfiguration: 'Configuration VPN',
    contractStatus: 'Statut du contrat',
    sendContract: 'Envoyer le contrat',
    readyForTests: 'Prêt pour les tests',
    upload: 'Téléverser',
    members: 'Membres',
    addMember: 'Ajouter un membre',
    removeMember: 'Retirer le membre',
    scansCount: 'Nombre de scans',
    lastActivity: 'Dernière activité',
    created: 'Créé le',
    shareWorkspace: 'Partager l\'espace',
    archiveWorkspace: 'Archiver l\'espace',
    noWorkspaces: 'Aucun espace client',
    // Form labels
    siret: 'SIRET',
    siretPlaceholder: 'Ex : 123 456 789 00001',
    siren: 'SIREN',
    sirenPlaceholder: 'Ex : 123 456 789',
    country: 'Pays',
    // Additional workspace keys
    scans: 'Scans',
    hosts: 'Hôtes',
    vulnerabilities: 'Vulnérabilités',
    attackPaths: 'Chemins d\'attaque',
    successfulScans: 'Scans réussis',
    company: 'Entreprise',
    legalForm: 'Forme juridique',
    address: 'Adresse',
    city: 'Ville',
    website: 'Site web',
    shareDescription: 'Partagez cet espace avec vos clients ou collaborateurs',
    manageShares: 'Gérer les partages',
    mainContact: 'Contact principal',
    contact: 'Contact',
    signed: 'Signé',
    pending: 'En attente',
    draft: 'Brouillon',
    contractSigned: 'Contrat signé',
    contractNotSigned: 'Contrat non signé',
    pendingContract: 'Contrat en attente',
    noContract: 'Aucun contrat',
    noScans: 'Aucun scan associé',
    noScansHint: 'Associez un scan existant ou lancez-en un nouveau depuis la page Scans',
    noHosts: 'Aucun hôte',
    noVulnerabilities: 'Aucune vulnérabilité',
    noAttackPaths: 'Aucun chemin d\'attaque',
    // Network stats
    vulnerable: 'Vulnérables',
    subnets: 'Sous-réseaux',
    services: 'Services',
    // Contact form labels
    contactFullName: 'Nom complet',
    contactFunction: 'Fonction',
    contactEmail: 'E-mail',
    contactPhone: 'Téléphone',
    contactResponsibleDescription: 'Personne responsable du projet pentest',
    logoUsedInReports: 'Utilisé dans les rapports de pentest',
    noAttackTree: 'Aucun arbre d\'attaque',
    noVPN: 'Aucun VPN configuré',
    // AI Analysis
    aiAnalysis: 'Analyse IA',
    generateSummary: 'Générer le résumé',
    launchAiAnalysis: 'Lancer l\'analyse IA',
    analysisInProgress: 'Analyse en cours...',
    completeAnalysis: 'Analyse complète & Solutions',
    aggregatedData: 'Données agrégées',
    riskAnalysis: 'Analyse des risques',
    clickToGenerateSummary: 'Cliquez sur "Générer le résumé" pour obtenir une analyse IA de l\'espace de travail',
    analyzingInProgress: 'Analyse en cours...',
    generatingAiSummary: 'Génération du résumé IA',
    noScansToAssociate: 'Aucun scan disponible à associer',
    associateScan: 'Associer un scan',
    networkMap: 'Carte Réseau',
    noAnalysisAvailable: 'Aucune analyse disponible',
    clickToLaunchAnalysis: 'Cliquez sur le bouton ci-dessus pour lancer l\'analyse IA',
    launchScanToDiscoverNetwork: 'Lancez un scan pour découvrir le réseau',
    critical: 'Critiques',
    high: 'Hautes',
    download: 'Télécharger',
    deleteStoredCredentials: 'Supprimer les identifiants enregistrés',
    useStoredCredentials: 'utiliser identifiants enregistrés',
    enterVpnUsername: 'Entrez votre identifiant VPN',
    enterVpnPassword: 'Entrez votre mot de passe VPN',
    // VPN Modal
    actionPlan: 'Plan d\'action & Solutions',
    noDocuments: 'Aucun document généré pour cet espace de travail',
    reportsWillAppear: 'Les rapports apparaîtront ici après génération',
    vpnCredentials: 'Identifiants VPN',
    requiresAuthentication: 'nécessite une authentification',
    storedCredentials: 'Identifiants enregistrés',
    clickToUseCredentials: 'Cliquez sur "Se connecter" pour utiliser ces identifiants',
    connect: 'Se connecter',
    cancel: 'Annuler',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    saveCredentials: 'Enregistrer ces identifiants',
    saveCredentialsSecurely: 'Enregistrer les identifiants de façon sécurisée',
    credentialsStorageInfo: 'Les identifiants seront chiffrés (AES-256) et stockés en base de données. Ils seront automatiquement utilisés lors des prochaines connexions VPN.',
    saving: 'Enregistrement...',
    connecting: 'Connexion...',
    server: 'Serveur',
    protocol: 'Protocole',
    noVulnsToFix: 'Aucune vulnérabilité à corriger',
    connectionInProgress: 'Connexion en cours...',
    connectionFailed: 'Connexion échouée',
    generateActionPlan: 'Générer le plan d\'action',
    clickToGenerateActionPlan: 'Cliquez sur "Générer le plan d\'action" pour obtenir les recommandations',
    vpnConnected: 'VPN connecté\u202F! IP\u202F:',
    // Workspace Switcher
    select: 'Sélectionnez un espace de travail',
    selectTitle: 'Sélection de l\'espace de travail',
    selectDescription: 'Choisissez un espace de travail pour continuer',
    searchPlaceholder: 'Rechercher un espace de travail...',
    noWorkspacesYet: 'Aucun espace de travail créé',
    noResults: 'Aucun espace de travail trouvé',
    createFirst: 'Créer votre premier espace de travail',
    createNew: 'Créer un espace de travail',
    manageAll: 'Gérer les espaces de travail',
    continue: 'Continuer',
    switchError: 'Erreur lors du changement d\'espace de travail',
    switchSuccess: 'Espace de travail changé avec succès',
    // Schedules
    scanSchedules: 'Planifications de scan',
    addSchedule: 'Ajouter une planification',
    noSchedules: 'Aucune planification configurée',
    noSchedulesHint: 'Cliquez sur "Ajouter une planification" pour automatiser vos scans',
    createSchedule: 'Créer une planification',
    scheduleName: 'Nom de la planification',
    scheduleNamePlaceholder: 'Ex: Scan hebdomadaire de sécurité',
    targets: 'Cibles',
    targetsPlaceholder: '192.168.1.0/24, exemple.com',
    targetsCommaSeparated: 'Cibles * (séparées par des virgules)',
    scanType: 'Type de scan',
    frequency: 'Fréquence',
    timeOfDay: 'Heure d\'exécution',
    daysOfWeek: 'Jours de la semaine',
    autoGenerateReport: 'Générer le rapport automatiquement',
    sendNotifications: 'Envoyer des notifications',
    notificationRecipients: 'Destinataires des notifications (e-mails, séparés par des virgules)',
    cancel: 'Annuler',
    creating: 'Création...',
    // Scan types
    scanTypeQuick: 'Rapide',
    scanTypeFull: 'Complet',
    scanTypeVulnerability: 'Vulnérabilités',
    scanTypePortScan: 'Scan de ports',
    scanTypeWebScan: 'Scan Web',
    // Frequencies
    frequencyDaily: 'Quotidien',
    frequencyWeekly: 'Hebdomadaire',
    frequencyBiweekly: 'Bimensuel',
    frequencyMonthly: 'Mensuel',
    frequencyQuarterly: 'Trimestriel',
    // Days
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mer',
    dayThu: 'Jeu',
    dayFri: 'Ven',
    daySat: 'Sam',
    daySun: 'Dim',
    // Stats labels
    schedulesCount: 'Planifications',
    successfulRuns: 'Exécutions réussies',
    runNow: 'Exécuter maintenant',
    nextRun: 'Prochain',
    // Remediation Tracker
    remediationTitle: 'Suivi de Remédiation',
    remediationProgress: 'Progression globale',
    remediationVulnsFixed: 'vulnérabilités remédiées',
    remediationNoVulns: 'Aucune vulnérabilité trouvée',
    remediationRescanTitle: 'Lancer un re-scan de vérification',
    remediationAllStatuses: 'Tous les statuts',
    remediationAllSeverities: 'Toutes sévérités',
    remediationResults: 'résultats',
    remediationSeverity: 'Sévérité',
    remediationVulnerability: 'Vulnérabilité',
    remediationHost: 'Hôte',
    remediationStatus: 'Statut',
    remediationUpdated: 'Mis à jour',
    remediationActions: 'Actions',
    remediationPrevious: '← Précédent',
    remediationNext: 'Suivant →',
    remediationCritical: 'Critique / Haute — non traitées',
    remediationSeverityBreakdown: 'Répartition par sévérité',
    remediationStatusUpdate: 'Statut mis à jour',
    remediationStatusError: 'Erreur lors de la mise à jour',
    remediationLoadDashboardError: 'Erreur chargement dashboard',
    remediationLoadVulnsError: 'Erreur chargement vulnérabilités',
    remediationRefresh: 'Actualiser',
    remediationCertificate: 'Certificat de clôture',
    remediationSearch: 'Rechercher...',
    // Status labels
    statusOpen: 'Ouverte',
    statusInProgress: 'En cours',
    statusFixed: 'Corrigée (à vérifier)',
    statusVerified: 'Vérifiée ✓',
    statusAcceptedRisk: 'Risque accepté',
    statusWontFix: 'Ne sera pas corrigée',
    // Severity labels
    severityCritical: 'Critique',
    severityHigh: 'Haute',
    severityMedium: 'Moyenne',
    severityLow: 'Basse',
    severityInfo: 'Info',
    // KPI labels
    kpiOpen: 'Ouvertes',
    kpiInProgress: 'En cours',
    kpiToVerify: 'À vérifier',
    kpiVerified: 'Vérifiées',
    kpiAcceptedRisk: 'Risque accepté',
    kpiTotal: 'Total',
    // VPN
    saveUid: 'Enregistrer l\'UID',
    noVpnCredentials: 'Aucun identifiant VPN enregistré - connectez-vous pour en sauvegarder',
    noVpnRoutes: 'Aucune route personnalisée configurée',
    add: 'Ajouter',
    noScanReports: 'Aucun rapport de scan disponible',
    errorAnalysis: 'Erreur d\'analyse',
    noBusinessAnalysis: 'Aucune analyse métier disponible',
    remediationTracker: 'Suivi de remédiation',
    downloadAsPdf: 'Télécharger en PDF',
    downloadAsWord: 'Télécharger en Word',
    downloadGeoipReport: 'Télécharger le rapport GeoIP',
    geoipComplianceReport: 'Rapport GeoIP & Conformité',
    riskCartographyReport: 'Rapport Cartographie des Risques',
    ipGeolocation: 'Géolocalisation IP',
    countryRisks: 'Risques pays',
    hackerGroups: 'Groupes de hackers',
    min2ScansRequired: 'Minimum 2 scans terminés requis',
    launchRegularScans: 'Lancez des scans réguliers pour suivre l\'évolution des risques',
    firstScan: 'Premier scan :',
    lastScan: 'Dernier scan :',
    generatedOn: 'Généré le',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    accessible: 'Accessible',
    notAccessible: 'Non accessible',
    online: 'En ligne',
    offline: 'Hors ligne',
    notConnected: 'Non connecté',
    markAsFalsePositive: 'Marquer comme faux positif',
    removeFalsePositive: 'Retirer le faux positif',
    downloadAsWordTooltip: 'Télécharger en Word',
    improvement: 'Amélioration',
    degradation: 'Dégradation',
    stable: 'Stable',
    aiGeneratedReports: 'Rapports générés par IA',
    since: 'Depuis le',
    noVpnConfig: 'Aucune configuration VPN',
    deleteReport: 'Supprimer le rapport',
    vpnRouteCount: '{{count}} route(s)',
    noRoutes: 'Aucune route',
    // WorkspaceManager
    deleteVpnLogo: 'Supprimer le logo',
    modifyWorkspace: 'Modifier le workspace',
    modifyWorkspaceDesc: 'Modifier les informations du client "{{name}}"',
    modifyVpnDesc: 'Modifier le VPN associé pour les scans de ce client',
    noVpnRequired: 'Aucune configuration VPN requise',
    noVpnAvailable: 'Aucune configuration VPN disponible',
    createWorkspaceBtn: 'Créer le workspace',
    vpnUploadError: 'Erreur lors de l\'upload du VPN',
    companyNotFound: 'Aucune entreprise trouvée pour "{{term}}"',
    noCompanyFound: 'Aucune entreprise trouvée',
    companySearchError: 'Erreur lors de la recherche',
    scheduleError: 'Erreur lors de la planification du scan',
    noCompletedScans: 'Aucun scan terminé',
    allWorkspaces: 'Tous les workspaces',
    contractCreateError: 'Erreur lors de la création du contrat',
    // Business context details
    details: {
      analyzed: 'Analysé',
      analyzing: 'Analyse en cours...',
      analyzeWithAI: 'Analyser avec IA',
      aiAnalysisInProgress: 'Analyse IA en cours...',
      business: 'Métier',
      estimatedSize: 'Taille estimée : ',
      cyberImpacts: 'Impacts cyber',
      dataSensitivity: 'Sensibilité des données :',
      keyServices: 'Services clés',
      pentestFocus: 'Focus pentest adapté au métier',
      cyberattackImpact: 'Impact cyberattaque',
      gdprFine: 'Amende RGPD max. estimée',
      category: 'Catégorie',
      reanalyze: 'Ré-analyser',
      enterUrlHint: 'Entrez l\'URL du site web et cliquez sur "Analyser avec IA"',
      destinationCidr: 'Destination (CIDR)',
      gateway: 'Passerelle (Gateway)',
      active: 'Actif',
    },
    infoLoaded: 'Informations {source} chargées',
    tabCompany: 'Entreprise',
    tabContact: 'Contact',
    tabLogo: 'Logo',
    tabVpn: 'VPN',
    tabContract: 'Contrat',
    newClientWorkspace: 'Nouveau client / espace',
    newClientDesc: 'Ajoutez un nouveau client avec recherche dans le registre des entreprises',
    authRequired: 'Authentification requise',
    vpnCredentialsRequired: 'Identifiants VPN requis',
    usernameLabel: 'Nom d\'utilisateur',
    passwordLabel: 'Mot de passe',
    addOvpnFiles: 'Ajoutez des fichiers .ovpn dans les paramètres',
    selectScanOrName: 'Veuillez sélectionner un scan ou saisir un nom',
    selectWorkspaceFirst: 'Veuillez sélectionner un espace',
    scanScheduledOk: 'Scan planifié avec succès',
    routeAdded: 'Route ajoutée avec succès',
    routeDeleted: 'Route supprimée',
    fillDestGateway: 'Veuillez renseigner la destination et la passerelle',
    topVulnerabilities: 'Top vulnérabilités',
    workflowView: 'Vue Workflow',
    listView: 'Vue Liste',
    generatingAttackTree: 'Génération de l\'arbre d\'attaque…',
    fileSelected: 'Fichier {name} "{filename}" sélectionné',
    vpnUploadSuccess: 'Configuration {name} téléversée avec succès',
  },

  // Workspace (alias for workspace switcher)
  workspace: {
    select: 'Sélectionnez un espace de travail',
    selectTitle: 'Sélection de l\'espace de travail',
    selectDescription: 'Choisissez un espace de travail pour continuer',
    searchPlaceholder: 'Rechercher un espace de travail...',
    noWorkspaces: 'Aucun espace de travail disponible',
    noWorkspacesYet: 'Aucun espace de travail créé',
    noResults: 'Aucun espace de travail trouvé',
    createFirst: 'Créer votre premier espace de travail',
    createNew: 'Créer un espace de travail',
    manageAll: 'Gérer les espaces de travail',
    continue: 'Continuer',
    switchError: 'Erreur lors du changement d\'espace de travail',
    switchSuccess: 'Espace de travail changé avec succès',
    scan: 'scan',
    scans: 'scans',
    createRequired: 'Espace de travail requis',
    createRequiredDescription: 'Vous devez créer un espace de travail pour accéder à cette section.',
    selectRequired: 'Sélection requise',
    selectRequiredDescription: 'Veuillez sélectionner un espace de travail pour accéder à cette section. Vous avez',
    workspaceAvailable: 'espace de travail disponible.',
    workspacesAvailable: 'espaces de travail disponibles.',
    selectWorkspace: 'Sélectionnez un espace de travail'
  },

  // Vulnerabilities
  vulnerabilities: {
    title: 'Vulnérabilités',
    subtitle: 'Analyse et gestion des vulnérabilités détectées',
    aiExploitRecommendations: 'Recommandations d\'exploits IA',
    aiExploitGenerator: 'Générateur d\'exploits IA',
    exploitsAvailable: 'Exploits disponibles',
    searchingMetasploitDb: 'Recherche dans les bases Metasploit, Exploit-DB...',
    clickViewToSearchExploits: 'Cliquez sur "Voir" pour rechercher les exploits disponibles',
    thenLaunchToTest: 'Puis "Lancer" pour tester sur la cible',
    searchInMetasploitEtc: 'Recherche dans Metasploit, Exploit-DB, NVD, PacketStorm',
    executedLabel: 'Exécuté',
    aiAssistant: 'Assistant IA',
    aiAssistantDesc: 'Analysez et exploitez les vulnérabilités de manière autonome',
    vulnerability: 'Vulnérabilité',
    severity: 'Sévérité',
    severities: {
      critical: 'Critique',
      high: 'Haute',
      medium: 'Moyenne',
      low: 'Basse',
      info: 'Informatif'
    },
    cve: 'CVE',
    cvss: 'Score CVSS',
    affected: 'Affecté',
    solution: 'Solution',
    references: 'Références',
    evidence: 'Preuves',
    exploitable: 'Exploitable',
    verified: 'Vérifié',
    falsePositive: 'Faux positif',
    validation: {
      confirmed: 'Confirmé exploitable',
      theoretical: 'Théorique',
      not_exploitable: 'Non exploitable',
      unvalidated: 'Non validé',
      poc_title: 'Preuve de Concept',
      narrative: 'Narratif d\'exploitation',
      exploit_path: 'Chemin d\'exploitation',
      prerequisites: 'Prérequis',
    },
    markAsFixed: 'Marquer comme corrigé',
    noVulnerabilities: 'Aucune vulnérabilité trouvée',
    export: 'Exporter les vulnérabilités',
    distributionBySeverity: 'Répartition par Sévérité',
    details: {
      loading: 'Chargement des détails...',
      exploitProof: 'Preuve d\'exploitation',
    },
    priority: {
      auto: 'Automatique',
    },
    searchPlaceholder: 'Rechercher par titre, CVE, description...',
    noVulnerabilitiesFound: 'Aucune vulnérabilité n\'a été trouvée dans les scans.',
    noVulnerabilitiesBySeverity: 'Aucune vulnérabilité de sévérité {severity} trouvée.',
    customActionPlaceholder: 'Ex : shell_inverse, extraction_creds, porte_derobee...',
    // Action Panel
    actionPanel: {
      title: 'Actions sur la vulnérabilité',
    },
    // Attack Chain
    attackChain: {
      title: 'Classement des Chaînes d\'Attaque',
      analysisTitle: 'Analyse des Risques',
      subtitle: 'Analyse des risques multi-vulnérabilités pour pénétrer la cible',
      riskScore: 'Score de risque',
      vulnCount: 'vulnérabilités',
      attackPath: 'Chemin d\'attaque vers l\'objectif',
      // Chart
      chartTitle: 'Distribution des Vulnérabilités',
      chartSubtitle: 'Analyse statistique des CVE détectées',
      bySeverity: 'Répartition par Sévérité',
      keyMetrics: 'Métriques Clés',
      totalVulns: 'Total CVE',
      avgCvss: 'CVSS Moyen',
      criticalHigh: 'Critique + Haute',
      affectedHosts: 'Hôtes Affectés',
      topCves: 'Top CVE par CVSS',
      // Stages
      stages: {
        initialAccess: 'Accès Initial',
        privEscalation: 'Élévation de Privilèges',
        persistence: 'Persistance',
        objective: 'Objectif'
      },
      exploitVia: 'Exploitation via',
      escalationVia: 'Escalade via',
      maintenanceVia: 'Maintien via',
      fullCompromise: 'Compromission complète du système',
      adminAccess: 'Accès administrateur possible',
      initialSystemAccess: 'Accès initial au système',
      // Risk Factors
      riskFactors: 'Facteurs de risque',
      factors: {
        multiVuln: 'Multi-vulnérabilités',
        multiVuln5: '{count} vulns combinables',
        multiVuln3: '{count} vulns sur cet hôte',
        criticalHighCombo: 'Combo Critical + High',
        rce: 'RCE potentiel',
        authBypass: 'Bypass auth possible',
        privEsc: 'Escalade privilèges',
        exposed: 'Services exposés',
        highCvss: 'CVSS moyen {score}'
      },
      // Ratings
      ratingCritical: 'CRITIQUE',
      ratingHigh: 'ÉLEVÉ',
      ratingMedium: 'MOYEN',
      ratingLow: 'FAIBLE',
      ratingSafe: 'SÉCURISÉ',
      // Details
      criticalPath: 'CHEMIN CRITIQUE',
      vulnsInChain: 'Vulnérabilités dans cette chaîne',
      noChains: 'Aucune chaîne d\'attaque détectée',
      noVulnsDesc: 'Aucune vulnérabilité n\'a été trouvée pour analyser les chemins d\'attaque.',
      viewDetails: 'Voir les détails',
      multiVulnWarning: 'Risque accru : plusieurs vulnérabilités exploitables en chaîne',
      // Recommendations
      recommendation: 'Recommandation d\'exploitation',
      recoCritical: 'Cette cible présente un risque critique. La combinaison de {count} vulnérabilités permet une compromission complète du système. Priorité maximale pour la remédiation.',
      recoHigh: 'Risque élevé de compromission. Les vulnérabilités combinées offrent un chemin d\'attaque viable. Action corrective recommandée dans les plus brefs délais.',
      recoMedium: 'Risque modéré. Certaines vulnérabilités pourraient être chaînées pour une exploitation. À surveiller et corriger selon la priorité.',
      recoLow: 'Risque faible. Les vulnérabilités présentes ont un impact limité et sont difficiles à exploiter en chaîne.',
      // Stats
      criticalPaths: 'Chemins Critiques',
      highRisk: 'Risque Élevé',
      multiVuln: 'Multi-Vulns (3+)',
      hostsAnalyzed: 'Hôtes Analysés',
      avgScore: 'Score Moyen',
      // Info
      infoText: 'Ce classement identifie les hôtes les plus vulnérables en analysant les combinaisons de vulnérabilités exploitables pour atteindre l\'objectif de pénétration.',
      // Legend
      legendCritical: 'Critique (80-100)',
      legendHigh: 'Élevé (60-79)',
      legendMedium: 'Moyen (40-59)',
      legendLow: 'Faible (20-39)',
      legendSafe: 'Sécurisé (0-19)'
    },
    // AI Quick Actions panel
    prioritization: 'Priorisation',
    prioritizationDesc: 'Urgence et criticité',
    exploitabilityLabel: 'Exploitabilité',
    exploitabilityDesc: 'Failles exploitables',
    summaryLabel: 'Résumé',
    summaryDesc: 'Vue d\'ensemble',
    remediationLabel: 'Remédiation',
    remediationDesc: 'Plan de correction',
    aiQueryPlaceholder: 'Posez une question sur les vulnérabilités...',
    analyzeBtn: 'Analyser',
    // PoC Panel
    pocAutoTitle: 'PoC Auto - Génération et Exécution',
    pocSelectVuln: 'Sélectionner une vulnérabilité',
    noCriticalHighForPoC: 'Aucune vulnérabilité critique/haute pour PoC',
    pocGeneratedCode: 'Code PoC Généré',
    copyCta: 'Copier',
    executeBtn: 'Exécuter',
    executingBtn: 'Exécution...',
    pocGenerating: 'Génération du PoC...',
    pocSelectPrompt: 'Sélectionnez une vulnérabilité pour générer un PoC',
    pocResult: 'Résultat :',
    pocActionInProgress: 'Action en cours...',
    // Attack Tree
    hideAttackTree: 'Masquer Arbre d\'Attaque',
    showAttackTree: 'Afficher Arbre d\'Attaque',
    viewWorkspace: 'Voir Workspace',
    generatingAttackTree: 'Génération de l\'arbre d\'attaque...',
    noAttackTreeData: 'Aucune donnée disponible pour l\'arbre d\'attaque',
    ensureWorkspaceHasScans: 'Assurez-vous que le workspace a des scans avec des vulnérabilités',
    // Pagination
    pageOfTotal: 'Page {current} / {total} — {count} vulnérabilités',
    prevPage: '← Précédent',
    nextPage: 'Suivant →',
    // Right panel - Actions
    quickActionsTitle: 'Actions Rapides',
    newScanBtn: 'Nouveau scan',
    generateReportBtn: 'Générer rapport',
    exportJsonBtn: 'Exporter JSON',
    exportCsvBtn: 'Exporter CSV',
    // AI Analysis panel
    aiAnalysisTitle: 'Analyse IA',
    selectedLabel: 'Sélectionné :',
    analyzingLabel: 'Analyse en cours...',
    analyzeWithAI: 'Analyser avec IA',
    impactLabel: 'Impact',
    recommendationsLabel: 'Recommandations',
    selectVulnForAnalysis: 'Sélectionnez une vulnérabilité pour obtenir une analyse IA détaillée.',
    // Statistics panel
    statisticsTitle: 'Statistiques',
    cvssAvg: 'CVSS Moyen',
    exploitableCount: 'Exploitables',
    hostsAffected: 'Hôtes Affectés',
    // Actions History
    actionsHistory: 'Historique des Actions ({count})',
    clearHistory: 'Effacer l\'historique',
    viewScan: 'Voir le scan',
    addToReport: 'Ajouter au rapport',
    // Action Panel Modal
    severityLabel: 'Sévérité',
    cveLabel: 'CVE',
    cvssLabel: 'CVSS',
    targetLabel: 'Cible',
    noDescription: 'Aucune description disponible',
    clickToChangePriority: 'Cliquer pour changer la priorité',
    platform: 'Plateforme',
    payload: 'Charge utile',
    clickToSeeDetails: 'Cliquer pour voir les détails et captures',
    sessionId: 'Session ID',
    actionsAvailable: 'Actions disponibles',
    exploitAction: 'Exploitation',
    exploitActionDesc: 'Tenter d\'exploiter cette vulnérabilité pour obtenir un accès',
    injectionAction: 'Injection',
    injectionActionDesc: 'Exécuter une injection (SQL, commande, XSS, etc.)',
    enumerationAction: 'Énumération',
    enumerationActionDesc: 'Collecter plus d\'informations sur cette faille',
    privescAction: 'Élévation',
    privescActionDesc: 'Tenter une élévation de privilèges',
    pivotAction: 'Pivot',
    pivotActionDesc: 'Pivoter vers d\'autres systèmes du réseau',
    exfilAction: 'Extraction',
    exfilActionDesc: 'Extraire des données sensibles via cette faille',
    aiWizardBtn: 'Wizard IA',
    aiWizardDesc: 'L\'IA analyse la CVE et lance le wizard d\'exploitation adapté',
    captureProofBtn: 'Capture Preuve',
    captureProofDesc: 'Capturer une preuve d\'exploitation pour le rapport',
    customActionTitle: 'Action personnalisée',
    executeAction: 'Exécuter',
    actionsAutoIntegrated: 'Les résultats des actions seront automatiquement intégrés au rapport du scan',
    // Priority Modal
    editPriority: 'Modifier la Priorité',
    autoSeverity: 'Sévérité automatique :',
    manualPriority: 'Priorité manuelle',
    usesCVSS: 'Utilise CVSS',
    priorityCritical: 'Critique',
    priorityHigh: 'Haute',
    priorityMedium: 'Moyenne',
    priorityLow: 'Basse',
    priorityInfo: 'Info',
    noteOptional: 'Note (optionnel)',
    explainPriorityChange: 'Expliquez pourquoi vous avez changé la priorité...',
    savePriority: 'Enregistrer',
    savingPriority: 'Enregistrement...',
    // AI Wizard Modal
    aiWizardTitle: 'Wizard IA - Analyse de Vulnérabilité',
    wizardRecommended: 'Wizard recommandé par l\'IA',
    vulnSummaryTitle: 'Résumé de la vulnérabilité',
    launchWizard: 'Lancer {name}',
    orChooseWizard: 'Ou choisir un autre wizard :',
    aiAnalyzing: 'Analyse IA en cours...',
    aiDeterminingWizard: 'L\'IA détermine le meilleur wizard d\'exploitation',
    // Screenshots Panel
    screenshotsTitle: 'Captures de Preuves ({count})',
    noScreenshots: 'Aucune capture de preuve',
    screenshotsAutoAdded: 'Les captures seront automatiquement ajoutées aux rapports',
    // Wizard reasons
    wizardReasonAD: 'Cette vulnérabilité est liée à Active Directory, Kerberos ou des services Windows. Le wizard AD permet d\'exploiter les failles d\'authentification et de mouvement latéral.',
    wizardReasonAPI: 'Cette vulnérabilité concerne une API ou un service web. Le wizard API permet de tester les endpoints, l\'authentification et les injections.',
    wizardReasonIoT: 'Cette vulnérabilité affecte un équipement IoT ou un protocole industriel. Le wizard IoT est spécialisé dans l\'analyse des objets connectés.',
    wizardReasonOT: 'Cette vulnérabilité concerne un système industriel ou SCADA. Le wizard OT est conçu pour l\'analyse sécurisée des environnements industriels.',
    wizardReasonExpert: 'Cette vulnérabilité critique nécessite une analyse approfondie. Le mode Expert offre un contrôle total sur les techniques d\'exploitation.',
    wizardReasonAI: 'L\'IA va analyser cette vulnérabilité et déterminer automatiquement la meilleure stratégie d\'exploitation.',
    // AI Analysis generated content
    aiSummaryTemplate: 'Cette vulnérabilité {severity} affecte {target}. Elle permet potentiellement à un attaquant d\'exploiter {title}.',
    aiImpactCritical: 'Impact critique sur la confidentialité et l\'intégrité du système',
    aiImpactHigh: 'Impact élevé - nécessite une attention immédiate',
    aiImpactMedium: 'Impact modéré - à corriger dans les meilleurs délais',
    aiImpactLow: 'Impact faible - à surveiller',
    aiRec1: 'Appliquer les correctifs de sécurité disponibles',
    aiRec2: 'Restreindre l\'accès réseau au service affecté',
    aiRec3: 'Mettre en place une surveillance renforcée',
    aiRec4CVE: 'Consulter les détails CVE : {cve_id}',
    aiRec4NoCVE: 'Effectuer une analyse approfondie',
    aiExploitHigh: 'Élevée',
    aiExploitMedium: 'Moyenne',
    aiExploitLow: 'Faible',
    aiExploitUnknown: 'Non évaluée',
    aiVectorRemote: 'Réseau (Remote)',
    aiVectorAdjacent: 'Adjacent',
    aiVectorLocal: 'Local',
    // VulnerabilityDetails page extra keys
    exploitabilityMetric: 'Exploitabilité',
    attackDifficulty: 'Difficulté d\'attaque',
    detectionRisk: 'Risque de détection',
    exploitMaturity: 'Maturité de l\'exploit',
    riskAssessment: 'Évaluation du risque',
    aiRecommendations: 'Recommandations IA',
    aiAnalyzingVuln: 'L\'IA analyse la vulnérabilité...',
    clickToGetRecommendations: 'Cliquez sur "Voir" pour obtenir les recommandations IA',
    autoAnalysisDesc: 'Analyse automatique des vecteurs d\'attaque et stratégies d\'exploitation',
    analyzeLabel: 'Analyse...',
    viewLabel: 'Voir',
    // Exploit generation
    generateExploit: 'Générer',
    generatingExploit: 'Génération...',
    executeOnTarget: 'Exécuter sur cible',
    executingExploit: 'Exécution...',
    copyCode: 'Copier',
    codeCopied: 'Code copié dans le presse-papier !',
    langLabel: 'Langage :',
    targetLabel2: 'Cible :',
    aiGeneratingExploit: 'L\'IA génère un exploit personnalisé...',
    aiExploitAnalysisDesc: 'Analyse du CVE, création du payload, optimisation...',
    clickGenerateExploit: 'Cliquez sur "Générer" pour créer un exploit IA personnalisé',
    thenExecuteExploit: 'Puis "Exécuter sur cible" pour lancer l\'attaque',
    autoExploitGenDesc: 'Génération automatique de code d\'exploitation adapté à la cible',
    exploitProofs: 'Preuves d\'Exploitation ({count})',
    captureN: 'Capture {n} :',
    capturesEnregistrees: '{count} captures de preuve enregistrées',
    exploitReussie: 'EXPLOITATION RÉUSSIE',
    exploitEchec: 'ÉCHEC',
    dureeDuration: 'Durée',
    exportPdf: 'Exporter PDF',
    // Impact Analysis Table
    impactAnalysis: 'Analyse d\'Impact',
    accessVector: 'Vecteur d\'accès',
    accessComplexity: 'Complexité d\'accès',
    requiredAuth: 'Authentification requise',
    userInteractionLabel: 'Interaction utilisateur',
    confidentialityImpact: 'Impact sur la confidentialité',
    integrityImpact: 'Impact sur l\'intégrité',
    availabilityImpact: 'Impact sur la disponibilité',
    networkInternet: 'Réseau Internet',
    adjacentNetwork: 'Réseau Adjacent',
    localAccess: 'Accès Local',
    complexityLow: 'Faible',
    complexityHigh: 'Élevée',
    privNone: 'Aucune',
    privLow: 'Privilèges bas',
    privHigh: 'Privilèges élevés',
    userInteractionNone: 'Aucune requise',
    userInteractionRequired: 'Requise',
    impactFull: 'Complet',
    impactPartial: 'Partiel',
    impactNone: 'Aucun',
    scoreCvss: 'Score CVSS v3.1',
    // AI Recommendations section
    detailsBtn: 'Détails',
    launchBtn: 'Lancer',
    relaunchBtn: 'Relancer',
    analyzingLabel2: 'Analyse...',
    // Remediation section
    remediationRecommendedDelay: 'Délai recommandé',
    remediationMaxWindow: 'Fenêtre de correction maximale',
    remediationImpact: 'Impact',
    remediationHighImpact: 'ÉLEVÉ',
    remediationRestartRequired: 'Redémarrage service requis',
    remediationStepsTitle: 'Étapes de remédiation détaillées',
    // Remediation Steps
    step1Title: 'Sauvegarde et préparation',
    step1Desc: 'Avant toute modification, effectuez une sauvegarde complète du système.',
    step1Li1: 'Vérifier l\'espace disque disponible',
    step1Li2: 'Documenter la configuration actuelle',
    step1Li3: 'Prévenir les équipes concernées',
    step2Title: 'Mise à jour Apache Struts',
    step2Desc: 'Téléchargez et installez la dernière version sécurisée d\'Apache Struts.',
    step2Warning: 'Attention : Vérifiez la compatibilité avec votre application avant la mise à jour',
    step3Title: 'Configuration WAF',
    step3Desc: 'Implémentez des règles WAF pour bloquer les tentatives d\'exploitation OGNL.',
    step4Title: 'Hardening de la configuration',
    step4Desc: 'Renforcez la configuration Struts pour prévenir les futures vulnérabilités.',
    step5Title: 'Redémarrage et validation',
    step5Desc: 'Redémarrez les services et validez que la correction est effective.',
    step5Li1: 'Vérifier que l\'application démarre correctement',
    step5Li2: 'Tester les fonctionnalités critiques',
    step5Li3: 'Relancer un scan de vulnérabilité pour confirmer',
    step6Title: 'Monitoring et surveillance',
    step6Desc: 'Mettez en place une surveillance continue pour détecter les tentatives d\'exploitation.',
    step6Li1: 'Configurer des alertes IDS/IPS pour les patterns d\'attaque Struts',
    step6Li2: 'Activer la journalisation détaillée des requêtes HTTP',
    step6Li3: 'Planifier des scans de vulnérabilité réguliers (hebdomadaires)',
    step6Li4: 'S\'abonner aux bulletins de sécurité Apache Struts',
    workaroundTitle: 'Solution temporaire (si patch impossible)',
    workaroundDesc: 'Si la mise à jour immédiate n\'est pas possible, appliquez ces mesures d\'atténuation :',
    workaround1: 'Bloquer l\'accès externe au service (firewall/ACL)',
    workaround2: 'Implémenter un reverse proxy avec filtrage des headers Content-Type',
    workaround3: 'Désactiver les endpoints REST non essentiels',
    workaround4: 'Activer le mode strict du parser multipart',
    // Slider
    attackDetails: 'Détails de l\'Attaque',
    targetInfo: 'Cible',
    systemInfoTitle: 'Informations Système',
    hostnameLabel: 'Nom d\'hôte',
    architectureLabel: 'Architecture',
    ipLabel: 'Adresse IP',
    initialUserLabel: 'Utilisateur initial',
    privilegesObtained: 'Privilèges obtenus',
    domainLabel: 'Domaine',
    exfiltratedData: 'Données Exfiltrées ({count})',
    proofCaptures: 'Captures de Preuve ({count})',
    // AI Responses
    aiResponsesCount: '{count} réponse(s) IA',
    questionLabel: 'Question :',
    // discoveredField
    discoveredField: 'Découvert',
    // Exploit action alerts
    aiExecAlert: 'Exécution des recommandations IA sur {host}:{port}\n\nTest de pénétration automatisé lancé\nScan de vulnérabilité en cours\nVérification des vecteurs d\'attaque\n\nRésultats disponibles dans quelques minutes...',
    exploitSearchAlert: 'Recherche et test d\'exploits sur {host}:{port}\n\nConnexion à Metasploit Framework\nScan des modules applicables\nTest automatisé des exploits\n\n3 exploits trouvés, test en cours...',
    exploitGenAlert: 'Génération et exécution d\'exploit IA sur {host}:{port}\n\nAnalyse de la vulnérabilité\nGénération du payload personnalisé\nExécution sur la cible\n\nRésultat : Exploitation réussie !\nSession établie.',
    // Mock screenshot titles
    screenshotInitialConn: 'Connexion initiale',
    screenshotInitialConnDesc: 'Établissement de la connexion reverse shell',
    screenshotSysInfo: 'Information système',
    screenshotSysInfoDesc: 'Récupération des informations de la cible',
    screenshotFileAccess: 'Accès fichiers',
    screenshotFileAccessDesc: 'Preuve d\'accès au système de fichiers',
    attackComplexity: 'Complexité d\'attaque',
    attackVector: 'Vecteur d\'attaque',
    backToList: 'Retour à la liste',
    cvssMetrics: 'Métriques CVSS',
    exportCsv: 'Exporter CSV',
    exportJson: 'Exporter JSON',
    host: 'Hôte',
    immediateFix: 'Correction immédiate',
    noCVE: 'Pas de CVE',
    port: 'Port',
    privilegesRequired: 'Privilèges requis',
    remediation: 'Remédiation',
    remediationSummary: 'Résumé de remédiation',
    service: 'Service',
    sortByCvss: 'Trier par CVSS',
    sortBySeverity: 'Trier par sévérité',
    userInteraction: 'Interaction utilisateur',
    screenshotPrivEsc: 'Élévation de privilèges',
    screenshotPrivEscDesc: 'Tentative d\'escalade de privilèges',
    list: {
      attackChain: '⚔️ Chaîne d\'attaque',
      aiAssistant: '🤖 Assistant IA',
      pocAuto: '💥 PoC Auto',
      total: 'Total vulnérabilités',
      avgScore: 'Score moyen',
      avgCvssScore: 'Score CVSS Moyen',
      uniqueHosts: 'Hôtes uniques',
      affectedHosts: 'Hôtes affectés',
      radarChart: 'Graphique en Toile (Radar)',
    },
  },

  // Reports
  reports: {
    title: 'Rapports',
    newReport: 'Nouveau rapport',
    generateReport: 'Générer un rapport',
    downloadReport: 'Télécharger le rapport',
    reportType: 'Types de rapports',
    settings: 'Paramètres',
    branding: 'Image de marque',
    types: {
      executive: 'Rapport exécutif',
      technical: 'Rapport technique',
      compliance: 'Rapport de conformité',
      full: 'Rapport complet',
      vulnerability_list: 'Rapport de vulnérabilités',
      redteam: 'Rapport équipe rouge',
      retest: 'Rapport de contre-test',
      multi_campaign: 'Rapport multi-campagnes',
      active_directory: 'Rapport Active Directory',
      data_leak: 'Rapport de fuites de données',
      attack_surface: 'Rapport de surface d\'attaque'
    },
    typeDescriptions: {
      executive: 'Synthèse stratégique pour le COMEX avec indicateurs clés et recommandations prioritaires',
      technical: 'Analyse complète des vulnérabilités avec détails techniques et remédiations',
      vulnerability_list: 'Export structuré pour Jira, ServiceNow, GLPI',
      redteam: 'Scénario d\'attaque narratif avec MITRE ATT&CK mapping',
      retest: 'Comparaison avant/après correction',
      multi_campaign: 'Vue consolidée de plusieurs scans',
      active_directory: 'Audit AD, privilèges, GPO, délégations',
      data_leak: 'Détection des données exposées et credentials',
      attack_surface: 'Cartographie de l\'exposition externe'
    },
    format: 'Format',
    formats: {
      pdf: 'PDF',
      html: 'HTML',
      json: 'JSON',
      csv: 'CSV',
      docx: 'Word (DOCX)',
      xml: 'XML',
      jira: 'Jira',
      servicenow: 'ServiceNow',
      glpi: 'GLPI',
      pptx: 'PowerPoint (PPTX)',
      txt: 'Texte (TXT)',
      xlsx: 'Excel (XLSX)'
    },
    includeEvidence: 'Inclure les preuves',
    includeRemediation: 'Inclure les recommandations',
    generatedAt: 'Généré le',
    generatedBy: 'Généré par',
    noReports: 'Aucun rapport',
    // AI Generated Reports
    aiGenerated: 'Rapports IA',
    generated: {
      title: 'Rapports Générés par IA',
      subtitle: 'Rapports professionnels générés par LLM',
      create: 'Créer un rapport',
      createNew: 'Nouveau rapport IA',
      selectType: 'Type de rapport',
      selectScan: 'Sélectionner un scan',
      selectWorkspace: 'Sélectionnez un espace de travail',
      selectFormat: 'Format de sortie',
      generating: 'Génération en cours...',
      regenerate: 'Régénérer',
      regenerateSection: 'Régénérer cette section',
      export: 'Exporter',
      download: 'Télécharger',
      delete: 'Supprimer',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce rapport\u202F?',
      status: {
        pending: 'En attente',
        queued: 'En file d\'attente',
        generating: 'En génération',
        completed: 'Terminé',
        failed: 'Échec',
        cancelled: 'Annulé'
      },
      sections: {
        executive_summary: 'Résumé exécutif',
        key_findings: 'Conclusions principales',
        recommendations: 'Recommandations',
        technical_details: 'Détails techniques',
        vulnerability_analysis: 'Analyse des vulnérabilités',
        risk_assessment: 'Évaluation des risques',
        remediation_plan: 'Plan de remédiation',
        attack_narrative: 'Récit d\'attaque',
        mitre_mapping: 'Mapping MITRE ATT&CK',
        timeline: 'Chronologie',
        appendix: 'Annexes'
      },
      quality: {
        score: 'Score de qualité',
        excellent: 'Excellent',
        good: 'Bon',
        average: 'Moyen',
        poor: 'Faible'
      },
      noReports: 'Aucun rapport généré',
      noReportsDesc: 'Créez votre premier rapport IA pour commencer',
      totalReports: 'Total des rapports',
      completedReports: 'Rapports terminés',
      averageQuality: 'Qualité moyenne',
      lastGenerated: 'Dernier rapport'
    },
    // GeneratedReportDetail keys
    fixRate: 'Taux de correction',
    fixed: 'Corrigé',
    partial: 'Partielles',
    notFixed: 'Non corrigé',
    qualityScore: 'Score de qualité',
    riskLevel: 'Niveau de risque',
    riskScore: 'Score de risque',
    aiVerification: 'Vérification IA',
    tokensUsed: 'Tokens utilisés : ',
    generationTime: 'Temps de génération : ',
    keyFindings: 'Constats Majeurs',
    mitreMapping: 'Mapping MITRE ATT&CK',
    vulnStats: 'Statistiques de vulnérabilités',
    remediationProgress: 'Progression Remédiation',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce rapport ?',
    reportNotFound: 'Rapport introuvable',
    backToList: 'Retour à la liste',
    backToReports: 'Retour aux rapports',
    generating: 'Génération...',
    verified: 'vérifié',
    corrections: 'correction(s) appliquée(s)',
    executiveSummary: 'Résumé Exécutif',
    attackVectors: 'Vecteurs d\'Attaque',
    complianceImpact: 'Impact Conformité',
    promptVersion: 'Version prompt',
    regenerateReports: 'Régénérer les rapports PDF et Word',
    // ReportsList keys
    promptIa: 'Prompt IA',
    aiReports: 'Rapports IA',
    validationRequired: 'Validation requise pour générer des rapports',
    validationRequiredDesc: 'Pour générer un rapport, vous devez d\'abord valider des éléments depuis leurs pages respectives :',
    validationRequiredDesc2: 'Seuls les éléments validés apparaîtront dans la liste ci-dessous.',
    withoutScanData: 'Sans données de scan',
    linkToScanOptional: 'Lier à un scan (optionnel)',
    noValidScans: 'Aucun scan valide',
    noValidScansDesc: 'Validez vos scans depuis la page Scans',
    totalScansTooltip: 'Total des scans de sécurité effectués. Ces données constituent la base pour la génération de rapport de pentest.',
    totalVulnsTooltip: 'Total des vulnérabilités détectées tous niveaux confondus. Inclut Critique, Haute, Moyenne et Faible.',
    criticalVulnsTooltip: 'Failles de sécurité critiques (CVSS 9-10). Exploitation immédiate possible, risque de compromission totale. Correction prioritaire sous 24-48h.',
    highVulnsTooltip: 'Failles de sécurité élevées (CVSS 7-8.9). Impact significatif sur la confidentialité ou l\'intégrité. Correction recommandée sous 2 semaines.',
    mediumVulnsTooltip: 'Failles de sécurité moyennes (CVSS 4-6.9). Exploitation nécessite des conditions spécifiques. Correction lors du cycle de maintenance normal.',
    lowVulnsTooltip: 'Failles de sécurité à faible impact (CVSS 0.1-3.9). Risque limité, peuvent être enchaînées avec d\'autres vulnérabilités. Correction planifiable.',
    generatedReportsTooltip: 'Nombre de rapports de pentest générés et sauvegardés. Les rapports incluent les résultats, recommandations et peuvent être exportés en PDF.',
    enterpriseFeature: 'Fonctionnalité Entreprise',
    prepareRemediation: 'Préparer la Remédiation',
    aiAssisted: 'Assisté par IA',
    analyzingVulnerabilities: 'Analyse des vulnérabilités...',
    generatingE3rProcedures: 'Génération des procédures E3R...',
    aiEnrichment: 'Enrichissement IA...',
    finalizingDocument: 'Finalisation du document...',
    generateRemediationPlan: 'Générer le plan de remédiation ANSSI E3R',
    remediationPlanDesc: 'Le plan de remédiation inclut les 4 phases ANSSI avec procédures, scripts et recommandations basés sur les vulnérabilités détectées.',
    selectAScan: '-- Sélectionner un scan --',
    noScansAvailable: '-- Aucun scan disponible --',
    globalRemediation: 'Remédiation globale',
    scansWithVulns: 'Scans avec vulnérabilités',
    scansWithoutVulns: 'Scans sans vulnérabilités',
    noScansInWorkspace: 'Aucun scan disponible dans ce workspace. Lancez un scan de sécurité pour générer un plan de remédiation.',
    continuityRecovery: 'Continuité & Reprise d\'Activité',
    referenceScanOptional: 'Scan de référence (optionnel — enrichit la section cyber du PCRA)',
    noScanGenericPcra: '-- Aucun scan (PCRA générique) --',
    generationOptions: 'Options de génération',
    generatingPcra: 'Génération du PCRA...',
    analyzingIsRisks: 'Analyse des SI et risques opérationnels...',
    identifyingCriticalActivities: 'Identification des activités critiques et DMIA...',
    generatingOperationalSheets: 'Génération des fiches opérationnelles...',
    aiEnrichmentContinuity: 'Enrichissement IA des solutions de continuité...',
    generatePcra: 'Générer le PCRA — Domaine ANS 2',
    pcraCompliantDesc: 'Conforme au Kit PCRA de santé ANS · Décret du 3 juillet 2025 · ISO 22301 · Critères d\'évaluation D2',
    adPentestMethodology: 'Méthodologie PASSI Active Directory',
    noAdPentestData: 'Aucun pentest AD réalisé — collez vos données manuellement ci-dessous.',
    importFromExistingPentest: 'Importer depuis un pentest AD existant',
    loadingPentests: 'Chargement des pentests...',
    aiAnalyzingData: 'L\'IA analyse vos données PingCastle et ORADAD...',
    reportsGeneratedSuccessfully: 'Rapports générés avec succès',
    generateAdReports: 'Générer les rapports Active Directory',
    compliancePlans: 'Plans de Conformité',
    generateDocument: 'Générer le document',
    askQuestion: 'Poser une question sur les rapports, vulnérabilités, recommandations...',
    reportsLibrary: 'Bibliothèque de rapports',
    refreshList: 'Rafraîchir la liste',
    generatedReportsWillAppear: 'Les rapports générés apparaîtront ici',
    regenerateReport: 'Régénérer le rapport',
    download: 'Télécharger',
    configurationSummary: 'Résumé de la configuration',
    selectedScansLabel: 'Scans sélectionnés',
    notSelected: 'Non sélectionné',
    readyToGenerate: 'Prêt à générer',
    selectScans: 'Sélectionner des scans',
    chooseReportType: 'Choisir un type de rapport',
    recentReports: 'Rapports récents',
    selectAtLeastOneScan: 'Sélectionner au moins un scan',
    aiReportGeneration: 'Génération de rapports IA',
    generateWithAi: 'Générer un rapport avec l\'IA',
    aiDetectsConfig: 'Décrivez le rapport souhaité en langage naturel. L\'IA détectera automatiquement le type, le format et le scan cible.',
    configurationDetected: 'Configuration détectée :',
    proFeature: 'Fonctionnalité Pro',
    retry: 'Réessayer',
    // Export modal
    export: {
      title: 'Exportation',
      processing: 'Exportation en cours...',
      generating: 'Génération du fichier',
      takingLong: 'Cette opération prend plus de temps que prévu.',
      canWaitOrEmail: 'Vous pouvez patienter, ou fermer cette fenêtre et nous vous enverrons un lien par e-mail.',
      sendByEmail: 'Recevoir par e-mail',
      continueWaiting: 'Vous pouvez aussi continuer à attendre, le téléchargement démarrera automatiquement.',
      emailSent: 'E-mail envoyé !',
      emailSentDesc: 'Vous recevrez le lien de téléchargement par e-mail dans quelques instants.',
      wordLocked: 'Disponible pour les plans Entreprise et supérieurs'
    },
    // Report configuration placeholders
    placeholders: {
      footerText: 'Ex. : Document confidentiel - Ne pas diffuser',
      logoUrl: 'https://entreprise.fr/logo.png',
      contactEmail: 'contact@entreprise.fr',
      sectionTitle: 'Titre de la section...',
      sectionDescription: 'Description (optionnel)...',
      contentTemplate: 'Entrez le modèle de contenu (Markdown pris en charge)...\n\nVariables disponibles :\n{{scan.target}} - Cible du scan\n{{scan.date}} - Date du scan\n{{vulnerabilities.count}} - Nombre de vulnérabilités\n{{vulnerabilities.critical}} - Vulnérabilités critiques'
    },
    // Report configuration labels
    config: {
      title: 'Configuration',
      subtitle: 'Configurez les types de rapports disponibles et personnalisez leur contenu',
      settingsTitle: 'Paramètres des rapports',
      brandingTitle: 'Image de marque des rapports',
      defaultLanguage: 'Langue par défaut',
      confidentialityLevel: 'Niveau de confidentialité',
      includeOptions: 'Options d\'inclusion',
      includeLogo: 'Inclure le logo',
      includeTableOfContents: 'Inclure la table des matières',
      includeAppendices: 'Inclure les annexes',
      includeMethodology: 'Inclure la méthodologie',
      footerTextLabel: 'Texte de pied de page',
      logoUrlLabel: 'URL du logo',
      primaryColor: 'Couleur principale',
      secondaryColor: 'Couleur secondaire',
      companyInfo: 'Informations société (pour les rapports)',
      companyName: 'Nom de la société',
      address: 'Adresse',
      contactEmail: 'E-mail de contact',
      phone: 'Téléphone',
      website: 'Site web',
      sectionsTitle: 'Sections du rapport',
      addSection: 'Ajouter une section',
      noTypeSelected: 'Aucun type sélectionné',
      noTypeSelectedHint: 'Cliquez sur un type de rapport dans la liste pour afficher et personnaliser ses sections',
      sectionRequired: 'Section requise',
      sectionActive: 'Actif',
      requiredBadge: 'Requis',
      contentTemplateLabel: 'Modèle de contenu (Markdown pris en charge)',
      clickToAddTemplate: 'Cliquez pour ajouter un modèle de contenu...',
      markdownHint: 'Utilisez Markdown pour le formatage. Variables : {{variable}}',
      noReportTypes: 'Aucun type de rapport disponible',
      loadError: 'Erreur lors du chargement du rapport',
      loadingReport: 'Chargement du rapport...',
      loadDataError: 'Erreur lors du chargement des données',
      loadSectionsError: 'Erreur lors du chargement des sections',
      deleteError: 'Erreur lors de la suppression',
      reorderError: 'Erreur lors du réordonnancement',
      addError: 'Erreur lors de l\'ajout',
      updateError: 'Erreur lors de la mise à jour',
      saveError: 'Erreur lors de la sauvegarde',
      downloadError: 'Erreur lors du téléchargement',
      generateError: 'Erreur lors de la génération du rapport',
      regenerateError: 'Erreur lors de la régénération',
      noGeneratedFile: 'Aucun fichier généré',
      noScansAvailable: 'Aucun scan terminé disponible pour générer les rapports. Veuillez effectuer un scan d\'abord.',
      noVulnsDetected: 'Aucune vulnérabilité détectée dans les scans. Le plan de remédiation sera vide.',
      loadingPentests: 'Chargement des pentests...',
      noScanAvailable: '-- Aucun scan disponible --',
      networkError: 'Erreur réseau. Vérifiez votre connexion.'
    },
    pageCountLabels: {
      executive: 'Synthèse',
      technical: 'Complet',
      vulnerability_list: 'Liste',
      redteam: 'Narratif',
      retest: 'Comparatif',
      multi_campaign: 'Multi-scan',
      active_directory: 'Audit AD',
      data_leak: 'DLP',
      attack_surface: 'ASM'
    },
    aiPrompts: {
      executiveSummary: 'Synthèse exécutive',
      executiveSummaryQuery: 'Génère une synthèse exécutive des vulnérabilités trouvées pour la direction',
      recommendations: 'Recommandations',
      recommendationsQuery: 'Quelles sont les recommandations de remédiation prioritaires ?',
      trends: 'Tendances',
      trendsQuery: 'Analyse les tendances de sécurité à partir des scans terminés',
      criticalRisks: 'Risques critiques',
      criticalRisksQuery: 'Quels sont les risques critiques à traiter immédiatement ?'
    },
    pcraDomains: {
      heading: '4 scénarios d\'indisponibilité couverts',
      informationSystems: 'Systèmes d\'information',
      staffKeySkills: 'Personnel / Compétences clés',
      buildingsInfra: 'Bâtiments / Infrastructures',
      suppliers: 'Fournisseurs / Sous-traitants'
    },
    pcraPhases: {
      heading: '4 phases de construction',
      scoping: 'Cadrage',
      scopingSub: 'Périmètre & gouvernance',
      bia: 'Analyse BIA',
      biaSub: 'Activités critiques & DMIA',
      development: 'Développement',
      developmentSub: 'Solutions de continuité',
      mco: 'MCO',
      mcoSub: 'Maintien en condition opérationnelle',
      phaseLabel: 'Phase'
    },
    adReportTypes: {
      comex: 'Rapport COMEX',
      comexDesc: '10–15 pages',
      technical: 'Rapport Technique',
      technicalDesc: '25–60 pages, AD-XX',
      actionPlan: 'Plan d\'action',
      actionPlanDesc: 'Excel 16 colonnes',
      aiSummary: 'Synthèse IA',
      aiSummaryDesc: 'Roadmap 30/90/180j'
    },
    adForm: {
      missionName: 'Nom de la mission',
      missionPlaceholder: 'ex: Audit AD — Infra Prod',
      clientName: 'Nom du client / organisation',
      clientPlaceholder: 'ex: ACME Corp',
      pingcastleResults: 'Résultats PingCastle (collez ici)',
      pingcastlePlaceholder: 'Collez les résultats PingCastle ici :\n- Score global, règles déclenchées\n- Stale Objects, comptes privilégiés\n- Trusts, politiques de mots de passe, délégations\n\nAccepte : texte brut, HTML, CSV…',
      oradadResults: 'Résultats ORADAD (collez ici)',
      oradadPlaceholder: 'Collez les résultats ORADAD ici :\n- Anomalies structurelles\n- Délégations, groupes critiques\n- Comptes sensibles, GPO, objets obsolètes\n- ACL dangereuses, SPN exposés…',
      charactersSuffix: 'caractères',
      optionalEnrich: 'Optionnel — enrichit l\'analyse IA',
      reportsToGenerate: 'Rapports à générer',
      comexPdfLabel: 'Rapport COMEX (PDF)',
      comexPdfDesc: '10-15 pages, COMEX/RSSI',
      technicalPdfLabel: 'Rapport Technique (PDF)',
      technicalPdfDesc: '25-60 pages, constats AD-XX',
      actionPlanLabel: 'Plan d\'action (Excel)',
      actionPlanDesc: '16 colonnes, P1/P2/P3'
    },
    outputFormat: 'Format de sortie'
  },

  // Account
  account: {
    title: 'Mon compte',
    profile: 'Profil',
    security: 'Sécurité',
    subscription: 'Abonnement',
    billing: 'Facturation',
    credits: 'Crédits',
    notifications: 'Notifications',
    integrations: 'Intégrations',
    referral: 'Parrainage',
    activity: 'Activité',
    contracts: 'Contrats',

    // Profile section
    profileSection: {
      title: 'Informations du profil',
      avatar: 'Photo de profil',
      changeAvatar: 'Changer la photo',
      removeAvatar: 'Supprimer la photo',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      position: 'Fonction',
      timezone: 'Fuseau horaire',
      language: 'Langue du portail',
      languageDescription: 'Choisissez la langue d\'affichage de l\'interface',
      updateSuccess: 'Profil mis à jour avec succès',
      updateError: 'Erreur lors de la mise à jour du profil',
      // Language names in French
      languages: {
        fr: 'Français',
        en: 'Anglais',
        es: 'Espagnol',
        de: 'Allemand',
        it: 'Italien',
        pt: 'Portugais'
      }
    },

    // Security section
    securitySection: {
      title: 'Sécurité du compte',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      passwordRequirements: 'Le mot de passe doit contenir au moins 8 caractères',
      twoFactorAuth: 'Authentification à deux facteurs',
      enable2FA: 'Activer la 2FA',
      disable2FA: 'Désactiver la 2FA',
      twoFactorEnabled: '2FA activée',
      twoFactorDisabled: '2FA désactivée',
      activeSessions: 'Sessions actives',
      revokeSession: 'Révoquer la session',
      revokeAllSessions: 'Révoquer toutes les sessions',
      loginHistory: 'Historique des connexions',
      lastLogin: 'Dernière connexion',
      apiKeys: 'Clés API',
      generateApiKey: 'Générer une clé API',
      deleteApiKey: 'Supprimer la clé API',
      passwordsNoMatch: 'Les mots de passe ne correspondent pas',
      passwordChanged: 'Mot de passe modifié',
      mfaConfigError: 'Erreur lors de la configuration MFA',
      invalidCode: 'Code invalide',
      apiKeyGenerated: 'Clé API générée et copiée',
      confirmApiKeyGenerate: 'Générer une nouvelle clé API ? L\'ancienne sera invalidée.',
      enterMfaCode: 'Entrez votre code MFA pour désactiver',
      passwordCopied: 'Mot de passe copié dans le presse-papiers',
      generatePasswordFirst: 'Générez un mot de passe et vérifiez votre numéro de téléphone',
      smsSent: 'Mot de passe envoyé par SMS',
      smsError: 'Erreur lors de l\'envoi du SMS',
      mfaEnabled: '2FA activée',
      mfaDisabled: '2FA désactivée',
      passwordApplied: 'Mot de passe appliqué aux champs',
    },

    // Subscription section
    subscriptionSection: {
      title: 'Abonnement',
      currentPlan: 'Plan actuel',
      planDetails: 'Détails du plan',
      features: 'Fonctionnalités incluses',
      usage: 'Utilisation',
      limits: 'Limites',
      renewalDate: 'Date de renouvellement',
      cancelSubscription: 'Annuler l\'abonnement',
      upgradePlan: 'Passer à un plan supérieur',
      downgradePlan: 'Passer à un plan inférieur',
      plans: {
        free: 'Gratuit',
        pro: 'Pro',
        enterprise: 'Entreprise',
        dedicated: 'Dédié'
      }
    },

    // Credits section
    creditsSection: {
      title: 'Gestion des crédits',
      subtitle: 'Gérez vos crédits, abonnements et packs',
      balance: 'Solde',
      totalCredits: 'Crédits totaux',
      monthlyCredits: 'Crédits mensuels',
      packCredits: 'Crédits pack',
      usedThisMonth: 'Utilisés ce mois',
      remaining: 'Restants',
      buyCredits: 'Acheter des crédits',
      creditHistory: 'Historique des crédits',
      transaction: 'Transaction',
      amount: 'Montant',
      creditCosts: 'Coût des opérations',
      scanCost: 'Coût d\'un scan',
      reportCost: 'Coût d\'un rapport',
      // Additional keys for CreditsPage
      expires: 'Expire le',
      noExpiration: 'Sans expiration',
      currentPlan: 'Plan actuel',
      statusActive: 'Actif',
      monthlyPlans: 'Plans mensuels',
      free: 'Gratuit',
      perMonth: '/mois',
      creditsPerMonth: 'crédits/mois',
      unlimitedWorkspaces: 'Espaces clients illimités',
      externalScans: 'Scans externes',
      internalScans: 'Scans internes',
      adScans: 'Scans Active Directory',
      select: 'Sélectionner',
      creditPacks: 'Packs de crédits',
      credits: 'crédits',
      validity: 'Validité',
      months: 'mois',
      buy: 'Acheter',
      scans: 'Scans',
      leakDetection: 'Détection de fuites',
      audits: 'Audits',
      reports: 'Rapports',
      noTransactions: 'Aucune transaction',
      transactionHistory: 'Historique des transactions',
      refresh: 'Actualiser',
      date: 'Date',
      type: 'Type',
      dashboard: 'Tableau de bord',
      plansAndPacks: 'Plans & Packs',
      history: 'Historique',
      errorOccurred: 'Une erreur est survenue',
      creditsAvailable: 'crédits disponibles',
      confirmPlanChange: 'Confirmer le changement de plan',
      confirmPurchase: 'Confirmer l\'achat',
      planActiveImmediately: 'Le plan sera actif immédiatement',
      creditsAddedImmediately: 'Les crédits seront ajoutés immédiatement',
      cancel: 'Annuler',
      processing: 'Traitement...',
      confirm: 'Confirmer',
      planSubscribed: 'Abonnement au plan {plan} réussi',
      packPurchased: 'Achat du pack {pack} réussi',
      statusPremium: 'PREMIUM',
      statusExhausted: 'ÉPUISÉ',
      statusCritical: 'CRITIQUE',
      statusLow: 'FAIBLE',
      unlimited: 'Illimité',
      totalBalance: 'Solde total disponible',
      monthly: 'Mensuels',
      packs: 'Packs'
    },

    // Notifications section
    notificationsSection: {
      title: 'Préférences de notification',
      emailNotifications: 'Notifications par e-mail',
      pushNotifications: 'Notifications push',
      scanCompleted: 'Scan terminé',
      scanFailed: 'Scan échoué',
      newVulnerability: 'Nouvelle vulnérabilité critique',
      reportReady: 'Rapport prêt',
      securityAlerts: 'Alertes de sécurité',
      weeklyDigest: 'Résumé hebdomadaire',
      marketingEmails: 'E-mails marketing'
    },

    // Integrations section
    integrationsSection: {
      title: 'Intégrations',
      connected: 'Connecté',
      notConnected: 'Non connecté',
      configure: 'Configurer',
      disconnect: 'Déconnecter',
      testConnection: 'Tester la connexion',
      connectionSuccess: 'Connexion réussie',
      connectionFailed: 'Échec de la connexion',
      availableIntegrations: 'Intégrations disponibles',
      myIntegrations: 'Mes intégrations'
    },

    // Referral section
    referralSection: {
      title: 'Programme de parrainage',
      referralLink: 'Lien de parrainage',
      copyLink: 'Copier le lien',
      shareLink: 'Partager le lien',
      inviteFriends: 'Inviter des amis',
      referralStats: 'Statistiques de parrainage',
      totalReferrals: 'Total des parrainages',
      pendingReferrals: 'Parrainages en attente',
      completedReferrals: 'Parrainages complétés',
      earnedCredits: 'Crédits gagnés',
      inviteByEmail: 'Inviter par e-mail',
      contacts: 'Contacts invités',
      rewards: 'Récompenses',
      leaderboard: 'Classement',
      inviteContact: 'Inviter un contact',
      shareDescription: 'Partagez ce lien pour inviter de nouveaux utilisateurs',
      loading: 'Chargement...',
      yourLevel: 'Votre niveau',
      nextLevel: 'Prochain niveau',
      creditsEarned: 'Crédits gagnés',
      conversionFunnel: 'Entonnoir de conversion',
      invited: 'Invités',
      clicked: 'Cliqués',
      signedUp: 'Inscrits',
      converted: 'Convertis',
      clickRate: 'Taux de clic',
      conversionRate: 'Taux de conversion',
      perClick: 'Par clic',
      perSignup: 'Par inscription',
      perProConversion: 'Par conversion Pro',
      noContacts: 'Aucun contact invité',
      inviteFirstContact: 'Invitez votre premier contact',
      contact: 'Contact',
      creditsGenerated: 'Crédits générés',
      topReferrers: 'Top Parrains',
      rank: 'Rang',
      user: 'Utilisateur',
      tier: 'Niveau',
      referrals: 'Filleuls',
      conversions: 'Conversions',
      value: 'Valeur',
      you: '(vous)',
      firstName: 'Prénom',
      lastName: 'Nom',
      company: 'Entreprise',
      sendInvitation: 'Envoyer l\'invitation',
      referralLinkCopied: 'Lien de parrainage copié !',
      invitationSent: 'Invitation envoyée avec succès !',
      contactRemoved: 'Contact supprimé',
      deleteContactConfirm: 'Supprimer ce contact ?',
      resendInvitation: 'Renvoyer l\'invitation',
      statusInvited: 'Invité',
      statusClicked: 'A cliqué',
      statusSignedUp: 'Inscrit',
      statusConverted: 'Converti',
      statusChurned: 'Parti',
      remainingToNextTier: 'restants',
      errorSending: 'Erreur lors de l\'envoi',
      errorResending: 'Erreur lors du renvoi',
      errorDeleting: 'Erreur lors de la suppression',
      planSubscribed: 'Abonnement au plan {plan} réussi',
      packPurchased: 'Achat du pack {pack} réussi'
    },

    // Save buttons
    // Avatar section
    avatarSection: {
      invalidType: 'Veuillez sélectionner une image',
      tooLarge: 'L\'image ne doit pas dépasser 2 Mo',
      updateSuccess: 'Avatar mis à jour',
      updateError: 'Erreur lors de la mise à jour de l\'avatar',
      readError: 'Erreur lors de la lecture du fichier'
    },

    // Company section
    companySection: {
      title: 'Informations de l\'entreprise',
      logo: 'Logo de l\'entreprise',
      name: 'Nom de l\'entreprise',
      legalForm: 'Forme juridique',
      capital: 'Capital social',
      address: 'Adresse',
      city: 'Ville',
      postalCode: 'Code postal',
      country: 'Pays',
      timezone: 'Fuseau horaire (pour les scans)',
      legalRep: 'Représentant légal',
      fullName: 'Nom complet',
      updateSuccess: 'Informations de l\'entreprise mises à jour',
      updateError: 'Erreur lors de la sauvegarde'
    },

    // Team section
    teamSection: {
      confirmRemove: 'Voulez-vous vraiment retirer ce membre ?',
      memberRemoved: 'Membre retiré'
    },

    // Logo section
    logoSection: {
      updated: 'Logo mis à jour',
      updatedAV: 'Logo mis à jour - Scan antivirus OK',
      updateError: 'Erreur lors de la mise à jour du logo',
      deleted: 'Logo supprimé',
      deleteError: 'Erreur lors de la suppression du logo'
    },

    configuration: 'Configuration',
    team: 'Équipe',
    users: 'Utilisateurs',
    help: 'Aide',
    history: 'Historique',
    version: 'Version',
    support: 'Support',
    reportTypes: 'Types de rapports',
    loadError: 'Erreur lors du chargement du compte',
    saveAll: 'Tout sauvegarder',
    saveProfile: 'Sauver profil',
    saveCompany: 'Sauver entreprise'
  },

  // Settings
  settings: {
    title: 'Paramètres',
    general: 'Général',
    tools: 'Outils',
    network: 'Réseau',
    advanced: 'Avancé',

    // General settings
    generalSection: {
      title: 'Paramètres généraux',
      defaultScanType: 'Type de scan par défaut',
      defaultReportFormat: 'Format de rapport par défaut',
      autoSaveReports: 'Sauvegarde automatique des rapports',
      enableNotifications: 'Activer les notifications',
      darkMode: 'Mode sombre',
      compactView: 'Vue compacte'
    },

    // Tools settings
    toolsSection: {
      title: 'Configuration des outils',
      enabledTools: 'Outils activés',
      toolSettings: 'Paramètres des outils',
      timeout: 'Délai d\'attente',
      threads: 'Nombre de threads',
      verbosity: 'Niveau de verbosité'
    },

    // Network settings
    networkSection: {
      title: 'Configuration réseau',
      proxySettings: 'Paramètres proxy',
      vpnSettings: 'Paramètres VPN',
      dnsSettings: 'Paramètres DNS',
      useProxy: 'Utiliser un proxy',
      proxyHost: 'Hôte du proxy',
      proxyPort: 'Port du proxy'
    },

    // Server status
    uptime: 'Disponibilité'
  },

  // Admin
  admin: {
    title: 'Administration',
    users: 'Utilisateurs',
    companies: 'Entreprises',
    system: 'Système',
    logs: 'Journaux',
    maintenance: 'Maintenance',

    // Users management
    usersSection: {
      title: 'Gestion des utilisateurs',
      addUser: 'Ajouter un utilisateur',
      editUser: 'Modifier l\'utilisateur',
      deleteUser: 'Supprimer l\'utilisateur',
      activateUser: 'Activer l\'utilisateur',
      deactivateUser: 'Désactiver l\'utilisateur',
      resetPassword: 'Réinitialiser le mot de passe',
      role: 'Rôle',
      roles: {
        admin: 'Administrateur',
        user: 'Utilisateur',
        viewer: 'Observateur'
      },
      lastLogin: 'Dernière connexion',
      createdAt: 'Créé le',
      noUsers: 'Aucun utilisateur'
    },

    // System
    systemSection: {
      title: 'Système',
      systemInfo: 'Informations système',
      version: 'Version',
      uptime: 'Temps de fonctionnement',
      restart: 'Redémarrer',
      backup: 'Sauvegarder',
      restore: 'Restaurer',
      update: 'Mettre à jour'
    },
    columns: {
      company: 'Entreprise',
      plan: 'Plan',
      status: 'Statut',
      users: 'Utilisateurs',
      scans: 'Scans',
      createdOn: 'Créé le',
      actions: 'Actions',
      user: 'Utilisateur',
      role: 'Rôle',
      emailVerified: 'Email vérifié',
      mfa: 'MFA',
      lastLogin: 'Dernière connexion',
      timestamp: 'Horodatage',
      action: 'Action',
      resourceType: 'Type de ressource',
      ipAddress: 'Adresse IP',
      statusCol: 'Statut',
    },
    actions: {
      resendVerification: 'Renvoyer l\'email de vérification',
      sendPasswordReset: 'Envoyer le lien de réinitialisation',
      changePassword: 'Changer le mot de passe',
      resendInvitation: 'Renvoyer l\'invitation',
      unlockAccount: 'Déverrouiller le compte',
      forceEmailVerification: 'Forcer la vérification d\'email',
      activateAccount: 'Activer le compte',
      deactivateAccount: 'Désactiver le compte',
      disableMfa: 'Désactiver le MFA',
    },
    // Stats cards
    revenueMonth: 'Revenus (mois)',
    revenueSubtitle: 'Abonnements et crédits',
    // Tabs
    auditLogs: 'Journaux d\'audit',
    suspiciousActivity: 'Activité suspecte',
    // Pagination
    pagination: {
      of: 'sur',
      rowsPerPage: 'Lignes par page',
    },
    // Legend
    legend: 'Légende',
    statusCompleted: 'Terminé',
    statusArchived: 'Archivé',
    // Status chips
    locked: 'Verrouillé',
    statusSuccess: 'Succès',
    statusFailed: 'Échoué',
    // Table columns
    owner: 'Propriétaire',
    // Tooltips company status
    companyTooltip: {
      active: 'Entreprise active avec accès complet',
      suspended: 'Entreprise suspendue, accès bloqué',
      pending: 'En attente d\'approbation ou de paiement',
      inactive: 'Entreprise inactive, compte fermé',
    },
    // Tooltips workspace status
    statusTooltip: {
      active: 'Workspace actuellement utilisé',
      completed: 'Toutes les tâches terminées',
      archived: 'Workspace archivé, accès en lecture seule',
      pending: 'En attente de configuration ou validation',
      inactive: 'Workspace inactif',
    },
    // Dialog labels
    companyDetails: 'Détails de l\'entreprise',
    subscription: 'Abonnement',
    noSubscription: 'Aucun abonnement',
    userDetails: 'Détails de l\'utilisateur',
    fullName: 'Nom complet',
    accountStatus: 'Statut du compte',
    adminApproval: 'Approbation admin',
    approved: 'Approuvé',
    security: 'Sécurité',
    failedAttempts: 'Tentatives échouées',
    lockedUntil: 'Verrouillé jusqu\'au',
    blocked: 'Bloqué',
    loginSection: 'Connexion',
    never: 'Jamais',
    lastIp: 'Dernière IP',
    creationDate: 'Date de création',
    setNewPasswordFor: 'Définir un nouveau mot de passe pour',
    createNewUser: 'Créer un nouvel utilisateur',
    sendInvitationEmail: 'Envoyer l\'e-mail d\'invitation',
    newUser: 'Nouvel utilisateur',
    exportCsv: 'Exporter en CSV',
    // Suspicious activity
    suspiciousActivityDesc: 'Cette section affiche les tentatives de connexion échouées et les activités suspectes.',
    seeConsole: 'Voir la console',
    loadAlerts: 'Charger les alertes',
    // Misc
    vsLastMonth: 'vs mois dernier',
  },

  // Errors
  errors: {
    generic: 'Une erreur est survenue',
    notFound: 'Page non trouvée',
    // Backend error message translations (English to French mapping)
    backendMessages: {
      'Workspace not found': 'Espace de travail non trouvé',
      'Invalid signature token': 'Jeton de signature invalide',
      'Contract already signed': 'Contrat déjà signé',
      'Contract already pending signature. Cancel existing request first.': 'Contrat déjà en attente de signature. Annulez d\'abord la demande existante.',
      'Contract not yet signed': 'Contrat pas encore signé',
      'Signed contract file not found': 'Fichier du contrat signé non trouvé',
      'Contract file not found on disk': 'Fichier du contrat non trouvé sur le disque',
      'Contract already signed, cannot cancel': 'Contrat déjà signé, impossible d\'annuler',
      'No pending signature request to cancel': 'Aucune demande de signature en attente à annuler',
      'User not found': 'Utilisateur non trouvé',
      'Invalid credentials': 'Identifiants invalides',
      'Access denied': 'Accès refusé',
      'Permission denied': 'Permission refusée',
      'Not found': 'Non trouvé',
      'Bad request': 'Requête invalide',
      'Internal server error': 'Erreur interne du serveur',
      'Service unavailable': 'Service indisponible'
    },
    unauthorized: 'Accès non autorisé',
    forbidden: 'Accès interdit',
    serverError: 'Erreur serveur',
    networkError: 'Erreur réseau',
    timeout: 'Délai d\'attente dépassé',
    validation: 'Erreur de validation',
    invalidEmail: 'E-mail invalide',
    invalidPassword: 'Mot de passe invalide',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    requiredField: 'Ce champ est requis',
    minLength: 'Minimum {min} caractères requis',
    maxLength: 'Maximum {max} caractères autorisés',
    fillAllFields: 'Veuillez remplir tous les champs obligatoires',
    verificationFailed: 'La vérification de l\'e-mail a échoué. Le lien peut être expiré ou invalide.',
    invalidVerificationLink: 'Ce lien de vérification est invalide ou a expiré. Veuillez demander un nouveau lien.',
    rateLimitExceeded: 'Trop de tentatives. Veuillez réessayer dans quelques minutes.',
    rateLimitEmail: 'Veuillez patienter quelques minutes avant de renvoyer un e-mail de vérification.',
    emailAlreadyUsed: 'Cet e-mail est déjà utilisé',
    companyAlreadyRegistered: 'Cette entreprise est déjà enregistrée',
    registrationError: 'Erreur lors de l\'inscription',
    genericError: 'Une erreur inattendue s\'est produite',
    disposableEmailNotAllowed: 'Les e-mails temporaires ne sont pas autorisés',
    personalEmailNotAllowed: 'L\'e-mail {domain} n\'est pas autorisé. Utilisez un e-mail professionnel.',
    invalidResetLink: 'Ce lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.',
    resetLinkExpired: 'Ce lien de réinitialisation a expiré. Veuillez demander un nouveau lien.',
    resetPasswordFailed: 'Échec de la réinitialisation du mot de passe. Veuillez réessayer.',
    passwordCriteriaNotMet: 'Le mot de passe ne respecte pas tous les critères requis.',
    // Error page
    401: {
      title: 'Non Autorisé',
      subtitle: 'Oups ! Vous devez vous connecter',
      description: 'Votre session a expiré ou vous n\'êtes pas authentifié. Veuillez vous connecter pour accéder à cette page.',
      redirectText: 'Redirection vers la connexion'
    },
    403: {
      title: 'Accès Refusé',
      subtitle: 'Oups ! Accès interdit',
      description: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette ressource.',
      redirectText: 'Redirection vers le dashboard'
    },
    404: {
      title: 'Page Non Trouvée',
      subtitle: 'Oups ! Page introuvable',
      description: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
      redirectText: 'Redirection vers le dashboard'
    },
    500: {
      title: 'Erreur Serveur',
      subtitle: 'Oups ! Une erreur est survenue',
      description: 'Le serveur a rencontré une erreur. Veuillez réessayer dans quelques instants.',
      redirectText: 'Redirection vers le dashboard'
    },
    503: {
      title: 'Service Indisponible',
      subtitle: 'Oups ! Service temporairement indisponible',
      description: 'Le service est temporairement indisponible pour maintenance. Veuillez réessayer dans quelques instants.',
      redirectText: 'Redirection vers le dashboard'
    },
    backToDashboard: 'Retour au Dashboard',
    retry: 'Réessayer',
    supportContact: 'Si le problème persiste, contactez le support technique.',
    redirectingIn: 'dans',
    seconds: 'secondes',
    error: 'Erreur',
    companyRequired: 'Vous devez appartenir à une entreprise pour effectuer cette action',
    selectRequired: 'Veuillez effectuer une sélection',
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.'
  },

  // Success messages
  success: {
    saved: 'Enregistré avec succès',
    deleted: 'Supprimé avec succès',
    updated: 'Mis à jour avec succès',
    created: 'Créé avec succès',
    copied: 'Copié dans le presse-papiers',
    sent: 'Envoyé avec succès',
    uploaded: 'Téléversé avec succès'
  },

  // Time
  time: {
    now: 'Maintenant',
    seconds: 'secondes',
    minutes: 'minutes',
    hours: 'heures',
    days: 'jours',
    weeks: 'semaines',
    months: 'mois',
    years: 'ans',
    ago: 'il y a',
    in: 'dans'
  },

  // Credentials
  credentials: {
    title: 'Identifiants',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    hash: 'Hash',
    domain: 'Domaine',
    source: 'Source',
    foundAt: 'Trouvé le',
    noCredentials: 'Aucun identifiant trouvé',
    export: 'Exporter les identifiants',
    addNumbers: 'Ajouter chiffres',
    addSpecialChars: 'Caractères spéciaux',
    noPasswordSave: 'Aucun mot de passe à sauvegarder',
    saveDictionaryError: 'Erreur lors de la sauvegarde du dictionnaire',
    loadDictionariesError: 'Erreur lors du chargement des dictionnaires',
    loadDictionaryError: 'Erreur lors du chargement du dictionnaire',
    deleteError: 'Erreur lors de la suppression',
    downloadError: 'Erreur lors du téléchargement',
    searchError: 'Recherche échouée',
    validationError: 'Erreur lors de la validation',
    noCredentialExport: 'Aucun credential à exporter',
    noPasswordExport: 'Aucun mot de passe à exporter',
    decryptError: 'Erreur lors du décryptage',
    noDictionarySaved: 'Aucun dictionnaire sauvegardé',
    noWorkspace: '-- Aucun workspace --',
    noResult: 'Aucun résultat',
    noResultMatch: 'Aucun credential ne correspond',
    noPasswordAvailable: 'Aucun mot de passe disponible'
  },

  // Sessions
  sessions: {
    title: 'Sessions',
    pageTitle: 'Sessions d\'Exploitation',
    pageDescription: 'Gestion des sessions d\'exploitation et accès compromis',
    sessionDetails: 'Détails de la session',
    activeSession: 'Session active',
    closedSession: 'Session fermée',
    sessionType: 'Type de session',
    target: 'Cible',
    startedAt: 'Démarré à',
    endedAt: 'Terminé à',
    duration: 'Durée',
    commands: 'Commandes',
    noSessions: 'Aucune session',
    closeSession: 'Fermer la session',
    interactiveShell: 'Terminal interactif',
    quickActions: 'Actions Rapides',
    quickCommands: 'Commandes Rapides',
    defaultSessionType: 'Terminal',
    sessionLabel: 'Session',
    manualExploit: 'Manuel',
    platform: 'Plateforme',
    platformUnknown: 'Inconnue',
    exploitUsed: 'Exploit utilisé',
    commandsExecuted: 'Commandes exécutées',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      closed: 'Fermée',
      stale: 'À relancer',
      idle: 'Veille',
      error: 'Erreur',
      unknown: 'Inconnue',
      queued: 'En file d\'attente',
      running: 'En cours',
      pending: 'En attente',
      completed: 'Terminée',
      failed: 'Échouée'
    },
    badges: {
      root: 'ROOT',
      persistent: 'PERSISTANT'
    },
    persistence: {
      installed: 'Installée',
      notInstalled: 'Non installée'
    },
    quickPrompts: {
      help: 'Aide',
      privesc: 'Privesc',
      persistence: 'Persistence',
      lateral: 'Mouvement latéral',
      pocAuto: 'PoC auto',
      aptModules: 'Modules APT'
    },
    errors: {
      connectionError: 'Erreur de connexion au serveur',
      loadingError: 'Erreur lors du chargement des sessions',
      actionError: 'Erreur lors de l\'exécution de l\'action',
      serverError: 'Erreur serveur interne',
      serviceUnavailable: 'Service temporairement indisponible',
      loadFailed: 'Échec du chargement',
      screenshotFailed: 'Échec de la capture d\'écran',
      privescFailed: 'Échec de l\'escalade de privilèges',
      persistenceFailed: 'Échec de l\'installation de la persistance',
      aptExecutionFailed: 'Échec de l\'exécution du module APT'
    },
    actions: {
      screenshotSuccess: 'Capture d\'écran effectuée',
      privescSuccess: 'Escalade de privilèges réussie',
      privescCompleted: 'Tentative d\'escalade terminée',
      persistenceSuccess: 'Mécanisme de persistance installé',
      persistenceCompleted: 'Installation terminée'
    },
    privilegeLevel: 'Niveau de privilège',
    lastActivity: 'Dernière activité',
    screenshot: 'Capture d\'écran',
    privilegeEscalation: 'Escalade de privilèges',
    downloadLogs: 'Télécharger les logs',
    migrationRecommended: 'Migration recommandée',
    connected: 'Connecté',
    connecting: 'Connexion...',
    confirmInstallPersistence: 'Installer un mécanisme de persistance ?',
    confirmCloseSession: 'Êtes-vous sûr de vouloir fermer cette session ?'
  },

  // Support
  support: {
    title: 'Support',
    myTickets: 'Mes Tickets Support',
    manageRequests: 'Gérez vos demandes d\'assistance',
    newTicket: 'Nouveau ticket',
    ticketDetails: 'Détails du ticket',
    subject: 'Sujet',
    message: 'Message',
    priority: 'Priorité',
    status: 'Statut',
    category: 'Catégorie',
    created: 'Créé',
    createdOn: 'Créé le',
    updated: 'Dernière mise à jour',
    resolved: 'Résolu',
    resolvedOn: 'Résolu le',
    noTickets: 'Aucun ticket',
    noTicketsFound: 'Aucun ticket trouvé',
    noTicketsYet: 'Vous n\'avez pas encore créé de ticket de support',
    tryModifyingSearch: 'Essayez de modifier vos critères de recherche',
    createFirstTicket: 'Créer mon premier ticket',
    sendMessage: 'Envoyer un message',
    send: 'Envoyer',
    sending: 'Envoi...',
    closeTicket: 'Fermer le ticket',
    closing: 'Fermeture...',
    ticketClosed: 'Ce ticket est fermé. Pour une nouvelle demande, créez un nouveau ticket.',
    search: 'Rechercher un ticket...',
    allStatuses: 'Tous les statuts',
    refresh: 'Actualiser',
    backToTickets: 'Retour aux tickets',
    ticketNumber: 'Numéro',
    you: 'Vous',
    supportTeam: 'Support SYLink',
    system: 'Système',
    writeReply: 'Écrivez votre réponse...',
    detailedDescription: 'Description détaillée',
    informations: 'Informations',
    needHelp: 'Besoin d\'aide\u202F?',
    responseTime: 'Temps de réponse estimé',
    responseTimeDesc: 'Notre équipe répond généralement sous 24h ouvrées. Les tickets urgents sont traités en priorité. Vous recevrez une notification par e-mail dès qu\'une réponse sera apportée.',
    supportResponseDesc: 'Notre équipe de support répond généralement sous 24h ouvrées. Pour les urgences, n\'hésitez pas à indiquer une priorité haute.',
    newTicketTitle: 'Nouveau Ticket',
    newTicketDesc: 'Décrivez votre problème et notre équipe vous répondra rapidement',
    describeIssue: 'Décrivez brièvement votre problème...',
    relatedWorkspace: 'Client / Espace de travail concerné (optionnel)',
    noSpecificWorkspace: 'Aucun espace de travail spécifique',
    detailedDescPlaceholder: 'Décrivez votre problème en détail. Plus vous donnez d\'informations, plus nous pourrons vous aider rapidement...\n\n- Qu\'essayez-vous de faire\u202F?\n- Qu\'est-ce qui se passe\u202F?\n- Qu\'attendiez-vous\u202F?\n- Avez-vous un message d\'erreur\u202F?',
    charactersCount: '{count} caractères',
    charactersMin: '{count} caractères (minimum {min})',
    cancel: 'Annuler',
    createTicket: 'Créer le ticket',
    creating: 'Création...',
    rateSupport: 'Comment évaluez-vous la qualité de notre support\u202F?',
    comment: 'Commentaire (optionnel)...',
    confirm: 'Confirmer',
    messages: 'message',
    messagesPlural: 'messages',
    resolutionNotes: 'Notes de résolution',
    yourRating: 'Votre évaluation',

    // Statuses
    statuses: {
      open: 'Ouvert',
      in_progress: 'En cours',
      waiting_customer: 'En attente de votre réponse',
      waiting_internal: 'En traitement',
      resolved: 'Résolu',
      closed: 'Fermé'
    },

    // Priorities
    priorities: {
      low: 'Basse',
      medium: 'Moyenne',
      high: 'Haute',
      urgent: 'Urgente',
      lowDesc: 'Pas urgent, peut attendre',
      mediumDesc: 'Importance normale',
      highDesc: 'Nécessite une attention rapide',
      urgentDesc: 'Impact critique sur l\'activité',
      priority: 'Priorité'
    },

    // Categories
    categories: {
      technical: 'Technique',
      billing: 'Facturation',
      feature_request: 'Demande de fonctionnalité',
      bug_report: 'Signalement de bug',
      account: 'Compte',
      security: 'Sécurité',
      other: 'Autre',
      technicalDesc: 'Problèmes techniques, erreurs, dysfonctionnements',
      billingDesc: 'Questions sur les factures, paiements, abonnements',
      feature_requestDesc: 'Suggestions d\'amélioration ou nouvelles fonctionnalités',
      bug_reportDesc: 'Signaler un bug ou comportement inattendu',
      accountDesc: 'Gestion du compte, accès, permissions',
      securityDesc: 'Questions ou préoccupations de sécurité',
      otherDesc: 'Autre type de demande'
    },

    // Errors
    errors: {
      loadingTickets: 'Erreur lors du chargement des tickets',
      loadingTicket: 'Erreur lors du chargement du ticket',
      sendingMessage: 'Erreur lors de l\'envoi du message',
      closingTicket: 'Erreur lors de la fermeture du ticket',
      creatingTicket: 'Erreur lors de la création du ticket',
      ticketNotFound: 'Ticket non trouvé',
      retry: 'Réessayer',
      fixFormErrors: 'Veuillez corriger les erreurs dans le formulaire',
      subjectRequired: 'Le sujet est requis',
      subjectMinLength: 'Le sujet doit contenir au moins 5 caractères',
      descriptionRequired: 'La description est requise',
      descriptionMinLength: 'La description doit contenir au moins 20 caractères'
    },

    // Success messages
    success: {
      ticketCreated: 'Ticket {number} créé avec succès',
      messageSent: 'Message envoyé',
      ticketClosed: 'Ticket fermé avec succès'
    }
  },

  // Attack
  attack: {
    title: 'Centre d\'Attaque',
    description: 'Outils d\'attaque avancés et orchestrateur dynamique',
    selectTarget: 'Sélectionner la cible',
    selectTechnique: 'Sélectionner la technique',
    launchAttack: 'Lancer l\'attaque',
    attackInProgress: 'Attaque en cours',
    attackCompleted: 'Attaque terminée',
    attackFailed: 'Attaque échouée',
    techniques: 'Techniques',
    payloads: 'Charges utiles',
    results: 'Résultats',
    dynamicOrchestrator: 'Orchestrateur Dynamique',
    attackGraph: 'Graphe d\'Attaque',
    attackBuilder: 'Constructeur d\'Attaque',
    launchChain: 'Lancer la chaîne',
    continueChain: 'Reprendre',
    restartAll: 'Relancer tout',
    executing: 'Exécution...',
    aiSuggestions: 'Suggestions IA',
    ready: 'Prêt',
    inProgress: 'En cours...'
  },

  // Pricing
  pricing: {
    title: 'Choisissez votre plan',
    subtitle: 'Des solutions de sécurité adaptées à toutes les tailles d\'entreprise. Commencez gratuitement et évoluez selon vos besoins.',
    monthly: 'Mensuel',
    yearly: 'Annuel',
    yearlyDiscount: '-17%',
    perMonth: 'mois',
    perYear: 'an',
    ht: 'HT',
    or: 'Soit',
    perMonthShort: '/mois',
    onQuote: 'Sur devis',
    free: 'Gratuit',
    // Plan names and descriptions
    plans: {
      gratuit: {
        name: 'Gratuit',
        subtitle: 'Découverte',
        description: 'Idéal pour tester la plateforme',
        cta: 'Commencer gratuitement'
      },
      pro: {
        name: 'Pro',
        subtitle: 'Le plus populaire',
        description: 'Pour les professionnels et PME',
        cta: 'Choisir Pro',
        badge: 'Recommandé'
      },
      entreprise: {
        name: 'Entreprise',
        subtitle: 'Pour les grandes équipes',
        description: 'Fonctionnalités avancées et support dédié',
        cta: 'Choisir Entreprise'
      },
      entreprise_plus: {
        name: 'Groupe',
        subtitle: 'Pour les grandes organisations',
        description: 'Volume étendu et support premium',
        cta: 'Choisir Groupe'
      },
      sur_mesure: {
        name: 'Sur-Mesure',
        subtitle: 'Solution personnalisée',
        description: 'Adaptée à vos besoins spécifiques',
        cta: 'Nous contacter'
      }
    },
    // Features
    features: {
      simulationOnly: 'Mode simulation uniquement',
      oneUser: '1 utilisateur',
      oneTarget: '1 cible de test',
      basicDashboard: 'Dashboard basique',
      realScans: 'Scans réels',
      pdfReports: 'Rapports PDF',
      technicalSupport: 'Support technique',
      apiAccess: 'Accès API',
      unlimitedScans: 'Scans IA illimités',
      fiveUsers: '5 utilisateurs',
      tenTargets: '10 cibles',
      customPdfReports: 'Rapports PDF personnalisés',
      credentialSearch: 'Recherche de credentials',
      autoScheduling: 'Planification automatique',
      prioritySupport: 'Support prioritaire',
      allProFeatures: 'Tout le plan Pro +',
      fifteenUsers: '15 utilisateurs',
      thirtyTargets: '30 cibles',
      ssoSaml: 'SSO / SAML',
      complianceAudit: 'Audit de conformité',
      slaGuarantee: 'SLA garanti 99.9%',
      dedicatedSupport: 'Support dédié',
      teamTraining: 'Formation équipe incluse',
      allEnterpriseFeatures: 'Tout le plan Entreprise +',
      unlimitedUsers: 'Utilisateurs illimités',
      fiftyTargets: '50 cibles',
      advancedWorkspaces: 'Multi-espaces avancés',
      whiteLabelReports: 'Rapports personnalisables',
      support24_7: 'Support dédié 24/7',
      accountManager: 'Gestionnaire de compte dédié',
      customOnboarding: 'Accompagnement personnalisé',
      allGroupeFeatures: 'Tout le plan Groupe +',
      dedicatedInfra: 'Infrastructure dédiée',
      customIntegrations: 'Intégrations personnalisées',
      specificDevelopment: 'Développements spécifiques',
      sourceCodeAudit: 'Audit de code source',
      manualPentest: 'Tests d\'intrusion manuels',
      cissoSupport: 'Accompagnement RSSI',
      customContract: 'Contrat sur mesure'
    },
    // Sections
    whyChoose: 'Pourquoi choisir SYLink Pentest\u202F?',
    aiTitle: 'Intelligence Artificielle',
    aiDesc: 'Notre IA analyse et exploite les vulnérabilités de manière autonome, simulant le comportement d\'un pentester expert.',
    securityTitle: 'Sécurité Maximale',
    securityDesc: 'Vos données sont chiffrées et sécurisées. Aucune information sensible n\'est stockée après les tests.',
    reportsTitle: 'Rapports Détaillés',
    reportsDesc: 'Générez des rapports PDF professionnels avec recommandations de remédiation et scoring CVSS.',
    // FAQ
    faqTitle: 'Questions fréquentes',
    faqCanChangePlan: 'Puis-je changer de plan\u202F?',
    faqCanChangePlanAnswer: 'Oui, vous pouvez upgrader ou downgrader votre plan à tout moment. Les changements sont effectifs immédiatement et au prorata.',
    faqFreePlan: 'Comment fonctionne le plan gratuit\u202F?',
    faqFreePlanAnswer: 'Le plan gratuit vous permet de tester la plateforme en mode simulation. Aucun scan réel n\'est effectué mais vous découvrez toutes les fonctionnalités.',
    faqCommitment: 'Y a-t-il un engagement\u202F?',
    faqCommitmentAnswer: 'Non, aucun engagement. Vous pouvez annuler à tout moment. La facturation annuelle offre 2 mois gratuits.',
    faqSupport: 'Quel support est inclus\u202F?',
    faqSupportAnswer: 'Le plan Pro inclut un support prioritaire par e-mail. Le plan Entreprise bénéficie d\'un support dédié 24/7.',
    // Contact CTA
    needHelpChoosing: 'Besoin d\'aide pour choisir\u202F?',
    needHelpDesc: 'Notre équipe est disponible pour vous conseiller et répondre à toutes vos questions. Obtenez une démonstration personnalisée de la plateforme.',
    needHelpDescShort: 'Notre équipe est disponible pour vous accompagner et répondre à toutes vos questions.',
    contactUs: 'Nous contacter',
    requestCall: 'Demander un appel',
    // Banners
    welcomeTitle: 'Bienvenue sur SYLink Pentest !',
    welcomeDesc: 'Votre compte est activé. Choisissez le plan qui correspond à vos besoins.',
    welcomeDescShort: 'Choisissez le plan qui correspond à vos besoins',
    paymentError: 'Erreur de paiement',
    close: 'Fermer',
    redirecting: 'Redirection...',
    securedByStripe: 'Paiement sécurisé par Stripe',
    // UI labels
    detailedComparison: 'Comparaison détaillée',
    infrastructureOptions: 'Options d\'infrastructure',
    infrastructureDesc: 'Choisissez le mode de déploiement adapté à vos besoins et contraintes',
    choosePlan: 'Choisissez votre',
    choosePlanHighlight: 'plan',
    pageSubtitle: 'Automatisez vos tests d\'intrusion avec l\'IA. Du freelance à l\'entreprise, nous avons le plan qu\'il vous faut.',
    contactBanner: 'Tous nos plans sont personnalisés à vos besoins',
    foreverFree: 'Pour toujours',
    customPricing: 'Sur devis',
    customPricingLabel: 'Tarification personnalisée',
    perMonthHT: '/mois HT',
    billedPerYear: 'Facturé',
    billedPerYearSuffix: '/an',
    requestQuote: 'Demander un devis',
    startFree: 'Commencer gratuitement',
    learnMoreDedicated: 'En savoir plus sur les serveurs dédiés',
    readOnlyApi: 'Lecture seule',
    featureRow: 'Fonctionnalité',
    priceRow: 'Prix'
  },

  // Active Directory
  ad: {
    title: 'Active Directory',
    description: 'Outils d\'attaque AD avec assistance IA LLM et PoC automatisé',
    domain: 'Domaine',
    dcIp: 'IP Domain Controller',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    ntlmHash: 'Hash NTLM (optionnel)',
    dcConfiguration: 'Configuration Domain Controller',
    attacks: 'Attaques AD',
    ldapPentest: 'Pentest LDAP/LDAPS',
    searchPlaceholder: 'Rechercher une attaque, un outil...',
    allCategories: 'Toutes les catégories',
    attackCategories: 'Catégories d\'Attaques',
    targetResults: 'Cible / Résultats',
    noDataMessage: 'Sélectionnez une attaque pour commencer',
    noDataHint: 'Ou utilisez le PoC Auto pour une chaîne d\'attaques',
    readyToStart: 'Prêt à démarrer',
    stats: {
      attacks: 'Attaques',
      successful: 'Réussies',
      failed: 'Échouées',
      credentials: 'Identifiants',
      users: 'Utilisateurs',
      paths: 'Chemins'
    },
    attackWizard: 'Assistant d\'Attaque AD',
    // PingCastleDetail
    backToAD: 'Retour à la page AD',
    auditRunning: 'Audit AD en cours',
    auditRunningDesc: 'Analyse de l\'Active Directory {domain}... La page se rafraîchit automatiquement.',
    auditFailed: 'Audit échoué',
    globalRiskScore: 'Score de risque global',
    scoresByCategory: 'Scores par catégorie',
    noScoresCalculated: 'Aucun score calculé',
    auditInfo: 'Informations de l\'audit',
    criticalIndicatorsPriority: 'Indicateurs critiques à traiter en priorité',
    riskScoreCritical: 'Le domaine présente des vulnérabilités critiques nécessitant une action immédiate.',
    riskScoreHigh: 'Des risques significatifs ont été identifiés dans le domaine Active Directory.',
    riskScoreMedium: 'Quelques axes d\'amélioration à traiter avec une priorité moyenne.',
    riskScoreLow: 'Le domaine présente un niveau de risque faible. Maintenez les bonnes pratiques.',
    objectsAffected: '{count} objet(s) affecté(s)',
    recommendedSolution: 'Solution recommandée',
    noActionRequired: 'Aucune action requise',
    noRiskIndicators: 'Le domaine ne présente aucun indicateur de risque.',
    immediateActions: 'Actions immédiates',
    recommendedImprovements: 'Améliorations recommandées',
    prioritizedActionPlan: 'Plan d\'action priorisé basé sur {count} indicateurs détectés. Les actions immédiates (< 30j) doivent être traitées avant la génération de rapports AD.',
    generateAIAnalysis: 'Générer l\'analyse IA',
    generateAIAnalysisDesc: 'L\'IA va analyser les {count} indicateurs AD pour :',
    generatingAI: 'Analyse en cours…',
    generatingAIDesc: 'L\'IA analyse les {count} indicateur(s) AD et génère le guide d\'attaque',
    generatingAITime: 'Cela peut prendre 2 à 4 minutes selon la charge du serveur GPU',
    analysisGenerated: 'Analyse générée — {domain} · Score {score}/100 ({risk})',
    indicatorsAnalyzed: '{count} indicateur(s) analysé(s)',
    regenerate: 'Régénérer',
    rawResponse: 'Réponse brute',
    analysisError: 'Note : L\'analyse a utilisé un fallback (service IA indisponible).',
    downloadEvidenceReport: 'Télécharger le rapport de preuves (.txt)',
    noIndicatorsForFilter: 'Aucun indicateur de sévérité {filter}.',
    noRiskIndicatorsDetected: 'Aucun indicateur de risque détecté.',
    statsDomainAdmins: 'Admins domaine',
    statsMaxPrivAccounts: 'Comptes à privilège maximum',
    statsKerberoastable: 'Kerberoastable',
    statsInventory: 'Inventaire',
    statsPrivilegedGroups: 'Groupes à privilèges',
    statsKerberosDeleg: 'Kerberos & Délégation',
    statsOtherAnomalies: 'Autres anomalies',
    statsInterpretation: 'Interprétation des statistiques',
    lapsDeployed: 'Déployé',
    lapsAbsent: 'Absent',
    highIndicators: 'Indicateurs High',
    statusDone: '✓ Terminé',
    statusRunning: '⟳ En cours',
    statusFailed: '✗ Échoué',
    scanIdLabel: 'Scan ID',
    startedLabel: 'Démarré',
    completedLabel: 'Terminé',
    // ADSessionDetail
    sessionStatusCompleted: 'Terminé',
    sessionStatusFailed: 'Échoué',
    sessionStatusStopped: 'Arrêté',
    sessionStatusInitialized: 'Initialisé',
    sessionTabOverview: 'Vue d\'ensemble',
    sessionTabSteps: 'Étapes',
    sessionTabFindings: 'Findings',
    sessionTabTimeline: 'Chronologie',
    sessionTabAI: 'Analyse IA',
    sessionFindingsDetected: 'Findings détectés',
    sessionStepsExecuted: 'Étapes exécutées',
    sessionStepsFailed: '{count} échouées, {skipped} ignorées',
    sessionCredentialsFound: 'Identifiants trouvés',
    sessionCompromisedAccounts: 'Comptes compromis',
    sessionUsersEnumerated: 'Utilisateurs énumérés',
    sessionDuration: 'Durée : {duration}',
    sessionDomainCompromised: 'Domaine compromis',
    sessionDomainCompromisedDesc: 'Les techniques exécutées ont démontré la compromission du domaine Active Directory {domain}. Action immédiate requise.',
    sessionAttackPathsFound: 'Chemins d\'attaque identifiés',
    sessionAttackPathsDesc: 'Des vecteurs d\'escalade de privilèges ou de mouvement latéral ont été identifiés dans le domaine.',
    sessionCriticalHighFindings: 'Findings critiques / hauts',
    sessionStepsCompleted: 'Terminées',
    sessionStepsSkipped: 'Ignorées',
    sessionNoMatchingSteps: 'Aucune étape correspondante',
    sessionNoFindingsDetected: 'Aucun finding détecté',
    sessionNoFindingsForFilter: 'Aucun finding à ce niveau de sévérité.',
    sessionNoTimelineEvents: 'Aucun événement de chronologie',
    sessionStepsLabel: '{count} étapes',
    sessionStepFindings: 'Findings de l\'étape',
    sessionRecommendedRemediation: 'Remédiation recommandée',
    sessionAICompromiseGuide: 'Analyse IA — Guide de compromission AD',
    sessionAIWillAnalyze: 'L\'IA va analyser tous les findings et étapes de cette session pour :',
    sessionAIExplainDiscoveries: 'Expliquer les découvertes',
    sessionAIIdentifyPaths: 'Identifier les chemins d\'attaque',
    sessionAIStepByStep: 'Guide de compromission AD étape par étape',
    sessionAIPriorityRecs: 'Recommandations de remédiation prioritaires',
    sessionAILoading: 'Génération automatique du guide de compromission AD',
    sessionAILoadingTime: 'Cela peut prendre 2-4 minutes — traitement en arrière-plan',
    sessionAIAnalysisFor: 'Analyse générée pour {domain}',
    sessionAIAnalysisMeta: '{steps} étapes · {findings} findings analysés',
    sessionAIAnalysisCredentials: '· {count} identifiants',
    sessionDownloadEvidence: 'Télécharger toutes les preuves (.txt)',
    sessionOutputLabel: 'Output',
    sessionStepFindingsLabel: 'Step findings',
    sessionAIAnalysisGenerationTime: 'Génération via Ollama (sylink/sylink2:27b) — environ 2-4 minutes'
  },

  // Branding (Login/Register pages)
  branding: {
    platformTitle: 'Plateforme de',
    platformSubtitle: 'Pentest Automatisé',
    platformDescription: 'Analyse de sécurité alimentée par l\'IA avec exploitation automatisée et rapports détaillés.'
  },

  // Features (Login/Register pages)
  features: {
    autonomousAI: {
      title: 'IA Autonome',
      description: 'Pentester IA simulant un expert en sécurité',
      highlight: 'IA Locale'
    },
    advancedDetection: {
      title: 'Détection avancée',
      description: 'Détection automatique des failles critiques',
      highlight: '200K+ CVE'
    },
    completeTests: {
      title: 'Tests complets',
      description: 'Audit réseau, web, API et infrastructure',
      highlight: '100+ outils'
    },
    instantReports: {
      title: 'Rapports instantanés',
      description: 'Génération automatique de rapports professionnels',
      highlight: '6+ formats'
    }
  },

  // Stats (Login/Register pages)
  stats: {
    availability: 'Disponibilité',
    vulnerabilities: 'Vulnérabilités',
    monitoring: 'Surveillance',
    scanTime: 'Temps de scan'
  },

  // Footer
  footer: {
    title: 'Plateforme de scan de sécurité',
    subtitle: 'Système autonome de tests de pénétration',
    terms: 'Conditions générales d\'utilisation',
    termsShort: 'Conditions d\'utilisation (CGU)',
    sales: 'Conditions générales de vente',
    salesShort: 'Conditions de vente (CGV)',
    privacy: 'Politique de confidentialité',
    legalNotice: 'Mentions légales',
    contact: 'Contact',
    version: 'Version',
    licence: 'Licence n°',
    poweredBy: 'Propulsé par SYLink IA'
  },

  // Notifications
  notifications: {
    managementCenter: 'Centre de gestion des alertes et événements',
    aiAssistant: 'Assistant IA',
    aiAssistantTitle: 'Assistant IA - Notifications',
    aiPlaceholder: 'Posez une question sur vos notifications...',
    settings: 'Paramètres des notifications',
    soundEnabled: 'Sons activés',
    criticalOnly: 'Critiques seulement',
    autoMarkRead: 'Marquer lu auto',
    filters: 'Filtres',
    total: 'Total',
    unread: 'Non lues',
    critical: 'Critiques',
    warning: 'Attention',
    success: 'Succès',
    info: 'Infos',
    markAllRead: 'Tout marquer lu',
    clearAll: 'Effacer tout',
    noNotifications: 'Aucune notification',
    noNotificationsDesc: 'Vous n\'avez aucune notification pour le moment',
    allRead: 'Toutes vos notifications sont lues',
    noNotificationsType: 'Aucune notification de type "{type}"',

    // Notification types
    typeCritical: 'Critique',
    typeWarning: 'Attention',
    typeSuccess: 'Succès',
    typeInfo: 'Info',

    // Notification messages
    criticalVulnsFound: '{count} vulnérabilité{count, plural, =1 {} other {s}} critique{count, plural, =1 {} other {s}}',
    vulnsDetected: '{count} vulnérabilité{count, plural, =1 {} other {s}} détectée{count, plural, =1 {} other {s}}',
    hostsScanned: '{count} hosts scannés sur {target}',
    scanCompletedNoVulns: 'Scan terminé - Aucune vulnérabilité',
    noVulnsDetected: 'Aucune vulnérabilité détectée sur {target}',
    scanInProgress: 'Scan en cours',
    analyzing: 'Analyse de {target}...',
    scanFailed: 'Scan échoué',
    errorOn: 'Erreur sur {target}',

    // Time
    justNow: 'À l\'instant',
    minutesAgo: 'il y a {count}min',
    hoursAgo: 'il y a {count}h',
    daysAgo: 'il y a {count}j',
    scanRunning: 'Scan en cours',
    viewAll: 'Voir toutes les notifications',
    scanCompleted: 'Scan terminé'
  },

  // Enrichment - ABSpider Integration
  enrichment: {
    title: 'Enrichissement de données',
    subtitle: 'Analyse avancée de domaines et IPs avec VirusTotal, en-têtes de sécurité, e-mail et géolocalisation',
    description: 'Analysez des cibles avec plusieurs sources de renseignement de sécurité',

    // Flat keys used by EnrichmentDashboard
    target: 'Cible',
    type: 'Type',
    modules: 'Modules',
    quickScans: 'Scans rapides',
    threatSummary: 'Résumé des menaces',
    recentScans: 'Scans récents',
    riskScore: 'Score de risque',
    date: 'Date',
    noScans: 'Aucun scan pour le moment',
    scan: 'Analyser',
    quickResult: 'Résultat du scan rapide',
    scanDetails: 'Détails du scan',
    statusLabel: 'Statut',

    // Navigation & Actions
    newScan: 'Nouveau scan',
    quickScan: 'Scan rapide',
    fullScan: 'Scan complet',
    viewDetails: 'Voir les détails',
    exportReport: 'Exporter le rapport',
    refresh: 'Actualiser',

    // Scan Types
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'En-têtes de sécurité',
      security_headers: 'En-têtes de sécurité',
      email_security: 'Sécurité e-mail',
      geoip: 'Géolocalisation IP',
      reverse_ip: 'IP inversée',
      full: 'Scan complet',
      domain: 'Domaine',
      ip: 'Adresse IP',
      url: 'URL',
      // Pentest scan types
      ai_scan: 'Scan IA',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      expert: 'Scan expert',
      api_pentest: 'Pentest API',
      iot_scan: 'Scan objets connectés',
      ot_scan: 'Scan OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scan Active Directory',
      ad_recon: 'Reconnaissance AD',
      ad_full: 'Scan AD complet',
      ldap_scan: 'Scan LDAP',
      kerberos_scan: 'Scan Kerberos',
      web_scan: 'Scan Web',
      web: 'Scan Web',
      quick: 'Rapide',
      quick_scan: 'Scan rapide',
      discovery: 'Découverte',
      enumeration: 'Énumération',
      vulnerability: 'Vulnérabilités',
      exploitation: 'Exploitation',
      passive: 'Passif',
      aggressive: 'Agressif',
      credentials: 'Identifiants',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Contournement',
      nmap: 'Scan Nmap',
      nikto: 'Scan Nikto',
      internal: 'Scan interne',
      external: 'Scan externe',
      network: 'Scan réseau'
    },

    // Status
    status: {
      pending: 'En attente',
      queued: 'En file d\'attente',
      running: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
      cancelled: 'Annulé'
    },

    // Threat Levels
    threatLevels: {
      safe: 'Sûre',
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Élevée',
      critical: 'Critique'
    },

    // Form
    form: {
      targetDomain: 'Domaine cible',
      targetDomainPlaceholder: 'ex: exemple.com',
      targetIp: 'Adresse IP (optionnel)',
      targetIpPlaceholder: 'ex: 192.168.1.1',
      scanType: 'Type de scan',
      workspace: 'Espace de travail (optionnel)',
      startScan: 'Lancer le scan',
      credits: 'Crédits requis'
    },

    // Results - General
    results: {
      title: 'Résultats',
      noResults: 'Aucun résultat disponible',
      loading: 'Chargement des résultats...',
      riskScore: 'Score de risque',
      threatLevel: 'Niveau de menace',
      scannedAt: 'Scanné le',
      duration: 'Durée'
    },

    // Security Headers
    headers: {
      title: 'Analyse des en-têtes de sécurité',
      score: 'Score',
      grade: 'Note',
      present: 'Présents',
      missing: 'Manquants',
      recommendations: 'Recommandations',
      headerName: 'En-tête',
      value: 'Valeur',
      status: 'Statut',
      issues: 'Problèmes',
      gradeDescriptions: {
        A: 'Excellent - Sécurité optimale',
        B: 'Bon - Quelques améliorations possibles',
        C: 'Moyen - Améliorations recommandées',
        D: 'Faible - Améliorations importantes nécessaires',
        F: 'Insuffisant - Sécurité critique à améliorer'
      }
    },

    // Email Security
    email: {
      title: 'Sécurité e-mail',
      mxRecords: 'Enregistrements MX',
      spf: 'SPF (Sender Policy Framework)',
      dkim: 'DKIM (DomainKeys Identified Mail)',
      dmarc: 'DMARC (Domain-based Message Authentication)',
      valid: 'Valide',
      invalid: 'Invalide',
      notFound: 'Non trouvé',
      policy: 'Politique',
      mechanisms: 'Mécanismes',
      selectors: 'Sélecteurs',
      vulnerabilities: 'Vulnérabilités détectées',
      recommendations: 'Recommandations'
    },

    // GeoIP
    geoip: {
      title: 'Géolocalisation IP',
      location: 'Localisation',
      country: 'Pays',
      region: 'Région',
      city: 'Ville',
      coordinates: 'Coordonnées',
      timezone: 'Fuseau horaire',
      network: 'Informations réseau',
      isp: 'Fournisseur (ISP)',
      organization: 'Organisation',
      asn: 'ASN',
      flags: 'Indicateurs de sécurité',
      isProxy: 'Proxy détecté',
      isVpn: 'VPN détecté',
      isTor: 'Tor détecté',
      isDatacenter: 'Datacenter',
      isHosting: 'Hébergement'
    },

    // Reverse IP
    reverseIp: {
      title: 'Reverse IP Lookup',
      totalDomains: 'Domaines trouvés',
      domains: 'Liste des domaines',
      sharedHosting: 'Hébergement partagé',
      hostingProvider: 'Fournisseur d\'hébergement',
      suspiciousDomains: 'Domaines suspects',
      riskScore: 'Score de risque'
    },

    // VirusTotal
    virustotal: {
      title: 'Analyse VirusTotal',
      reputation: 'Réputation',
      malicious: 'Malveillant',
      suspicious: 'Suspect',
      harmless: 'Inoffensif',
      undetected: 'Non détecté',
      categories: 'Catégories',
      lastAnalysis: 'Dernière analyse',
      permalink: 'Lien VirusTotal'
    },

    // Dashboard Stats
    stats: {
      totalScans: 'Total des scans',
      completedScans: 'Scans terminés',
      pendingScans: 'Scans en attente',
      failedScans: 'Scans échoués',
      averageScore: 'Score moyen',
      criticalThreats: 'Menaces critiques',
      highThreats: 'Menaces élevées',
      creditsUsed: 'Crédits utilisés'
    },

    // Error messages (used by EnrichmentDashboard)
    error: {
      targetRequired: 'La cible est requise',
      scanFailed: 'Échec du démarrage du scan',
      quickScanFailed: 'Échec du scan rapide',
      loadFailed: 'Échec du chargement des détails du scan',
      deleteFailed: 'Échec de la suppression du scan'
    },

    // Success messages (used by EnrichmentDashboard)
    success: {
      scanStarted: 'Scan démarré avec succès',
      quickScanComplete: 'Scan rapide terminé',
      scanDeleted: 'Scan supprimé'
    },

    // Errors (legacy)
    errors: {
      scanFailed: 'Le scan a échoué',
      insufficientCredits: 'Crédits insuffisants',
      invalidDomain: 'Domaine invalide',
      invalidIp: 'Adresse IP invalide',
      networkError: 'Erreur réseau',
      timeout: 'Délai d\'attente dépassé',
      unknownError: 'Erreur inconnue'
    },

    // Tooltips
    tooltips: {
      virusTotalCredit: 'Utilise l\'API VirusTotal pour analyser la réputation',
      headersCredit: 'Analyse les headers HTTP de sécurité',
      emailCredit: 'Vérifie SPF, DKIM et DMARC',
      geoipCredit: 'Géolocalise l\'adresse IP',
      reverseIpCredit: 'Trouve les domaines hébergés sur la même IP',
      fullCredit: 'Effectue toutes les analyses'
    },

    // Recent Indicators
    recentIndicators: 'Indicateurs récents',

    // AI Analysis
    aiAnalysis: {
      title: 'Analyse IA',
      executiveSummary: 'Résumé exécutif',
      keyFindings: 'Points clés',
      recommendations: 'Recommandations'
    }
  },

  // Antivirus (ClamAV)
  antivirus: {
    title: 'Scanner Antivirus',
    subtitle: 'Analyser les fichiers contre les logiciels malveillants avec ClamAV',
    scannerTab: 'Scanner de fichiers',
    adminTab: 'Administration',
    adminTitle: 'Gestion Antivirus',
    adminSubtitle: 'Surveillance ClamAV et gestion de la quarantaine',
    scanFile: 'Scanner un fichier',
    scanNow: 'Scanner maintenant',
    scanAll: 'Scanner tous les fichiers',
    scanning: 'Analyse en cours...',
    dropOrClick: 'Déposer un fichier ou cliquer pour sélectionner',
    dropFiles: 'Déposer les fichiers ici ou cliquer pour sélectionner',
    maxSize: 'Taille maximale par fichier',
    selectedFiles: 'Fichiers sélectionnés',
    recentScans: 'Analyses récentes',
    summary: 'Résumé de l\'analyse',

    // Status
    clean: 'Sain',
    infected: 'Infecté',
    pending: 'En attente',
    unavailable: 'ClamAV indisponible',

    // Stats
    totalScans: 'Total des analyses',
    cleanFiles: 'Fichiers sains',
    infectedFiles: 'Fichiers infectés',
    dataScanned: 'Données analysées',
    threatsBySeverity: 'Menaces par sévérité',
    performance: 'Performance',
    avgScanTime: 'Temps moyen d\'analyse',
    cacheEntries: 'Entrées en cache',

    // Table headers
    filename: 'Nom du fichier',
    size: 'Taille',
    status: 'Statut',
    threat: 'Menace',
    severity: 'Sévérité',
    scannedAt: 'Analysé',

    // ClamAV
    daemonStatus: 'Statut du démon',
    version: 'Version',
    signatureVersion: 'Version des signatures',
    signatureCount: 'Signatures',
    reloadSignatures: 'Recharger les signatures',

    // Quarantine
    quarantine: 'Quarantaine',
    noQuarantine: 'Aucun fichier en quarantaine',
    quarantinedAt: 'Mis en quarantaine',
    expiresAt: 'Expire',
    cleanupExpired: 'Nettoyer les expirés',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer définitivement ce fichier\u202F?',

    // Errors
    fileTooLarge: 'Fichier trop volumineux',
    typeNotAllowed: 'Type de fichier non autorisé',
    total: 'Total'
  },

  // Contracts & Signature
  contracts: {
    title: 'Contrats',
    newContract: 'Nouveau contrat',
    contractNumber: 'Référence du contrat',
    status: 'Statut',
    draft: 'Brouillon',
    pendingSignature: 'En attente de signature',
    signed: 'Signé',
    active: 'Actif',
    completed: 'Terminé',
    expired: 'Expiré',
    cancelled: 'Annulé',

    // Signature
    signature: {
      title: 'Signature électronique',
      certificate: 'Certificat de signature électronique',
      signatory: 'Signataire',
      signatoryName: 'Nom du signataire',
      signatoryEmail: 'E-mail du signataire',
      signatoryFirstName: 'Prénom',
      signatoryLastName: 'Nom',
      signatureDate: 'Date et heure de signature',
      signatureType: 'Type de signature',
      drawn: 'Dessinée',
      typed: 'Saisie',
      uploaded: 'Téléversée',
      legalMention: 'Mention légale',
      acceptPentest: 'Bon pour acceptation de Pentest',

      // Verification
      verification: 'Vérification',
      smsVerification: 'Vérification SMS',
      smsVerified: 'Validée',
      smsPending: 'En attente',
      ipAddress: 'Adresse IP',
      userAgent: 'Navigateur',
      geolocation: 'Géolocalisation',

      // Integrity
      integrity: 'Intégrité du document',
      documentHash: 'Hash du document',
      signatureHash: 'Hash de la signature',
      hashAlgorithm: 'Algorithme',
      sha512: 'SHA-512',

      // Timeline
      timeline: 'Chronologie',
      createdAt: 'Créé le',
      sentAt: 'Envoyé le',
      viewedAt: 'Consulté le',
      signedAt: 'Signé le',
      viewCount: 'Nombre de consultations',

      // Audit trail
      auditTrail: 'Journal d\'audit',
      action: 'Action',
      timestamp: 'Horodatage',
      viewed: 'Consultation',
      smsRequested: 'Code SMS demandé',
      smsVerifiedAction: 'Code SMS vérifié',
      signedAction: 'Signature effectuée',
      downloaded: 'Téléchargement',

      // Certificate
      certificateType: 'CERTIFICAT DE SIGNATURE',
      platform: 'Plateforme',
      eidas: 'Signature électronique conforme au règlement eIDAS (UE) 910/2014',
      generatedAt: 'Certificat généré le',

      // Actions
      downloadProof: 'Télécharger la preuve de signature',
      viewCertificate: 'Voir le certificat',
      resendEmail: 'Renvoyer par e-mail',

      // Messages
      contractSigned: 'Contrat signé avec succès !',
      copySentByEmail: 'Une copie de ce certificat sera envoyée par e-mail.',
      enterSmsCode: 'Entrez le code SMS',
      smsCodeSent: 'Code SMS envoyé',
      invalidCode: 'Code invalide',
      codeExpired: 'Code expiré',
      tooManyAttempts: 'Trop de tentatives'
    }
  },

  // VPN Configuration
  vpn: {
    title: 'Configuration VPN',
    configurations: 'Configurations VPN',
    noConfigurations: 'Aucune configuration VPN',
    uploadConfig: 'Téléverser une configuration',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    connecting: 'Connexion en cours...',
    disconnecting: 'Déconnexion en cours...',
    connect: 'Connecter',
    disconnect: 'Déconnecter',
    server: 'Serveur',
    saveCredentials: 'Enregistrer les identifiants pour ce VPN',
    status: 'Statut VPN',
    protocol: 'Protocole',
    interface: 'Interface',
    publicIp: 'IP Publique',
    vpnIp: 'IP VPN',
    country: 'Pays',
    city: 'Ville',
    connectedSince: 'Connecté depuis',

    // Routes
    routes: {
      title: 'Routes Réseau',
      description: 'Gérez les routes réseau personnalisées pour le VPN',
      addRoute: 'Ajouter une route',
      destination: 'Destination CIDR',
      destinationPlaceholder: '192.168.56.0/24',
      gateway: 'Passerelle',
      gatewayPlaceholder: '192.168.10.1',
      routeDescription: 'Description',
      routeDescriptionPlaceholder: 'Réseau interne client',
      noRoutes: 'Aucune route configurée',
      deleteRoute: 'Supprimer la route',
      applyRoutes: 'Appliquer les routes',
      routeAdded: 'Route ajoutée avec succès',
      routeDeleted: 'Route supprimée',
      routesApplied: 'Routes appliquées',
      invalidCidr: 'Format CIDR invalide',
      invalidGateway: 'Adresse IP invalide',
      active: 'Active',
      inactive: 'Inactive'
    },

    // Network Topology
    topology: {
      title: 'Topologie Réseau',
      server: 'Serveur Sylink',
      internet: 'Internet',
      vpnGateway: 'Passerelle VPN',
      clientNetwork: 'Réseau Client',
      online: 'En ligne',
      offline: 'Hors ligne',
      activeRoutes: 'Routes actives',
      totalRoutes: 'Routes totales',
      networkGateway: 'Passerelle Réseau',
      subnetsCount: '{{count}} sous-réseaux'
    },

    // Messages
    messages: {
      configUploaded: 'Configuration VPN téléversée',
      configDeleted: 'Configuration VPN supprimée',
      connectionSuccess: 'VPN connecté avec succès',
      connectionFailed: 'Échec de la connexion VPN',
      disconnectionSuccess: 'VPN déconnecté',
      disconnectionFailed: 'Échec de la déconnexion VPN',
      saveError: 'Erreur lors de l\'enregistrement',
      deleteError: 'Erreur lors de la suppression',
      connectError: 'Erreur de connexion VPN',
      disconnectError: 'Erreur de déconnexion VPN'
    },
    // Panel strings
    loadingWorkspaces: 'Chargement des workspaces...',
    noWorkspace: 'Aucun workspace',
    noWorkspaceAvailable: 'Aucun workspace disponible',
    noVpnFoundFor: 'Aucun VPN trouvé pour "{query}"',
    deleteStoredCredentialsTitle: 'Supprimer les identifiants enregistrés',
    saveCredentialsSecurely: 'Enregistrer les identifiants de façon sécurisée',
    saveCredentialsNow: 'Enregistrer maintenant',
    noVpnAvailable: 'Aucune configuration VPN disponible',
    loadingConfigs: 'Chargement des configurations VPN...'
  },

  // Phishing Simulation
  phishing: {
    title: 'Simulation de Phishing',
    subtitle: 'Testez la sensibilisation à la sécurité des employés avec des campagnes de phishing simulées',
    campaignsTab: 'Campagnes',
    templatesTab: 'Modèles',
    targetsTab: 'Groupes cibles',
    analyticsTab: 'Statistiques',
    settingsTab: 'Paramètres',
    totalCampaigns: 'Total des campagnes',
    emailsSent: 'Emails envoyés',
    clickRate: 'Taux de clic',
    reportRate: 'Taux de signalement',
    recentCampaigns: 'Campagnes récentes',
    newCampaign: 'Nouvelle campagne',
    campaignName: 'Nom de la campagne',
    status: 'Statut',
    sent: 'Envoyés',
    opened: 'Ouverts',
    clicked: 'Cliqués',
    reported: 'Signalés',
    actions: 'Actions',
    viewDetails: 'Voir les détails',
    emailTemplates: 'Modèles d\'emails',
    createTemplate: 'Créer un modèle',
    targetGroups: 'Groupes cibles',
    createGroup: 'Créer un groupe',
    groupName: 'Nom du groupe',
    members: 'Membres',
    lastUsed: 'Dernière utilisation',
    edit: 'Modifier',
    delete: 'Supprimer',
    analyticsOverview: 'Vue d\'ensemble des analytiques',
    clickRateTrend: 'Tendance du taux de clic',
    reportRateTrend: 'Tendance du taux de signalement',
    chartPlaceholder: 'Le graphique s\'affichera ici',
    departmentComparison: 'Comparaison par département',
    settings: 'Paramètres du Phishing',
    smtpConfig: 'Configuration SMTP',
    smtpServer: 'Serveur SMTP',
    smtpPort: 'Port SMTP',
    trackingSettings: 'Paramètres de suivi',
    trackOpens: 'Suivre les ouvertures d\'emails',
    trackClicks: 'Suivre les clics sur les liens',
    trackSubmissions: 'Suivre les soumissions d\'identifiants',
    saveSettings: 'Enregistrer les paramètres',
    reference: 'Référence',
    statusCompleted: 'Terminé',
    statusActive: 'Active',
    statusScheduled: 'Planifiée',
    statusCancelled: 'Annulée',
    statusDraft: 'Brouillon',
    categoryCredentialHarvest: 'Collecte d\'identifiants',
    categoryLinkClick: 'Clic sur lien',
    categoryAttachment: 'Pièce jointe'
  },

  // Sankey Analysis
  sankey: {
    title: 'Diagramme de Flux de Sécurité',
    clickForAiAnalysis: 'Cliquez sur un élément pour l\'analyse IA',
    exploitable: 'Exploitable',
    nonExploitable: 'Non exploitable',
    columns: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      assets: 'Actifs',
      vulnerabilities: 'Vulnérabilités',
      exploitability: 'Exploitabilité',
      cve: 'CVE'
    },
    legend: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      critical: 'Critique',
      nonExploitable: 'Non exploit.'
    },
    severity: {
      critical: 'Critiques',
      high: 'Hautes',
      medium: 'Moyennes',
      low: 'Faibles'
    },
    analysis: {
      model: 'Modèle',
      changeModel: 'Analyser avec un autre LLM',
      selectModel: 'Sélectionner un modèle LLM',
      regenerateWith: "Régénérer l'analyse avec un autre modèle",
      recommended: 'Recommandé',
      regenerate: "Régénérer l'analyse"
    },
    noScansAvailable: 'Aucun scan disponible pour la visualisation',
    scansLabel: 'scans',
    hostsLabel: 'hôtes',
    portsLabel: 'ports',
    occurrences: 'occurrence(s)',
    tooltip: {
      element: 'Élément',
      scansHostsVulns: '{scans} scans • {hosts} hôtes • {vulns} vulnérabilités',
      ipHostsVulns: '{ip} • {hosts} hôtes • {vulns} vulnérabilités',
      vulnsCount: '{count} vulnérabilités',
      clickForAi: "Cliquez pour l'analyse IA"
    },
    stats: {
      workspaces: 'Espaces clients',
      targets: 'Cibles',
      assets: 'Actifs',
      vulnerabilities: 'Vulnérabilités',
      exploitable: 'Exploitable'
    }
  },

  // LLM Monitor
  llmMonitor: {
    title: 'Orchestrateur LLM',
    subtitle: 'Gestion et supervision des modèles avec accélération GPU',
    gpuStatus: 'Statut GPU',
    vram: 'VRAM',
    utilization: 'Utilisation',
    load: 'Charger',
    loaded: 'Chargé',
    noTarget: 'Aucune cible',
    entries: 'entrées',
    vulnerabilities: 'vulnérabilités',
    credentials: 'identifiants',
    poolStatus: 'Statut du Pool GPU',
    servers: 'serveurs',
    moreModels: 'de plus',
    orchestratorMetrics: 'Métriques de l\'Orchestrateur',
    totalRequests: 'Requêtes Totales',
    modelSwaps: 'Échanges de Modèle',
    avgSwapTime: 'Temps Moy. Échange',
    inferences: 'Inférences',
    connected: 'Connecté',
    disconnected: 'Déconnecté',
    refresh: 'Actualiser',
    availableModels: 'Modèles Disponibles',
    activeSessions: 'Sessions Actives',
    noActiveSessions: 'Aucune session active',
    noSessionsHint: 'Les sessions LLM utilisent l\'intelligence artificielle pour analyser automatiquement les vulnérabilités, générer des rapports et coordonner les tests de pénétration.',
    noSessionsAction: 'Démarrer une session',
    readyStatus: 'Prêt à démarrer',
    howToStart: 'Lancez un scan pour démarrer une session LLM',
    waitingForScan: 'En attente d\'un scan',
    quickActions: 'Actions Rapides',
    newSession: 'Nouvelle Session',
    requestCheckpoint: 'Demander un Checkpoint',
    hashcatTasks: 'Tâches Hashcat',
    loadStatusFailed: 'Échec du chargement du statut LLM',
    loadingModel: 'Chargement de {{model}}...',
    swapFailed: 'Échec du changement de modèle',
    noModel: 'Aucun',
    online: 'En ligne',
    offline: 'Hors ligne',
    serviceUnavailable: 'Service LLM indisponible'
  },

  // Tool Categories (for ToolsList)
  toolCategories: {
    reconnaissance: 'Reconnaissance',
    web: 'Scan Web',
    cms: 'Scanners CMS',
    vulnerabilities: 'Scanners de Vulnérabilités',
    bruteforce: 'Force Brute',
    ad: 'Active Directory',
    ldap: 'LDAP / LDAPS',
    services: 'Énumération de Services',
    osint: 'Renseignement en sources ouvertes (OSINT)',
    suites: 'Suites de Sécurité',
    ssl: 'SSL/TLS',
    ot: 'OT/ICS/SCADA',
    iot: 'Appareils IoT',
    pivoting: 'Pivoting & Tunneling',
    privesc: 'Élévation de Privilèges',
    evasion: 'Évasion & Contournement',
    supply_chain: 'Sécurité Supply Chain',
    network_attack: 'Attaques Réseau',
    firewall: 'Box / Pare-feu / Routeur',
    vpn: 'Sécurité VPN',
    cloud: 'Sécurité Cloud',
    other: 'Autres'
  },

  // OSINT translations (used by ScansList.jsx translateScanType)
  osint: {
    scanTypes: {
      virustotal: 'VirusTotal',
      headers: 'En-têtes de sécurité',
      security_headers: 'En-têtes de sécurité',
      email_security: 'Sécurité e-mail',
      geoip: 'Géolocalisation IP',
      reverse_ip: 'IP inversée',
      full: 'Scan complet',
      domain: 'Domaine',
      ip: 'Adresse IP',
      url: 'URL',
      network_discovery: 'Découverte réseau',
      vulnerability_scan: 'Scan de vulnérabilités',
      full_autonomous: 'Autonome complet',
      full_auto: 'Autonome complet',
      full_automation: 'Autonome complet',
      expert: 'Scan expert',
      api_pentest: 'Pentest API',
      iot_scan: 'Scan objets connectés',
      ot_scan: 'Scan OT/SCADA',
      ad_pentest: 'Pentest AD',
      ad_scan: 'Scan Active Directory',
      ad_recon: 'Reconnaissance AD',
      ad_full: 'Scan AD complet',
      ldap_scan: 'Scan LDAP',
      kerberos_scan: 'Scan Kerberos',
      web_scan: 'Scan Web',
      web: 'Scan Web',
      quick: 'Rapide',
      quick_scan: 'Scan rapide',
      discovery: 'Découverte',
      enumeration: 'Énumération',
      vulnerability: 'Vulnérabilités',
      exploitation: 'Exploitation',
      passive: 'Passif',
      aggressive: 'Agressif',
      credentials: 'Identifiants',
      recon: 'Reconnaissance',
      exploit: 'Exploitation',
      bypass: 'Contournement',
      nmap: 'Scan Nmap',
      nikto: 'Scan Nikto',
      internal: 'Scan interne',
      external: 'Scan externe',
      network: 'Scan réseau',
      // OWASP/ZAP related scan types
      owasp: 'Scan OWASP',
      owasp_scan: 'Scan OWASP',
      owasp_top10: 'OWASP Top 10',
      owasp_top_10: 'OWASP Top 10',
      zap: 'Scan ZAP',
      zap_scan: 'Scan ZAP',
      owasp_zap: 'Scan OWASP ZAP',
      // Additional scan types
      sqlmap: 'Scan SQLMap',
      openvas: 'Scan OpenVAS',
      nuclei: 'Scan Nuclei',
      metasploit: 'Scan Metasploit',
      hydra: 'Test Hydra',
      wpscan: 'Scan WordPress',
      gobuster: 'Scan Gobuster',
      pentest: 'Pentest',
      stealth: 'Scan furtif',
      full_scan: 'Scan complet',
      standard: 'Standard'
    }
  },

  // Severity levels (used across components)
  severity: {
    critical: 'Critique',
    high: 'Élevée',
    medium: 'Moyenne',
    low: 'Faible',
    info: 'Info'
  },

  // Agents
  agents: {
    title: 'Agents',
    subtitle: 'Agents de scan déployés sur les réseaux internes',
    loading: 'Chargement des agents...',
    register: 'Enregistrer',
    registerAgent: 'Enregistrer un Agent',
    downloadInstaller: 'Télécharger l\'installateur',
    searchPlaceholder: 'Rechercher un agent...',
    noAgentsFound: 'Aucun agent trouvé',
    noAgentsRegistered: 'Aucun agent enregistré',
    noAgentsFoundHint: 'Modifiez votre recherche ou enregistrez un nouvel agent',
    noAgentsRegisteredHint: 'Déployez un agent sur un réseau client pour scanner les cibles internes sans VPN',
    loadError: 'Erreur lors du chargement des agents',
    deleteConfirm: 'Supprimer l\'agent "{name}" ?',
    // Table columns
    colAgent: 'Agent',
    colStatus: 'Status',
    colHostname: 'Hostname',
    colInternalIp: 'IP Interne',
    colLastSeen: 'Dernière connexion',
    colMetrics: 'Métriques',
    colActions: 'Actions',
    never: 'Jamais',
    details: 'Détails',
    delete: 'Supprimer',
    // Stats
    statTotal: 'Total',
    statOnline: 'En ligne',
    statOffline: 'Hors ligne',
    statBusy: 'Occupés',
    // AgentDetails
    loadingAgent: 'Chargement de l\'agent...',
    agentNotFound: 'Agent introuvable',
    backToAgents: 'Retour aux agents',
    pingAgent: 'Ping',
    pinging: 'Ping...',
    systemCard: 'Système',
    networkCard: 'Réseau',
    registeredCard: 'Enregistré',
    tunnelActive: 'Tunnel actif',
    polling: 'Polling',
    avg24h: 'moy. 24h',
    recentTasks: 'Tâches récentes',
    noTasksExecuted: 'Aucune tâche exécutée'
  },

  // Equipment types (for EquipmentDashboard)
  equipmentTypes: {
    deleteConfirm: 'Voulez-vous vraiment supprimer cet équipement ?',
    launchAttack: 'Lancer une attaque',
    validateDetection: 'Valider la détection',
    deleteEquipment: 'Supprimer',
    deleted: 'Équipement supprimé',
    validationError: 'Erreur lors de la validation',
    deleteError: 'Erreur lors de la suppression',
    categories: {
      server: 'Serveur',
      workstation: 'Poste de travail',
      network: 'Réseau',
      security: 'Sécurité',
      iot: 'IoT',
      ot_ics: 'OT/ICS',
      mobile: 'Mobile',
      cloud: 'Cloud',
      container: 'Conteneur',
      database: 'Base de données',
      web_application: 'Application Web',
      printer: 'Imprimante',
      storage: 'Stockage',
      voip: 'VoIP',
      other: 'Autre'
    }
  },

  // Sessions (extra keys for SessionDetails/SessionsList)
  sessionsExtra: {
    sessionNotFound: 'Session non trouvée',
    privescConfirm: 'Lancer une tentative de privilege escalation?',
    validateForReport: 'Valider pour rapport',
    chainNames: {
      full_recon: 'Reconnaissance Complète',
      cred_harvest: 'Récolte de Credentials',
      pivot_recon: 'Découverte Pivot',
      safe_migrate: 'Migration Sécurisée'
    },
    aptModules: 'Modules APT (Menace Persistante Avancée)',
    modulesAvailable: 'modules disponibles'
  },

  // NetworkMap extra keys
  networkMap: {
    launchOwaspAnalysis: 'Services web - Lancer analyse OWASP',
    launchSimulation: 'Lancer Simulation'
  },

  // ScanDetails extra keys
  scanDetails: {
    viewScanConfig: 'Voir la configuration du scan',
    downloadPdfReport: 'Télécharger le rapport PDF',
    pdfReport: 'Rapport PDF',
    relaunch: 'Relancer',
    relaunchScan: 'Relancer ce scan avec les mêmes paramètres',
    schedule: 'Programmer',
    scheduleScan: 'Programmer ce scan',
    refresh: 'Rafraîchir',
    vpnConnectionRequired: 'Connexion VPN requise',
    vpnConnectionRequired2: 'Ce scan nécessite une connexion VPN pour accéder au réseau interne',
    vpnConnectInstructions: 'Veuillez vous connecter au VPN configuré pour ce workspace, puis relancez le scan ou attendez que la connexion soit établie.',
    configureVpn: 'Configurer le VPN',
    viewWorkspaces: 'Voir les Workspaces',
    vpnConnection: 'Connexion VPN',
    scanServer: 'Serveur de Scan',
    vpnActive: 'VPN Actif',
    directConnection: 'Connexion Directe',
    vpnServer: 'Serveur VPN',
    hostsDiscovered: 'Hôtes Découverts',
    hostsDiscoveredDesc: 'Nombre total de machines (serveurs, équipements réseau, postes de travail) découvertes et accessibles sur le périmètre scanné. Chaque hôte représente une surface d\'attaque potentielle.',
    totalVulnerabilities: 'Total Vulnérabilités',
    totalVulnerabilitiesDesc: 'Nombre total de failles de sécurité (CVE) identifiées sur l\'ensemble des hôtes. Chaque CVE représente une vulnérabilité connue et documentée pouvant être exploitée par un attaquant.',
    criticalVulnerabilities: 'Vulnérabilités Critiques',
    criticalVulnerabilitiesDesc: 'CVSS 9.0-10.0 : Failles permettant une compromission totale du système (exécution de code à distance, élévation de privilèges root). Action immédiate requise.',
    immediateActionRequired: 'Action immédiate requise.',
    scanConfiguration: 'Configuration du scan',
    target: 'Cible',
    scanType: 'Type de scan',
    createdAt: 'Créé le',
    intensity: 'Intensité',
    queueHowItWorks: 'Comment fonctionne la file d\'attente\u202F?',
    queueOrdered: 'Les scans sont traités dans l\'ordre d\'arrivée avec une priorité selon votre plan',
    queueAutoUpdate: 'Cette page se met à jour automatiquement - restez ici ou revenez plus tard',
    queueAutoStart: 'Le scan démarrera automatiquement dès qu\'une ressource sera disponible',
    accelerateScans: 'Accélérez vos scans',
    accelerateDesc: 'Pour des temps d\'attente réduits et des scans prioritaires, plusieurs options s\'offrent à vous\u202F:',
    proPlanOption: 'Plan Pro ou Enterprise',
    proPlanDesc: 'Bénéficiez d\'une priorité plus élevée dans la file d\'attente et de temps d\'attente réduits',
    dedicatedServer: 'Serveur dédié',
    dedicatedServerDesc: 'Scans instantanés sans file d\'attente - vos propres ressources dédiées',
    viewPlans: 'Voir les plans',
    noVulnDetected: 'Aucune vulnérabilité détectée',
    showTop5: 'Afficher les 5 plus graves',
    showAll: 'Afficher tout',
    viewAll: 'Voir tout',
    viewDetails: 'Voir les détails',
    showingTop5: 'Affichage des 5 vulnérabilités {sortType} sur {total} au total',
    bySeverity: 'les plus graves',
    byDate: 'les plus récentes',
    capturedOn: 'Capturé le',
    imageLoadError: 'Erreur de chargement de l\'image',
    autoGenerateReport: 'Générer automatiquement le rapport',
    selectReportFormats: 'Sélectionnez le(s) format(s) de rapport à générer',
    reportFormats: 'Formats de rapport',
    reduceList: '← Réduire la liste',
    showMoreHosts: 'Voir les {count} autres hôtes →',
    stopScanConfirm: 'Êtes-vous sûr de vouloir arrêter ce scan\u202F?',
    deleteScanConfirm: 'Êtes-vous sûr de vouloir supprimer ce scan\u202F?',
    retryScanConfirm: 'Relancer ce scan avec les mêmes paramètres\u202F?',
    stopScanFailed: 'Échec de l\'arrêt du scan',
    deleteScanFailed: 'Échec de la suppression du scan',
    cleanupFailed: 'Échec du nettoyage',
    immediatePatching: 'Patching immédiat',
    immediatePatchingDesc: 'Appliquer les correctifs de sécurité pour les vulnérabilités critiques et hautes identifiées.',
    reduceAttackSurface: 'Réduction de la surface d\'attaque',
    reduceAttackSurfaceDesc: 'Fermer les ports non essentiels et limiter l\'exposition des services.',
    updateComponents: 'Mise à jour des composants',
    updateComponentsDesc: 'Mettre à jour les logiciels vulnérables vers leurs dernières versions sécurisées.',
    continuousMonitoring: 'Surveillance continue',
    continuousMonitoringDesc: 'Mettre en place une surveillance des logs et alertes pour détecter toute activité suspecte.',
    noCriticalVulnsDetected: 'Aucune vulnérabilité critique détectée',
    majorityLowSeverity: 'Majorité de vulnérabilités de faible sévérité',
    fullCoverageMultipleTools: 'Couverture complète avec multiples outils d\'analyse',
    automatedScanFastDetection: 'Scan automatisé permettant une détection rapide',
    aiAssistedReport: 'Rapport généré avec assistance IA pour analyse approfondie',
    implementSecurityRecommendations: 'Implémenter les recommandations de sécurité',
    strengthenNetworkSegmentation: 'Renforcer la segmentation réseau',
    vulnManagementProgram: 'Programme de gestion des vulnérabilités',
    regularSecurityAudits: 'Audits de sécurité réguliers',
    securityAwarenessTraining: 'Formation sensibilisation sécurité',
    hostsLabel: 'Hôtes',
    vulnerabilitiesLabel: 'Vulnérabilités',
    criticalLabel: 'Critiques',
    highLabel: 'Hautes',
    mediumLabel: 'Moyennes',
    lowLabel: 'Basses',
    highVulnsDesc: 'CVSS 7.0-8.9 : Failles pouvant entraîner un accès non autorisé ou une fuite de données sensibles. Correction prioritaire recommandée.',
    mediumVulnsDesc: 'CVSS 4.0-6.9 : Failles nécessitant des conditions spécifiques pour être exploitées. À corriger dans un délai raisonnable.',
    lowVulnsDesc: 'CVSS 0.1-3.9 : Failles à impact limité, souvent informatives ou nécessitant un accès préalable. À traiter lors des maintenances planifiées.',
    duration: 'Durée',
    remainingTime: 'Restant',
    aiModel: 'IA',
    capturesResults: 'Captures & Résultats',
    restartScanFailed: 'Échec du redémarrage du scan',
    runningScheduledScans: 'Scans en cours / planifiés',
    runningScansSection: 'Scans en cours',
    scheduledScansSection: 'Scans planifiés',
    identifiedCves: 'CVE identifiées',
    detailedVulnerabilities: 'Vulnérabilités détaillées',
    remediationRecommendations: 'Recommandations de remédiation',
    recPriorityUrgent: 'URGENT',
    recPriorityPriority: 'PRIORITAIRE',
    recPriorityRecommended: 'RECOMMANDÉ',
    scheduleNext: 'Prochain',
    scheduleAt: 'à',
    freeToSchedule: 'Vous pouvez programmer librement',
    executionTime: 'Heure d\'exécution',
    timezoneEuropeParis: 'Fuseau horaire : Europe/Paris',
    limitExecutions: 'Limiter le nombre d\'exécutions',
    autoStopAfterDesc: 'Arrêt automatique après X scans',
    endAfter: 'Fin après',
    executionsUnit: 'exécution(s)',
    summaryLabel: 'Résumé',
    noDaySelected: 'aucun jour sélectionné',
    schedulePrefix: 'Le scan s\'exécutera',
    scheduleSummaryWeekly: 'chaque semaine ({days})',
    scheduleSummaryMonthly: 'tous les mois (1er {day})',
    scheduleSummaryQuarterly: 'tous les 3 mois (1er {day})',
    scheduleSummarySemestrial: 'tous les 6 mois (1er {day})',
    scheduleSummaryYearly: 'tous les ans (1er {day})',
    forNExecutions: 'pendant {count} exécution(s)',
    reportsLabel: 'Rapport(s)',
    scheduleRunRule: 'Le scan s\'exécutera le premier {day} {period}',
    freqEveryMonth: 'tous les mois',
    freqEveryQuarter: 'tous les trimestres',
    freqEvery6Months: 'tous les 6 mois',
    freqEveryYear: 'tous les ans',
    daysOfWeek: {
      sunday: 'Dimanche',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi'
    },
    daysOfWeekShort: {
      sun: 'Dim',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mer',
      thu: 'Jeu',
      fri: 'Ven',
      sat: 'Sam'
    },
    daysOfWeekMini: {
      sun: 'Di',
      mon: 'Lu',
      tue: 'Ma',
      wed: 'Me',
      thu: 'Je',
      fri: 'Ve',
      sat: 'Sa'
    },
    daysOfTheWeekLabel: 'Jours de la semaine',
    dayOfTheWeekLabel: 'Jour de la semaine',
    frequencyLabel: 'Fréquence',
    scheduleThisScan: 'Programmer ce scan',
    configureRecurrence: 'Configurer la récurrence pour relancer automatiquement ce scan sur {target}',
    detectedServices: 'Services détectés',
    discoveredHosts: 'Hôtes découverts',
    manageAllVulnerabilities: 'Gérer toutes les vulnérabilités →',
    aiFeedback: 'Retour sur l\'IA',
    aiFeedbackDesc: 'Aidez-nous à améliorer les résultats de l\'IA en expliquant ce qui n\'est pas correct.',
    executiveReportDesc: 'Ce rapport exécutif a été automatiquement généré par notre IA de cybersécurité {brand}. Elle analyse en profondeur les résultats du scan pour identifier les risques critiques, évaluer l\'impact métier, et fournir des recommandations actionnables adaptées à votre contexte.',
    modelLabel: 'Modèle',
    alertExploitedVulns: '⚠️ ALERTE : Vulnérabilités exploitées confirmées',
    aiConfirmedExploitation: 'L\'IA a confirmé l\'exploitation réussie de {count} vulnérabilité(s).',
    immediateRiskFlaws: 'Ces failles représentent un risque immédiat et nécessitent une action d\'urgence.',
    generalInformation: 'Informations générales',
    networkMode: 'Mode réseau',
    vpnConfiguration: 'Configuration VPN',
    artificialIntelligence: 'Intelligence artificielle',
    aiModelLabel: 'Modèle IA',
    analysisDepth: 'Profondeur d\'analyse',
    assistanceMode: 'Mode assistance',
    activeAiAnalysis: 'Analyse IA active',
    enabledTools: 'Outils activés',
    securityOptions: 'Options de sécurité',
    safeMode: 'Mode sûr',
    evasion: 'Évasion',
    simulationMode: 'Mode simulation',
    darkWebSearch: 'Recherche Dark Web',
    severityFilters: 'Filtres de sévérité',
    nameLabel: 'Nom',
    targetLabel: 'Cible',
    scanTypeLabel: 'Type de scan',
    unnamed: 'Sans nom',
    userLabel: 'Utilisateur',
    configurationLabel: 'Configuration',
    queuedStatus: 'En file d\'attente',
    impactIdentified: 'Impact identifié',
    excludedFromReport: 'Exclu du rapport',
    analyzeWithAI: 'Analyser avec l\'IA',
    networkScanMode: 'Mode de scan réseau',
    networkScanModeDesc: 'Choisissez la manière dont le trafic du scan sera routé. Pour les réseaux internes, utilisez VPN Client-to-Site.',
    scanSpeed: 'Vitesse du scan',
    timingDesc: {
      paranoidLabel: 'Paranoïaque',
      paranoidDesc: 'Très lent',
      sneakyLabel: 'Furtif',
      sneakyDesc: 'Lent',
      normalLabel: 'Normal',
      normalDesc: 'Équilibré',
      aggressiveLabel: 'Agressif',
      aggressiveDesc: 'Rapide',
      insaneLabel: 'Extrême',
      insaneDesc: 'Très rapide'
    },
    osDetectionTitle: 'Détection OS',
    osDetectionDesc: 'Identifier les systèmes d\'exploitation',
    serviceDetectionTitle: 'Détection des services',
    serviceDetectionDesc: 'Détecter les versions des services',
    scriptScanTitle: 'Scan par scripts',
    scriptScanDesc: 'Exécuter les scripts NSE',
    aggressiveModeTitle: 'Mode agressif',
    aggressiveModeDesc: 'Activer toutes les fonctionnalités de détection',
    advancedOptionsTitle: 'Options avancées',
    advancedOptionsDesc: 'Ces options peuvent impacter les performances et la détectabilité du scan. À utiliser avec précaution.',
    scanConfigSummary: 'Récapitulatif de la configuration du scan',
    basicConfig: 'Configuration de base',
    scanOptionsLabel: 'Options du scan',
    maxRetries: 'Tentatives max',
    timeoutLabel: 'Timeout',
    excludedHosts: 'Hôtes exclus',
    estimatedDuration: 'Durée estimée',
    estDurationDiscovery: 'Environ 5-15 minutes selon la taille du réseau',
    estDurationVulnScan: 'Environ 30-60 minutes selon les cibles',
    estDurationFullAutonomous: 'Environ 1-2 heures pour une évaluation complète',
    enabledLabel: 'Activé',
    disabledLabel: 'Désactivé',
    portsCommon: 'Courants',
    portsAll: 'Tous',
    modeLabelInline: 'Mode',
    speedLabelInline: 'Vitesse',
    selectedLabel: 'Sélectionné',
    iot: {
      defaultCreds: 'Identifiants par défaut',
      vulnerable: 'Vulnérable',
      vendorLabel: 'Fournisseur',
      openPortsLabel: 'Ports ouverts',
      unknownDevice: 'Appareil inconnu',
      loadingScanDetails: 'Chargement des détails du scan IoT…',
      backToScans: 'Retour aux scans',
      couldNotLoad: 'Le scan IoT n\'a pas pu être chargé.',
      tabOverview: 'Vue d\'ensemble',
      tabDevices: 'Appareils',
      tabVulnerabilities: 'Vulnérabilités',
      scanProgress: 'Progression du scan',
      riskAssessment: 'Évaluation du risque',
      overallRiskDesc: 'Risque global de sécurité basé sur les vulnérabilités découvertes',
      riskScore: 'Score de risque',
      scanInformation: 'Informations sur le scan',
      targetLabel: 'Cible',
      scanTypeLabel: 'Type de scan',
      protocolsLabel: 'Protocoles',
      createdLabel: 'Créé',
      startedLabel: 'Démarré',
      completedLabel: 'Terminé',
      deviceTypes: 'Types d\'appareils',
      noDevicesFound: 'Aucun appareil trouvé',
      vulnDistributionBySeverity: 'Répartition des vulnérabilités par sévérité',
      noIoTDevicesFound: 'Aucun appareil IoT trouvé',
      noIoTDevicesDesc: 'Le scan n\'a découvert aucun appareil IoT sur le réseau cible.',
      noVulnsFound: 'Aucune vulnérabilité trouvée',
      noVulnsFoundDesc: 'Le scan n\'a identifié aucune vulnérabilité de sécurité.'
    },
    freqLabel: {
      daily: 'Quotidien',
      weekly: 'Hebdomadaire',
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      semestrial: 'Semestriel',
      yearly: 'Annuel'
    },
    reportFormatLabels: {
      pentest: 'Rapport de pentest',
      remediation: 'Remédiation',
      comex: 'Comex',
      cveJson: 'JSON CVE',
      pentestShort: 'Pentest',
      remediationShort: 'Remédiation',
      comexShort: 'Comex',
      cveJsonShort: 'JSON CVE'
    }
  },

  // Subdomains
  subdomains: {
    title: 'Subdomain Discovery',
    description: 'Découvrez les sous-domaines et lancez des attaques automatisées',
    searchTitle: 'Recherche de Sous-domaines',
    domainPlaceholder: 'exemple.com',
    scanning: 'Scan...',
    quickScan: 'Scan rapide',
    fullScan: 'Scan complet',
    toolsLabel: 'Outils utilisés par le scan complet',
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
    discoveryError: 'Erreur lors de la découverte de sous-domaines',
    networkError: 'Erreur réseau. Vérifiez votre connexion.',
    enterDomain: 'Veuillez entrer un domaine',
    selectAtLeastOne: 'Sélectionnez au moins un sous-domaine',
    subdomainsDiscovered: '{count} sous-domaines découverts',
    savedToWorkspace: ' — enregistré dans l\'espace de travail',
    totalDiscovered: 'Total découverts',
    active: 'Actifs (résolvables)',
    selected: 'Sélectionnés',
    duration: 'Durée',
    selectAllActive: 'Sélectionner tous les actifs',
    deselectAll: 'Tout désélectionner',
    scanSelected: 'Scanner la sélection ({count})',
    attacking: 'Attaque...',
    scansLaunched: '{count} scan(s) lancé(s) sur les sous-domaines sélectionnés',
    discoveredSubdomains: 'Sous-domaines découverts',
    noAliveSubdomains: 'Aucun sous-domaine actif trouvé',
    noAliveSubdomainsDesc: 'Ce domaine n\'a peut-être pas de sous-domaines publiquement indexés',
    resultsByTool: 'Résultats par outil',
    emptyStateTitle: 'Subdomain Discovery',
    emptyStateDesc: 'Entrez un domaine ci-dessus pour découvrir tous ses sous-domaines.',
    quickScanHint: 'pour une recherche rapide avec Subfinder,',
    fullScanHint: 'pour une recherche approfondie.',
    configurableTools: 'Outils configurables : Subfinder, Amass, DNSRecon, Résolution IP',
    dataFromWorkspace: 'Données chargées depuis l\'espace de travail',
    rerunToRefresh: '— Relancez un scan pour actualiser',
    enrichedResultsSaved: 'Résultats enrichis enregistrés dans l\'espace de travail',
    quickDiscoveryError: 'Erreur lors de la découverte rapide'
  },

  // AI Agent
  aiAgent: {
    configTitle: 'Configuration de l\'Agent',
    configSubtitle: 'Ajustez les seuils et comportements de l\'agent IA',
    reset: 'Réinitialiser',
    save: 'Sauvegarder',
    generalSettings: 'Paramètres généraux',
    agentActive: 'Agent actif',
    automaticMonitoring: 'Surveillance automatique',
    autoRecovery: 'Auto-récupération',
    automaticRecovery: 'Récupération automatique',
    dailyReport: 'Rapport quotidien',
    summaryEmail: 'E-mail de résumé',
    alertThresholds: 'Seuils d\'alerte',
    alert: 'Alerte',
    critical: 'Critique',
    memory: 'Mémoire',
    disk: 'Disque',
    intervals: 'Intervalles',
    monitoringSeconds: 'Monitoring (secondes)',
    aiAnalysisSeconds: 'Analyse IA (secondes)',
    healthCheckSeconds: 'Health Check (secondes)',
    scanSettings: 'Paramètres de scan',
    scanTimeoutMin: 'Timeout Scan (minutes)',
    maxConcurrentScans: 'Scans simultanés max',
    errorRateThreshold: 'Taux d\'erreur seuil (/h)',
    alerts: 'Alertes',
    alertEmail: 'E-mail d\'alerte',
    maxAlertsHour: 'Alertes max/heure',
    deduplication: 'Déduplication (minutes)',
    aiModels: 'Modèles IA',
    primaryModel: 'Modèle principal',
    strategicModel: 'Modèle stratégique',
    technicalModel: 'Modèle technique',
    codeModel: 'Modèle code',
    dailyReportSettings: 'Rapport quotidien',
    sendTime: 'Heure d\'envoi',
    utcNote: '0-23 (heure UTC)',
    recipients: 'Destinataires (un par ligne)',
    conversationHistory: 'Historique des conversations IA',
    noConversations: 'Aucune conversation',
    selectConversation: 'Sélectionnez une conversation',
    configSaved: 'Configuration sauvegardée',
    configSaveError: 'Erreur lors de la sauvegarde',
    configReset: 'Configuration réinitialisée',
    configResetError: 'Erreur lors de la réinitialisation',
    configResetConfirm: 'Réinitialiser la configuration par défaut ?',
    deleteConversationConfirm: 'Supprimer cette conversation ?',
    conversationDeleted: 'Conversation supprimée',
    conversationDeleteError: 'Erreur lors de la suppression',
    loadMessagesError: 'Erreur lors du chargement des messages',
    untitledConversation: 'Conversation sans titre',
    modelsTitle: 'Modèles IA (Ollama)',
    modelsSubtitle: 'Statut des modèles LLM utilisés par l\'agent',
    ollamaOnline: 'En ligne',
    ollamaStopped: 'Arrêté',
    ollamaError: 'Erreur',
    vramAvailable: 'Mémoire disponible pour les modèles',
    defaultModel: 'Modèle par défaut',
    availableModels: 'Modèles disponibles',
    loaded: 'Chargé',
    available: 'Disponible',
    notAvailable: 'Non disponible',
    noModelsDetected: 'Aucun modèle détecté',
    usageStats: 'Statistiques d\'utilisation ({period})',
    totalRequests: 'Total requêtes',
    tokensUsed: 'Tokens utilisés',
    requestsByModel: 'Requêtes par modèle',
    avgLatency: 'Latence moyenne (ms)',
    testModel: 'Tester',
    modelError: 'Erreur : {error}',
    testError: 'Erreur lors du test',
    loadModelsError: 'Erreur lors du chargement des modèles',
    actionsTitle: 'Historique des Actions',
    actionsSubtitle: 'Actions exécutées par l\'agent IA',
    totalActions: 'Total Actions',
    successful: 'Réussies',
    failed: 'Échouées',
    successRate: 'Taux de réussite',
    actionsByType: 'Actions par type',
    noActionsRecorded: 'Aucune action enregistrée',
    filterType: 'Type',
    filterCategory: 'Catégorie',
    filterResult: 'Résultat',
    all: 'Tous',
    allCategories: 'Toutes',
    succeeded: 'Réussi',
    loadActionsError: 'Erreur lors du chargement des actions',
    metricsTitle: 'Métriques système',
    noData: 'Pas de données',
    loadMetricsError: 'Erreur lors du chargement des métriques',
    incidentsTitle: 'Incidents',
    incidentsSubtitle: 'Incidents détectés par l\'agent IA',
    acknowledge: 'Accuser réception',
    resolve: 'Résoudre',
    retryRecovery: 'Relancer la récupération',
    incidentAcknowledged: 'Incident accusé de réception',
    incidentResolved: 'Incident résolu',
    recoveryRelaunched: 'Récupération relancée',
    loadIncidentsError: 'Erreur lors du chargement des incidents',
    noIncidents: 'Aucun incident',
    filterSeverity: 'Sévérité',
    filterStatus: 'Statut',
    allSeverities: 'Toutes',
    allStatuses: 'Tous'
  },

  // Orchestrator
  orchestrator: {
    title: 'Orchestrateur IA',
    subtitle: 'Moteur intelligent d\'exploitation et d\'analyse autonome',
    active: 'ACTIF',
    inactive: 'INACTIF',
    disable: 'Désactiver',
    enable: 'Activer (Mode Sûr)',
    enableSafe: 'Activer',
    retry: 'Réessayer',
    connectionError: 'Erreur de connexion à l\'orchestrateur',
    serviceUnavailable: 'Service temporairement indisponible. Veuillez réessayer.',
    stateChangeError: 'Erreur lors du changement d\'état de l\'orchestrateur',
    activeScans: 'Scans actifs',
    aiDecisions: 'Décisions IA',
    aiModels: 'Modèles IA',
    minConfidence: 'Confiance min.',
    loadedModels: 'Modèles IA chargés',
    loadingModels: 'Chargement des modèles Ollama...',
    exploitationMode: 'Mode d\'exploitation',
    confidenceThreshold: 'Seuil de confiance',
    minConfidenceNote: 'Niveau de confiance minimum pour actions automatiques',
    safeModeNote: 'Le mode Safe évite les exploits destructifs',
    recentDecisions: 'Décisions IA récentes',
    noAiActivity: 'Aucune activité IA',
    decisionsAppearHere: 'Les analyses et décisions IA apparaîtront ici',
    configuration: 'Configuration'
  },

  // License
  license: {
    expiredBadge: 'LICENCE EXPIRÉE',
    revokedBadge: 'LICENCE RÉVOQUÉE',
    cancelledBadge: 'LICENCE ANNULÉE',
    noLicenseBadge: 'AUCUNE LICENCE',
    expiredTitle: 'Votre licence a expiré',
    expiredSubtitle: 'L\'accès à la plateforme est suspendu en attendant le renouvellement.',
    revokedTitle: 'Votre licence a été révoquée',
    revokedSubtitle: 'L\'accès à la plateforme a été suspendu par SYLink Security. Contactez votre responsable de compte.',
    cancelledTitle: 'Votre licence a été annulée',
    cancelledSubtitle: 'Votre abonnement a été annulé. Vos données sont conservées pendant 30 jours.',
    noLicenseTitle: 'Aucune licence active',
    noLicenseSubtitle: 'Activez une licence pour accéder à la plateforme SYLink Pentest.',
    renewAction: 'Renouveler ma licence',
    accessSettings: 'Accéder aux paramètres',
    contactSyLink: 'Contacter SYLink',
    subscribeAction: 'Souscrire à un nouveau plan',
    exportData: 'Exporter mes données',
    activateLicense: 'Activer ma licence',
    licenseInfo: 'Informations de licence',
    reference: 'Référence',
    tier: 'Niveau',
    expiredOn: 'Expiré le',
    holder: 'Titulaire',
    expiry: 'Expiration',
    plan: 'Plan',
    loggedAs: 'Connecté en tant que',
    adminBypass: 'Administrateur - Redirection vers le tableau de bord...',
    contactSupport: 'Contacter le support',
    warningExpired: 'Vos données sont préservées. Renouvelez votre licence pour restaurer l\'accès complet à la plateforme.',
    warningExpiredEmail: 'Un e-mail de rappel a été envoyé à',
    warningRevoked: 'L\'accès a été révoqué suite à une décision administrative. Contactez immédiatement votre responsable de compte SYLink.',
    warningCancelled: 'Votre abonnement a été annulé. Vous avez 30 jours pour exporter vos données avant suppression définitive.',
    warningNoLicense: 'Accédez aux paramètres de votre compte pour saisir votre clé de licence et activer la plateforme.',
    needHelp: 'Besoin d\'aide ?'
  },

  // Accept Invitation
  acceptInvitation: {
    verifying: 'Vérification de l\'invitation...',
    alreadyActivatedTitle: 'Compte déjà activé',
    alreadyActivatedDesc: 'Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter avec votre e-mail et mot de passe.',
    login: 'Se connecter',
    invitationExpiredTitle: 'Invitation expirée',
    invitationInvalidTitle: 'Invitation invalide',
    expiredHint: 'Les invitations sont valables 7 jours. Demandez à votre administrateur de renvoyer une nouvelle invitation.',
    invalidHint: 'Si vous avez reçu plusieurs e-mails d\'invitation, utilisez le lien du dernier e-mail.',
    contactSupport: 'Contacter le support',
    welcomeTitle: 'Bienvenue dans l\'équipe\u00A0!',
    accountActivated: 'Votre compte a été activé avec succès.',
    redirecting: 'Redirection vers le tableau de bord...',
    joinTeamTitle: 'Invitation à rejoindre l\'équipe',
    missingToken: 'Token d\'invitation manquant',
    acceptError: 'Erreur lors de l\'acceptation',
    genericError: 'Une erreur est survenue'
  },

  // Dedicated Server page
  dedicatedServer: {
    pageTitle: 'Serveur dédié - Infrastructure souveraine',
    heroTag: 'Solution souveraine 100% française',
    heroTitle: 'Infrastructure',
    heroTitleHighlight: 'Dédiée',
    heroDesc: 'Une solution de pentest isolée, gérée et supervisée pour votre entreprise. Hébergée en France, sans contraintes des solutions étrangères.',
    statFrench: 'Française',
    statQueue: 'File d\'attente',
    statSupervision: 'Supervision',
    statAvailability: 'Disponibilité',
    whyDedicated: 'Pourquoi choisir l\'infrastructure dédiée\u202F?',
    whyDedicatedDesc: 'Bénéficiez d\'une solution sur-mesure adaptée à vos exigences de sécurité et de performance',
    hostingOptions: 'Options d\'hébergement',
    hostingOptionsDesc: 'Choisissez l\'hébergement qui correspond à vos besoins\u202F: dans notre datacenter souverain ou directement dans votre infrastructure',
    recommended: 'Recommandé',
    aiTitle: 'SYLink IA - Modèles cybersécurité spécialisés',
    aiDesc: 'Déployez notre IA cybersécurité spécialisée directement sur votre infrastructure. Analyse locale, sans envoi de données à l\'extérieur.',
    parameters: 'paramètres',
    poweredBy: 'Propulsé par Ollama',
    localLLM: 'Exécution locale de modèles LLM',
    viewOnOllama: 'Voir sur Ollama',
    ctaTitle: 'Prêt à passer à l\'infrastructure dédiée\u202F?',
    ctaDesc: 'Contactez notre équipe commerciale pour une évaluation personnalisée de vos besoins et un devis sur-mesure.',
    requestQuote: 'Demander un devis',
    viewAllPlans: 'Voir tous les plans',
    trustFrenchTech: 'Technologie française',
    trustFrenchTechDesc: 'Développé en France, sans dépendance aux technologies étrangères',
    trustGDPR: 'Conformité RGPD',
    trustGDPRDesc: 'Hébergement souverain conforme aux réglementations européennes',
    trustProtectedData: 'Données protégées',
    trustProtectedDataDesc: 'Vos données restent en France, protégées du Cloud Act et du FISA',
    adv1Title: 'Isolation Totale',
    adv1Desc: 'Infrastructure dédiée et isolée pour une sécurité maximale. Aucun partage de ressources avec d\'autres clients.',
    adv2Title: 'Performance Garantie',
    adv2Desc: 'Ressources CPU, RAM et stockage dédiées. Scans instantanés sans files d\'attente ni limitations.',
    adv3Title: 'Souveraineté des données',
    adv3Desc: 'Hébergement 100% français, sans contraintes des solutions étrangères (Cloud Act, FISA).',
    adv4Title: 'Supervision 24/7',
    adv4Desc: 'Surveillance continue, alertes en temps réel et intervention proactive de nos équipes.',
    adv5Title: 'Support Dédié',
    adv5Desc: 'Équipe technique dédiée, SLA garanti et accompagnement personnalisé.',
    adv6Title: 'Disponibilité 99,9%',
    adv6Desc: 'Infrastructure redondante avec haute disponibilité et plan de reprise d\'activité.',
    hostingDatacenterTitle: 'France Data Center - Reims',
    hostingDatacenterLoc: 'Reims, France',
    hostingOnPremTitle: 'Sur site',
    hostingOnPremLoc: 'Votre infrastructure',
    ai8bDesc: 'Modèle léger et rapide pour les analyses standard',
    ai8bSpecs: 'GPU : 8 Go VRAM minimum',
    ai8bUseCase: 'Analyses rapides, rapports automatisés',
    ai30bDesc: 'Modèle équilibré pour les analyses approfondies',
    ai30bSpecs: 'GPU : 24 Go VRAM minimum',
    ai30bUseCase: 'Analyses détaillées, corrélations avancées',
    ai80bDesc: 'Modèle expert pour les analyses complexes',
    ai80bSpecs: 'GPU : 80 Go VRAM minimum',
    ai80bUseCase: 'Analyses expertes, recherche de vulnérabilités'
  },

  // Account Reports Config page
  accountReports: {
    configSaved: 'Configuration sauvegardée',
    configSaveError: 'Erreur lors de la sauvegarde de la configuration',
    clientAdded: 'Client ajouté',
    clientAddError: 'Erreur lors de l\'ajout',
    clientDeleted: 'Client supprimé',
    clientDeleteError: 'Erreur lors de la suppression',
    loadError: 'Erreur lors du chargement',
    deleteClientConfirm: 'Supprimer ce client\u202F?',
    unsavedChanges: 'Vous avez des modifications non sauvegardées',
    save: 'Sauvegarder',
    saving: 'Sauvegarde...',
    clientsTitle: 'Clients',
    addClient: 'Ajouter',
    clientName: 'Nom du client *',
    sirenOptional: 'SIREN (optionnel)',
    noClientsConfigured: 'Aucun client configuré',
    reportTypesTitle: 'Types de Rapports',
    reportTypesDesc: 'Personnalisez les types de rapports disponibles pour votre organisation',
    customName: 'Nom personnalisé',
    customDescription: 'Description personnalisée',
    infoNote: 'Ces paramètres sont spécifiques à votre organisation. Les modifications n\'affectent que vos rapports.'
  }
};
